/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddressAddressReadAddressWrite {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressAddressWrite {
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  phone?: string | null;
}

export interface AddressEventLocatorReadShopLocatorRead {
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressEventRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressEventReadAddressReadEventFormatReadIllustrationRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressEventReadEventFormatReadIllustrationRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressPrintingOrderRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
  email?: string | null;
}

export interface AddressShopLocatorRead {
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  fullAddress?: string | null;
  phone?: string | null;
}

export interface AddressShopRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  country?: CountryShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressUserPrivateRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressUserPrivateReadUserTokenRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressUserReadUserPrivateRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  country?: CountryUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldAddressReadAddressWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldAddressWrite {
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  phone?: string | null;
}

export interface AddressJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
  email?: string | null;
}

export interface AddressJsonldShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  fullAddress?: string | null;
  phone?: string | null;
}

export interface AddressJsonldShopRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  fullAddress?: string | null;
  phone?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  country?: CountryJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldUserReadUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  phone?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  country?: CountryJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressValidatedAddressValidatedPostWrite {
  label?: string;
  firstName?: string;
  lastName?: string;
  additionalAddress?: string;
  phone?: string;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
}

export interface AddressValidatedAddressValidatedRead {
  responseId?: string;
  formattedAddress?: string | null;
  entered?: string;
  street?: string;
  zipCode?: string;
  city?: string;
  region?: string;
  latitude?: string;
  longitude?: string;
  countryCode?: string;
  isValid?: boolean;
  fieldWasModify?: boolean;
}

export interface AddressValidatedAddressValidatedValidateWrite {
  entered?: string;
  label?: string;
  zipCode?: string;
  countryCode?: string;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
}

export interface AddressValidatedAddressAddressRead {
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressValidatedAddressJsonldAddressRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  label?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  street?: string;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string;
  region?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  /** @format iri-reference */
  country?: string | null;
  isDefaultBilling?: boolean | null;
  isDefaultShipping?: boolean | null;
  fullAddress?: string | null;
  isEligible?: boolean | null;
  phone?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  countryCode?: string | null;
}

export interface AddressValidatedJsonldAddressValidatedPostWrite {
  label?: string;
  firstName?: string;
  lastName?: string;
  additionalAddress?: string;
  phone?: string;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
}

export interface AddressValidatedJsonldAddressValidatedRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  responseId?: string;
  formattedAddress?: string | null;
  entered?: string;
  street?: string;
  zipCode?: string;
  city?: string;
  region?: string;
  latitude?: string;
  longitude?: string;
  countryCode?: string;
  isValid?: boolean;
  fieldWasModify?: boolean;
}

export interface AddressValidatedJsonldAddressValidatedValidateWrite {
  entered?: string;
  label?: string;
  zipCode?: string;
  countryCode?: string;
  isDefaultBilling?: boolean;
  isDefaultShipping?: boolean;
}

export interface BadgeBadgeRead {
  illustrationPath?: string | null;
  label?: string;
}

export interface BadgeLeagueRead {
  illustrationPath?: string | null;
  label?: string;
}

export interface BadgeSeasonPassRead {
  illustrationPath?: string | null;
  label?: string;
}

export interface BadgeJsonldBadgeRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  illustrationPath?: string | null;
  label?: string;
}

export interface BadgeJsonldLeagueRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  illustrationPath?: string | null;
  label?: string;
}

export interface BadgeJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  illustrationPath?: string | null;
  label?: string;
}

export interface BankAccountBankAccountRead {
  id?: string;
  IBAN?: string;
  BIC?: string;
  ownerName?: string;
}

export interface BankAccountBankAccountWrite {
  IBAN?: string;
  BIC?: string;
  accountNumber?: string;
  sortCode?: string;
  institutionNumber?: string;
  branchCode?: string;
  bankName?: string;
  ABA?: string;
  ownerLastName?: string;
  ownerFirstName?: string;
  /** @format iri-reference */
  address?: string;
  type?: 'IBAN' | 'CA' | 'US' | 'GB' | 'OTHER';
}

export interface BankAccountPaymentDetailPayoutRead {
  ownerName?: string;
  bankAccountResume?: string;
}

export interface BankAccountJsonldBankAccountRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string;
  IBAN?: string;
  BIC?: string;
  ownerName?: string;
}

export interface BankAccountJsonldBankAccountWrite {
  IBAN?: string;
  BIC?: string;
  accountNumber?: string;
  sortCode?: string;
  institutionNumber?: string;
  branchCode?: string;
  bankName?: string;
  ABA?: string;
  ownerLastName?: string;
  ownerFirstName?: string;
  /** @format iri-reference */
  address?: string;
  type?: 'IBAN' | 'CA' | 'US' | 'GB' | 'OTHER';
}

export interface BankAccountJsonldPaymentDetailPayoutRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  ownerName?: string;
  bankAccountResume?: string;
}

export interface CardCardDetailRead {
  loreEntries?: LoreEntryCardDetailRead[];
  cardType: CardTypeCardDetailRead | null;
  cardSubTypes?: CardSubTypeCardDetailRead[];
  cardSet: CardSetCardDetailRead | null;
  rarity: RarityCardDetailRead | null;
  cardCycle?: CardCycleCardDetailRead | null;
  cardRulings?: CardRulingCardDetailRead[];
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  lowerPrice?: number;
  qrUrlDetail?: string | null;
  isSuspended?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionCardDetailRead | null;
  allImagePath?: Record<string, string>;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardCardRead {
  cardType: CardTypeCardRead | null;
  rarity: RarityCardRead | null;
  cardProduct: CardProductCardRead | null;
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  qrUrlDetail?: string | null;
  isSuspended?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionCardRead | null;
  name?: string;
  elements?: Record<string, string>;
  collectorNumberFormatted?: string | null;
}

export interface CardCardStatRead {
  inMyTradelist?: number;
  inMyCollection?: number;
  inMyWantlist?: boolean;
  foiled?: boolean;
  lowerPrice?: number;
  lowerOfferId?: string;
  inSale?: number;
  inMySale?: number;
  numberCopyAvailable?: number;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface CardCardVariant {
  rarity: RarityCardVariant | null;
  imagePath?: string | null;
  inMyCollection?: number;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardDeckUserListRead {
  cardType: CardTypeDeckUserListRead | null;
  rarity: RarityDeckUserListRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  numberCopyAvailable?: number;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  /** Used for Deckbuilder Legality. */
  familyReference?: string;
  mainFaction?: FactionDeckUserListRead | null;
  name?: string;
  /** Used for getting Siblings. */
  siblingReference?: string;
}

export interface CardDeckUserListReadDeckUserListDetailRead {
  cardType: CardTypeDeckUserListReadDeckUserListDetailRead | null;
  rarity: RarityDeckUserListReadDeckUserListDetailRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  numberCopyAvailable?: number;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  /** Used for Deckbuilder Legality. */
  familyReference?: string;
  mainFaction?: FactionDeckUserListReadDeckUserListDetailRead | null;
  name?: string;
  elements?: Record<string, string>;
  /** Used for getting Siblings. */
  siblingReference?: string;
}

export interface CardOwnerClaimMultiRead {
  /** @format iri-reference */
  cardType: string | null;
  rarity: RarityOwnerClaimMultiRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionOwnerClaimMultiRead | null;
  name?: string;
  collectorNumberFormatted?: string | null;
}

export interface CardOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface CardOwnerHistoryGroupRead {
  rarity: RarityOwnerHistoryGroupRead | null;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardOwnershipRead {
  imagePath?: string | null;
  inMyCollection?: number;
  inMyWantlist?: boolean;
  loreEntryElements?: Record<string, string>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardOwnershipListRead {
  imagePath?: string | null;
  inMyCollection?: number;
  inMySale?: number;
  numberCopyAvailable?: number;
  quantity?: number | null;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardPaymentDetailRead {
  imagePath?: string | null;
  name?: string;
}

export interface CardPrintingOrderRead {
  cardType: CardTypePrintingOrderRead | null;
  rarity: RarityPrintingOrderRead | null;
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  mainFaction?: FactionPrintingOrderRead | null;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardPrintingOrderPartnerRead {
  /** @format iri-reference */
  rarity: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardPrintingPageReadPrintingOrderPartnerRead {
  /** @format iri-reference */
  rarity: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  cardType: CardTypePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  rarity: RarityPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  imagePath?: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  mainFaction?: FactionPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardSeasonPassRead {
  rarity: RaritySeasonPassRead | null;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardCardHistoryDataCardHistoryRead {
  news?: CardHistoryCardHistoryRead | null;
  cardHistories?: CardHistoryCardHistoryRead[] | null;
}

export interface CardCardHistoryDataJsonldCardHistoryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  news?: CardHistoryJsonldCardHistoryRead | null;
  cardHistories?: CardHistoryJsonldCardHistoryRead[] | null;
}

export interface CardJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  loreEntries?: LoreEntryJsonldCardDetailRead[];
  cardType: CardTypeJsonldCardDetailRead | null;
  cardSubTypes?: CardSubTypeJsonldCardDetailRead[];
  cardSet: CardSetJsonldCardDetailRead | null;
  rarity: RarityJsonldCardDetailRead | null;
  cardCycle?: CardCycleJsonldCardDetailRead | null;
  cardRulings?: CardRulingJsonldCardDetailRead[];
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  lowerPrice?: number;
  qrUrlDetail?: string | null;
  isSuspended?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionJsonldCardDetailRead | null;
  allImagePath?: Record<string, string>;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardJsonldCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldCardRead | null;
  rarity: RarityJsonldCardRead | null;
  cardProduct: CardProductJsonldCardRead | null;
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  qrUrlDetail?: string | null;
  isSuspended?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionJsonldCardRead | null;
  name?: string;
  elements?: Record<string, string>;
  collectorNumberFormatted?: string | null;
}

export interface CardJsonldCardStatRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  inMyTradelist?: number;
  inMyCollection?: number;
  inMyWantlist?: boolean;
  foiled?: boolean;
  lowerPrice?: number;
  lowerOfferId?: string;
  inSale?: number;
  inMySale?: number;
  numberCopyAvailable?: number;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface CardJsonldCardVariant {
  '@id'?: string;
  '@type'?: string;
  rarity: RarityJsonldCardVariant | null;
  imagePath?: string | null;
  inMyCollection?: number;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldDeckUserListRead | null;
  rarity: RarityJsonldDeckUserListRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  numberCopyAvailable?: number;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  /** Used for Deckbuilder Legality. */
  familyReference?: string;
  mainFaction?: FactionJsonldDeckUserListRead | null;
  name?: string;
  /** Used for getting Siblings. */
  siblingReference?: string;
}

export interface CardJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldDeckUserListReadDeckUserListDetailRead | null;
  rarity: RarityJsonldDeckUserListReadDeckUserListDetailRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  numberCopyAvailable?: number;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  /** Used for Deckbuilder Legality. */
  familyReference?: string;
  mainFaction?: FactionJsonldDeckUserListReadDeckUserListDetailRead | null;
  name?: string;
  elements?: Record<string, string>;
  /** Used for getting Siblings. */
  siblingReference?: string;
}

export interface CardJsonldOwnerClaimMultiRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  cardType: string | null;
  rarity: RarityJsonldOwnerClaimMultiRead | null;
  imagePath?: string | null;
  inMyCollection?: number;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  mainFaction?: FactionJsonldOwnerClaimMultiRead | null;
  name?: string;
  collectorNumberFormatted?: string | null;
}

export interface CardJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface CardJsonldOwnerHistoryGroupRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  rarity: RarityJsonldOwnerHistoryGroupRead | null;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardJsonldOwnershipRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  imagePath?: string | null;
  inMyCollection?: number;
  inMyWantlist?: boolean;
  loreEntryElements?: Record<string, string>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardJsonldOwnershipListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  imagePath?: string | null;
  inMyCollection?: number;
  inMySale?: number;
  numberCopyAvailable?: number;
  quantity?: number | null;
  isSuspended?: boolean;
  isExclusive?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardJsonldPaymentDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  imagePath?: string | null;
  name?: string;
}

export interface CardJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldPrintingOrderRead | null;
  rarity: RarityJsonldPrintingOrderRead | null;
  imagePath?: string | null;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  mainFaction?: FactionJsonldPrintingOrderRead | null;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  rarity: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  rarity: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  rarity: RarityJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  imagePath?: string | null;
  imagePathPartner?: string | null;
  imagePDFPartner?: string | null;
  assets?: Record<string, string | string[]>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  mainFaction?: FactionJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  name?: string;
  elements?: Record<string, string>;
}

export interface CardJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  rarity: RarityJsonldSeasonPassRead | null;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export type CardCycleCardDetailRead = object;

export interface CardCycleJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export type CardEffectDisplayCardElementRead = object;

export interface CardEffectDisplayJsonldCardElementRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface CardElementCardElementRead {
  /** @format iri-reference */
  cardElementType?: string | null;
  /** @format iri-reference */
  card?: string | null;
  cardEffectDisplays?: CardEffectDisplayCardElementRead[];
  value?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface CardElementJsonldCardElementRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  cardElementType?: string | null;
  /** @format iri-reference */
  card?: string | null;
  cardEffectDisplays?: CardEffectDisplayJsonldCardElementRead[];
  value?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface CardElementTypeCardElementTypeRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'MAIN_COST'
    | 'RECALL_COST'
    | 'OCEAN_POWER'
    | 'MOUNTAIN_POWER'
    | 'FOREST_POWER'
    | 'MAIN_EFFECT'
    | 'ECHO_EFFECT'
    | 'RESERVE'
    | 'PERMANENT';
  sequence?: number | null;
  /** @format iri-reference */
  cardType?: string | null;
  icon?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  name?: string | null;
}

export interface CardElementTypeJsonldCardElementTypeRead {
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'MAIN_COST'
    | 'RECALL_COST'
    | 'OCEAN_POWER'
    | 'MOUNTAIN_POWER'
    | 'FOREST_POWER'
    | 'MAIN_EFFECT'
    | 'ECHO_EFFECT'
    | 'RESERVE'
    | 'PERMANENT';
  sequence?: number | null;
  /** @format iri-reference */
  cardType?: string | null;
  icon?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  name?: string | null;
}

export interface CardFilterDataCardFilterData {
  factions?: string[];
  cardType?: string[];
  cardSet?: string[];
  cardSubTypes?: string[];
  mainCost?: string[];
  recallCost?: string[];
  oceanPower?: string[];
  mountainPower?: string[];
  forestPower?: string[];
  rarity?: string[];
  keyword?: string[];
  artist?: string[];
}

export interface CardFilterDataJsonldCardFilterData {
  '@id'?: string;
  '@type'?: string;
  factions?: string[];
  cardType?: string[];
  cardSet?: string[];
  cardSubTypes?: string[];
  mainCost?: string[];
  recallCost?: string[];
  oceanPower?: string[];
  mountainPower?: string[];
  forestPower?: string[];
  rarity?: string[];
  keyword?: string[];
  artist?: string[];
}

export type CardGoogleSheetCardSetRead = object;

export interface CardGoogleSheetJsonldCardSetRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface CardHistoryCardHistoryRead {
  id?: string;
  /** @format date-time */
  fromDate?: string;
  type?: 'ERRATUM' | 'SUSPENDED' | 'RULING' | 'UNSUSPENDED';
  name?: string | null;
  description?: string | null;
  answer?: string | null;
  question?: string | null;
}

export interface CardHistoryJsonldCardHistoryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string;
  /** @format date-time */
  fromDate?: string;
  type?: 'ERRATUM' | 'SUSPENDED' | 'RULING' | 'UNSUSPENDED';
  name?: string | null;
  description?: string | null;
  answer?: string | null;
  question?: string | null;
}

export interface CardManufactureCardManufactureRead {
  cardType: CardTypeManufactureRead | null;
  rarity: RarityManufactureRead | null;
  qrCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  translations?: Record<string, CardTranslationManufactureRead>;
  mainFaction?: FactionManufactureRead | null;
  name?: string;
  collectorNumberFormatted?: string | null;
}

export interface CardManufactureCardJsonldManufactureRead {
  '@id'?: string;
  '@type'?: string;
  cardType: CardTypeJsonldManufactureRead | null;
  rarity: RarityJsonldManufactureRead | null;
  qrCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  translations?: Record<string, CardTranslationJsonldManufactureRead>;
  mainFaction?: FactionJsonldManufactureRead | null;
  name?: string;
  collectorNumberFormatted?: string | null;
}

export interface CardProductCardRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'B';
  name?: string | null;
}

export interface CardProductCardProductRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'B';
  name?: string | null;
}

export interface CardProductJsonldCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'B';
  name?: string | null;
}

export interface CardProductJsonldCardProductRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'B';
  name?: string | null;
}

export type CardRegistrationPaymentCardPostWrite = object;

export type CardRegistrationPaymentCardPutWrite = object;

export interface CardRegistrationPaymentPaymentCardRead {
  id?: string;
  preRegistrationData?: string;
  accessKey?: string;
  cardRegistrationURL?: string;
}

export interface CardRegistrationPaymentCardPaymentPaymentCardRead {
  externalId?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  active?: boolean;
  validity?: string | null;
  cardProvider?: string | null;
  number?: string;
  /** @format iri-reference */
  user?: string | null;
}

export interface CardRegistrationPaymentCardJsonldPaymentPaymentCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  externalId?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  active?: boolean;
  validity?: string | null;
  cardProvider?: string | null;
  number?: string;
  /** @format iri-reference */
  user?: string | null;
}

export type CardRegistrationJsonldPaymentCardPostWrite = object;

export type CardRegistrationJsonldPaymentCardPutWrite = object;

export interface CardRegistrationJsonldPaymentPaymentCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string;
  preRegistrationData?: string;
  accessKey?: string;
  cardRegistrationURL?: string;
}

export interface CardRulingCardDetailRead {
  eventFormat?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  question?: string;
  answer?: string;
}

export interface CardRulingJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  eventFormat?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  question?: string;
  answer?: string;
}

export interface CardSetCardDetailRead {
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardSetCardSetRead {
  /** @format date-time */
  date?: string | null;
  code?: string | null;
  isActive?: boolean | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  cardGoogleSheets?: CardGoogleSheetCardSetRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface CardSetCardSetDataCardSetCollectionRead {
  cardSets?: PaginatorCardSetCollectionRead;
  cardInCollection?: number;
  averageValue?: number;
}

export interface CardSetCardSetDataJsonldCardSetCollectionRead {
  '@id'?: string;
  '@type'?: string;
  cardSets?: PaginatorJsonldCardSetCollectionRead;
  cardInCollection?: number;
  averageValue?: number;
}

export interface CardSetJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
}

export interface CardSetJsonldCardSetRead {
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  date?: string | null;
  code?: string | null;
  isActive?: boolean | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  cardGoogleSheets?: CardGoogleSheetJsonldCardSetRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface CardSubTypeCardDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardSubTypeJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: string;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTranslationManufactureRead {
  image?: string | null;
  imagePdf?: string | null;
}

export interface CardTranslationJsonldManufactureRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  image?: string | null;
  imagePdf?: string | null;
}

export interface CardTypeCardDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeCardRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeCardTypeRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  tags?: string[];
  /** @format ulid */
  id?: string | null;
  name?: string;
  description?: string;
}

export interface CardTypeDeckUserListRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeDeckUserListReadDeckUserListDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeManufactureRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
}

export interface CardTypePrintingOrderRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  name?: string;
}

export interface CardTypePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  name?: string;
}

export interface CardTypeJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeJsonldCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeJsonldCardTypeRead {
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  tags?: string[];
  /** @format ulid */
  id?: string | null;
  name?: string;
  description?: string;
}

export interface CardTypeJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface CardTypeJsonldManufactureRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
}

export interface CardTypeJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  name?: string;
}

export interface CardTypeJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference:
    | 'TOKEN'
    | 'HERO'
    | 'CHARACTER'
    | 'SPELL'
    | 'PERMANENT'
    | 'FOILER'
    | 'TOKEN_MANA'
    | 'LANDMARK_PERMANENT'
    | 'EXPEDITION_PERMANENT'
    | 'TOKEN_LANDMARK_PERMANENT';
  name?: string;
}

export interface CardUserListCardUserListRead {
  name?: string;
  cardQuantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface CardUserListJsonldCardUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  cardQuantity?: number;
  /** @format ulid */
  id?: string | null;
}

export type CardUserListCardCardUserListRead = object;

export interface CardUserListCardCardUserListCardRead {
  /** @format iri-reference */
  card?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface CardUserListCardPostCardsUserListCardDataPostCardsUserListCardDataWrite {
  name: string;
  cards: string[];
}

export interface CardUserListCardPostCardsUserListCardDataJsonldPostCardsUserListCardDataWrite {
  name: string;
  cards: string[];
}

export interface CardUserListCardJsonldCardUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface CardUserListCardJsonldCardUserListCardRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /** @format iri-reference */
  card?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ContactContactRead {
  name: string;
  email: string;
  reason: string;
  otherReason?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ContactContactWrite {
  name: string;
  email: string;
  reason: string;
  otherReason?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /** @format iri-reference */
  user?: string | null;
}

export interface ContactJsonldContactRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name: string;
  email: string;
  reason: string;
  otherReason?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ContactJsonldContactWrite {
  name: string;
  email: string;
  reason: string;
  otherReason?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /** @format iri-reference */
  user?: string | null;
}

export interface CountryCountryRead {
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CountryShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CountryUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CountryJsonldCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CountryJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CountryJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  flagPath?: string;
  latitude?: number | null;
  longitude?: number | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface CurrencyPaymentCurrencyRead {
  code?: string | null;
  name?: string | null;
}

export interface CurrencyJsonldPaymentCurrencyRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  code?: string | null;
  name?: string | null;
}

export interface DeckCardDeckUserListReadDeckUserListDetailRead {
  character?: DeckCardsDeckUserListReadDeckUserListDetailRead | null;
  spell?: DeckCardsDeckUserListReadDeckUserListDetailRead | null;
  permanent?: DeckCardsDeckUserListReadDeckUserListDetailRead | null;
}

export interface DeckCardJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  character?: DeckCardsJsonldDeckUserListReadDeckUserListDetailRead | null;
  spell?: DeckCardsJsonldDeckUserListReadDeckUserListDetailRead | null;
  permanent?: DeckCardsJsonldDeckUserListReadDeckUserListDetailRead | null;
}

export interface DeckCardsDeckUserListReadDeckUserListDetailRead {
  deckUserListCard?: DeckUserListCardDeckUserListReadDeckUserListDetailRead[];
  number?: number;
}

export interface DeckCardsJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  deckUserListCard?: DeckUserListCardJsonldDeckUserListReadDeckUserListDetailRead[];
  number?: number;
}

export interface DeckLegalityDeckUserListRead {
  resume?: {
    errorFamily?: Record<string, any[]>;
    globalValidity?: boolean;
    isOwned?: boolean;
    isSameFaction?: boolean;
    nbCards?: boolean;
    nbHero?: boolean;
    nbRare?: boolean;
    nbUnique?: boolean;
    nbFamily?: boolean;
    isSuspended?: boolean;
  };
}

export interface DeckLegalityDeckUserListReadDeckUserListDetailRead {
  resume?: {
    errorFamily?: Record<string, any[]>;
    globalValidity?: boolean;
    isOwned?: boolean;
    isSameFaction?: boolean;
    nbCards?: boolean;
    nbHero?: boolean;
    nbRare?: boolean;
    nbUnique?: boolean;
    nbFamily?: boolean;
    isSuspended?: boolean;
  };
}

export interface DeckLegalityJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  resume?: {
    errorFamily?: Record<string, any[]>;
    globalValidity?: boolean;
    isOwned?: boolean;
    isSameFaction?: boolean;
    nbCards?: boolean;
    nbHero?: boolean;
    nbRare?: boolean;
    nbUnique?: boolean;
    nbFamily?: boolean;
    isSuspended?: boolean;
  };
}

export interface DeckLegalityJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  resume?: {
    errorFamily?: Record<string, any[]>;
    globalValidity?: boolean;
    isOwned?: boolean;
    isSameFaction?: boolean;
    nbCards?: boolean;
    nbHero?: boolean;
    nbRare?: boolean;
    nbUnique?: boolean;
    nbFamily?: boolean;
    isSuspended?: boolean;
  };
}

export interface DeckUserListDeckUserListPut {
  name?: string;
  /** @format iri-reference */
  alterator?: string | null;
  public?: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface DeckUserListDeckUserListRead {
  name?: string;
  user?: UserDeckUserListRead | null;
  faction?: FactionDeckUserListRead | null;
  alterator?: CardDeckUserListRead | null;
  eventFormat?: string;
  public?: boolean;
  cardQuantity?: number;
  deckLegality?: DeckLegalityDeckUserListRead | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  legal?: boolean;
}

export interface DeckUserListDeckUserListReadDeckUserListDetailRead {
  name?: string;
  user?: UserDeckUserListReadDeckUserListDetailRead | null;
  faction?: FactionDeckUserListReadDeckUserListDetailRead | null;
  alterator?: CardDeckUserListReadDeckUserListDetailRead | null;
  eventFormat?: string;
  public?: boolean;
  cardQuantity?: number;
  deckLegality?: DeckLegalityDeckUserListReadDeckUserListDetailRead | null;
  deckCardsByType?: DeckCardDeckUserListReadDeckUserListDetailRead | null;
  cardsByRarityData?: string[];
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  legal?: boolean;
  cardIndexes?: Record<string, string>;
}

export interface DeckUserListDeckUserListWrite {
  name?: string;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  faction?: string | null;
  /** @format iri-reference */
  alterator?: string | null;
  public?: boolean;
  deckUserListCards?: DeckUserListCardDeckUserListWrite[];
  tags?: string[];
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface DeckUserListEventLocatorReadShopLocatorRead {
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListEventRead {
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListEventReadAddressReadEventFormatReadIllustrationRead {
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListEventReadEventFormatReadIllustrationRead {
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListDeckAddCardDataDeckAddCardDataWrite {
  cards?: DeckUserListCardDeckAddCardDataWrite[];
  putOption?: string | null;
}

export interface DeckUserListDeckAddCardDataJsonldDeckAddCardDataWrite {
  cards?: DeckUserListCardJsonldDeckAddCardDataWrite[];
  putOption?: string | null;
}

export interface DeckUserListDeckMultiScanDeckUserListRead {
  id?: string | null;
  successes?: CardDeckUserListRead[] | null;
  fails?: CardDeckUserListRead[] | null;
}

export interface DeckUserListDeckMultiScanJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string | null;
  successes?: CardJsonldDeckUserListRead[] | null;
  fails?: CardJsonldDeckUserListRead[] | null;
}

export interface DeckUserListDeckStatisticsDataDeckUserListReadDeckUserListData {
  costInvocation?: string[][];
  costRecall?: string[][];
  cardsByTypeData?: string[][];
  attributesData?: string[][];
  cardsByRarityData?: string[][];
  cardsOwned?: number;
  cardsQuantity?: number;
}

export interface DeckUserListDeckStatisticsDataJsonldDeckUserListReadDeckUserListData {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  costInvocation?: string[][];
  costRecall?: string[][];
  cardsByTypeData?: string[][];
  attributesData?: string[][];
  cardsByRarityData?: string[][];
  cardsOwned?: number;
  cardsQuantity?: number;
}

export interface DeckUserListJsonldDeckUserListPut {
  name?: string;
  /** @format iri-reference */
  alterator?: string | null;
  public?: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface DeckUserListJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  user?: UserJsonldDeckUserListRead | null;
  faction?: FactionJsonldDeckUserListRead | null;
  alterator?: CardJsonldDeckUserListRead | null;
  eventFormat?: string;
  public?: boolean;
  cardQuantity?: number;
  deckLegality?: DeckLegalityJsonldDeckUserListRead | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  legal?: boolean;
}

export interface DeckUserListJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  user?: UserJsonldDeckUserListReadDeckUserListDetailRead | null;
  faction?: FactionJsonldDeckUserListReadDeckUserListDetailRead | null;
  alterator?: CardJsonldDeckUserListReadDeckUserListDetailRead | null;
  eventFormat?: string;
  public?: boolean;
  cardQuantity?: number;
  deckLegality?: DeckLegalityJsonldDeckUserListReadDeckUserListDetailRead | null;
  deckCardsByType?: DeckCardJsonldDeckUserListReadDeckUserListDetailRead | null;
  cardsByRarityData?: string[];
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  legal?: boolean;
  cardIndexes?: Record<string, string>;
}

export interface DeckUserListJsonldDeckUserListWrite {
  name?: string;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  faction?: string | null;
  /** @format iri-reference */
  alterator?: string | null;
  public?: boolean;
  deckUserListCards?: DeckUserListCardJsonldDeckUserListWrite[];
  tags?: string[];
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface DeckUserListJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListCardDeckAddCardDataWrite {
  quantity: number;
  /** @format iri-reference */
  card: string | null;
}

export interface DeckUserListCardDeckUserListReadDeckUserListDetailRead {
  quantity: number;
  card: CardDeckUserListReadDeckUserListDetailRead | null;
  /** @format ulid */
  id?: string | null;
}

export type DeckUserListCardDeckUserListWrite = object;

export interface DeckUserListCardOwnershipListRead {
  quantity: number;
  card: CardOwnershipListRead | null;
}

export interface DeckUserListCardOwnershipListWrite {
  quantity: number;
  /** @format iri-reference */
  card: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListCardJsonldDeckAddCardDataWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity: number;
  /** @format iri-reference */
  card: string | null;
}

export interface DeckUserListCardJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity: number;
  card: CardJsonldDeckUserListReadDeckUserListDetailRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface DeckUserListCardJsonldDeckUserListWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface DeckUserListCardJsonldOwnershipListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity: number;
  card: CardJsonldOwnershipListRead | null;
}

export interface DeckUserListCardJsonldOwnershipListWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity: number;
  /** @format iri-reference */
  card: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface EmbeddableAddress {
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressPrintingOrderPartnerRead {
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressPrintingPageReadPrintingOrderPartnerRead {
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EmbeddableAddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  firstName?: string | null;
  lastName?: string | null;
  street?: string | null;
  additionalAddress?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  countryCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface EventEventLocatorReadShopLocatorRead {
  deckIsMandatory?: boolean | null;
  address?: AddressEventLocatorReadShopLocatorRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  image?: MediaEventLocatorReadShopLocatorRead | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserEventLocatorReadShopLocatorRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserEventLocatorReadShopLocatorRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeEventLocatorReadShopLocatorRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventEventRead {
  deckIsMandatory?: boolean | null;
  address?: AddressEventRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserEventRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserEventRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeEventRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format iri-reference */
  winningFaction?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventEventReadAddressReadEventFormatReadIllustrationRead {
  deckIsMandatory?: boolean | null;
  address?: AddressEventReadAddressReadEventFormatReadIllustrationRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  illustration?: IllustrationEventReadAddressReadEventFormatReadIllustrationRead | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserEventReadAddressReadEventFormatReadIllustrationRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserEventReadAddressReadEventFormatReadIllustrationRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeEventReadAddressReadEventFormatReadIllustrationRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  winningFaction?: FactionEventReadAddressReadEventFormatReadIllustrationRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventEventReadEventFormatReadIllustrationRead {
  deckIsMandatory?: boolean | null;
  address?: AddressEventReadEventFormatReadIllustrationRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  illustration?: IllustrationEventReadEventFormatReadIllustrationRead | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserEventReadEventFormatReadIllustrationRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserEventReadEventFormatReadIllustrationRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeEventReadEventFormatReadIllustrationRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  winningFaction?: FactionEventReadEventFormatReadIllustrationRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventEventWrite {
  deckIsMandatory?: boolean | null;
  /** @format iri-reference */
  address?: string | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  image?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  /** @format iri-reference */
  organizer?: string | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  isRecurrent?: boolean;
  informPreRegistrants?: boolean;
  /** @format iri-reference */
  eventType?: string | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format iri-reference */
  winningFaction?: string | null;
  name?: string;
  translationEvents?: string[];
  description?: string | null;
}

export interface EventGameRead {
  name?: string;
}

export interface EventShopRead {
  image?: MediaShopRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  image?: MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  image?: MediaUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventEventLocatorEventLocatorReadShopLocatorRead {
  events?: EventEventLocatorReadShopLocatorRead[];
  shops?: ShopEventLocatorReadShopLocatorRead[];
}

export interface EventEventLocatorJsonldEventLocatorReadShopLocatorRead {
  '@id'?: string;
  '@type'?: string;
  events?: EventJsonldEventLocatorReadShopLocatorRead[];
  shops?: ShopJsonldEventLocatorReadShopLocatorRead[];
}

export interface EventEventRankingEventRankingRead {
  nickName?: string | null;
  avatar?: string | null;
  factions?: FactionEventRankingRead[];
  win?: number;
  lose?: number;
}

export interface EventEventRankingJsonldEventRankingRead {
  '@id'?: string;
  '@type'?: string;
  nickName?: string | null;
  avatar?: string | null;
  factions?: FactionJsonldEventRankingRead[];
  win?: number;
  lose?: number;
}

export interface EventJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  deckIsMandatory?: boolean | null;
  address?: AddressJsonldEventLocatorReadShopLocatorRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  image?: MediaJsonldEventLocatorReadShopLocatorRead | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserJsonldEventLocatorReadShopLocatorRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserJsonldEventLocatorReadShopLocatorRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeJsonldEventLocatorReadShopLocatorRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  deckIsMandatory?: boolean | null;
  address?: AddressJsonldEventRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  illustration?: string | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserJsonldEventRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserJsonldEventRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeJsonldEventRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format iri-reference */
  winningFaction?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@id'?: string;
  '@type'?: string;
  deckIsMandatory?: boolean | null;
  address?: AddressJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  illustration?: IllustrationJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  winningFaction?: FactionJsonldEventReadAddressReadEventFormatReadIllustrationRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventJsonldEventReadEventFormatReadIllustrationRead {
  '@id'?: string;
  '@type'?: string;
  deckIsMandatory?: boolean | null;
  address?: AddressJsonldEventReadEventFormatReadIllustrationRead | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  illustration?: IllustrationJsonldEventReadEventFormatReadIllustrationRead | null;
  illustrationPath?: string | null;
  /** @format iri-reference */
  image?: string | null;
  imagePath?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  organizer?: UserJsonldEventReadEventFormatReadIllustrationRead | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  eventUser?: EventUserJsonldEventReadEventFormatReadIllustrationRead | null;
  isRecurrent?: boolean;
  eventType?: EventTypeJsonldEventReadEventFormatReadIllustrationRead | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  winningFaction?: FactionJsonldEventReadEventFormatReadIllustrationRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  distance?: number;
  name?: string;
  description?: string | null;
}

export interface EventJsonldEventWrite {
  deckIsMandatory?: boolean | null;
  /** @format iri-reference */
  address?: string | null;
  useShopAddress?: boolean | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /** @format iri-reference */
  image?: string | null;
  isFree?: boolean | null;
  isComplete?: boolean | null;
  ticketingLink?: string | null;
  placeNumber?: number | null;
  /** @format iri-reference */
  organizer?: string | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  /** @format date-time */
  startDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  isRecurrent?: boolean;
  informPreRegistrants?: boolean;
  /** @format iri-reference */
  eventType?: string | null;
  eventFormat?: 'STANDARD' | 'SEALED' | 'DRAFT' | 'OTHER' | null;
  gameFormat?: '1V1' | '2V2';
  /** @format iri-reference */
  winningFaction?: string | null;
  name?: string;
  translationEvents?: string[];
  description?: string | null;
}

export interface EventJsonldGameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
}

export interface EventJsonldShopRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  image?: MediaJsonldShopRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  image?: MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  image?: MediaJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  placeNumber?: number | null;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETE' | 'FINISHED' | 'CANCELED' | null;
  mobilityReducedAccessibility?: boolean | null;
  name?: string;
  description?: string | null;
}

export interface EventTypeEventLocatorReadShopLocatorRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeEventRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeEventReadAddressReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeEventReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeEventTypeRead {
  /**
   * @default true
   * @example true
   */
  isNew?: boolean;
  eventFormats?: string[] | null;
  gameFormats?: string[] | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeShopEventTypeEventTypeRead {
  eventType?: EventTypeEventTypeRead;
  isPossible?: boolean;
}

export interface EventTypeShopEventTypeJsonldEventTypeRead {
  '@id'?: string;
  '@type'?: string;
  eventType?: EventTypeJsonldEventTypeRead;
  isPossible?: boolean;
}

export interface EventTypeJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventTypeJsonldEventTypeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default true
   * @example true
   */
  isNew?: boolean;
  eventFormats?: string[] | null;
  gameFormats?: string[] | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface EventUserEventLocatorReadShopLocatorRead {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListEventLocatorReadShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserEventRead {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListEventRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserEventReadAddressReadEventFormatReadIllustrationRead {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserEventReadEventFormatReadIllustrationRead {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListEventReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserEventUserRead {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  user: UserEventUserRead | null;
  /** @format iri-reference */
  event: string | null;
  deckUserLists?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface EventUserEventUserUpdate {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: string[];
}

export interface EventUserEventUserWrite {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  event: string | null;
  deckUserLists?: string[];
}

export interface EventUserJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListJsonldEventLocatorReadShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListJsonldEventRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListJsonldEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: DeckUserListJsonldEventReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
}

export interface EventUserJsonldEventUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  user: UserJsonldEventUserRead | null;
  /** @format iri-reference */
  event: string | null;
  deckUserLists?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface EventUserJsonldEventUserUpdate {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  deckUserLists?: string[];
}

export interface EventUserJsonldEventUserWrite {
  status?: 'PRE_REGISTERED' | 'VALIDATED' | 'ABSENT' | 'ABANDONED';
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  event: string | null;
  deckUserLists?: string[];
}

export interface FactionCardDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionCardRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionDeckUserListRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionDeckUserListReadDeckUserListDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionEventReadAddressReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionEventReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionEventRankingRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionFactionRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
  description?: string | null;
}

export interface FactionGameRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  name?: string;
}

export interface FactionIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionManufactureRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
}

export interface FactionOwnerClaimMultiRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionPrintingOrderRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
}

export interface FactionPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
}

export interface FactionSeasonPassUserRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  name?: string;
}

export interface FactionJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldEventRankingRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldFactionRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
  description?: string | null;
}

export interface FactionJsonldGameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  name?: string;
}

export interface FactionJsonldIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldManufactureRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
}

export interface FactionJsonldOwnerClaimMultiRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  /** @format ulid */
  id?: string | null;
  name?: string;
}

export interface FactionJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
}

export interface FactionJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
}

export interface FactionJsonldSeasonPassUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'YZ' | 'MU' | 'OR' | 'AX' | 'LY' | 'BR';
  color?: string | null;
  name?: string;
}

export interface FactionPlayedUserGameStatsRead {
  timesPlayed?: number;
  name?: string;
  reference?: string;
}

export interface FactionPlayedJsonldUserGameStatsRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  timesPlayed?: number;
  name?: string;
  reference?: string;
}

export interface GameGameRead {
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  event?: EventGameRead | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: GameUserGameRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface GameGameWrite {
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  /** @format iri-reference */
  event?: string | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: string[];
}

export interface GameGameWriteGameUserWrite {
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  /** @format iri-reference */
  event?: string | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: GameUserGameWriteGameUserWrite[];
}

export interface GameJsonldGameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  event?: EventJsonldGameRead | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: GameUserJsonldGameRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface GameJsonldGameWrite {
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  /** @format iri-reference */
  event?: string | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: string[];
}

export interface GameJsonldGameWriteGameUserWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  eventFormat?: string | null;
  /** @format date-time */
  dateTime?: string | null;
  durationMin: number | null;
  /** @format iri-reference */
  event?: string | null;
  /** @format iri-reference */
  cardSet: string | null;
  gameUsers?: GameUserJsonldGameWriteGameUserWrite[];
}

export interface GameUserGameRead {
  winner: boolean;
  faction: FactionGameRead | null;
  user?: UserGameRead | null;
}

export interface GameUserGameWriteGameUserWrite {
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  game: GameGameWriteGameUserWrite | null;
}

export interface GameUserGameUserRead {
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  game: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface GameUserGameUserWrite {
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  game: string | null;
}

export interface GameUserJsonldGameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  winner: boolean;
  faction: FactionJsonldGameRead | null;
  user?: UserJsonldGameRead | null;
}

export interface GameUserJsonldGameWriteGameUserWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  game: GameJsonldGameWriteGameUserWrite | null;
}

export interface GameUserJsonldGameUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  game: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface GameUserJsonldGameUserWrite {
  winner: boolean;
  notation: number;
  /** @format iri-reference */
  faction: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  game: string | null;
}

export interface IllustrationEventReadAddressReadEventFormatReadIllustrationRead {
  filePath?: string | null;
  factions?: FactionEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationEventReadEventFormatReadIllustrationRead {
  filePath?: string | null;
  factions?: FactionEventReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationIllustrationRead {
  filePath?: string | null;
  factions?: FactionIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  filePath?: string | null;
  factions?: FactionJsonldEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  filePath?: string | null;
  factions?: FactionJsonldEventReadEventFormatReadIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationJsonldIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  filePath?: string | null;
  factions?: FactionJsonldIllustrationRead[];
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface IllustrationStatusIllustrationStatusRead {
  color?: string;
  sequence: number;
  illustrations?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
  description?: string | null;
}

export interface IllustrationStatusJsonldIllustrationStatusRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  color?: string;
  sequence: number;
  illustrations?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
  description?: string | null;
}

export interface IllustrationTypeIllustrationTypeRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference:
    | 'CARD'
    | 'USER_AVATARS'
    | 'USER_BACKGROUNDS'
    | 'DECK_THUMB'
    | 'HERO_THUMB'
    | 'FACTION_ICON_FILTER'
    | 'FRAMELESS'
    | 'WEB'
    | 'CARD_BACK'
    | 'LORE';
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  tags?: string[];
  name?: string | null;
  description?: string | null;
}

export interface IllustrationTypeJsonldIllustrationTypeRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference:
    | 'CARD'
    | 'USER_AVATARS'
    | 'USER_BACKGROUNDS'
    | 'DECK_THUMB'
    | 'HERO_THUMB'
    | 'FACTION_ICON_FILTER'
    | 'FRAMELESS'
    | 'WEB'
    | 'CARD_BACK'
    | 'LORE';
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  tags?: string[];
  name?: string | null;
  description?: string | null;
}

export interface InDesignCardExportRead {
  type?:
    | 'playtest'
    | 'playtest_a4'
    | 'playtest_letter'
    | 'meridian'
    | 'cartamundi'
    | 'jpg_bleed'
    | 'png_transparent'
    | 'printing_order';
  /**
   * @default "created"
   * @example "created"
   */
  status?: 'created' | 'sent' | 'start_indesign_process' | 'finish_indesign_process' | 'finish_indesign_error';
  roundedEdge?: boolean | null;
  /**
   * @default "fr_FR"
   * @example "fr_FR"
   */
  locale?: string;
  exportPath?: string | null;
}

export interface InDesignCardExportWrite {
  /**
   * @default "created"
   * @example "created"
   */
  status?: 'created' | 'sent' | 'start_indesign_process' | 'finish_indesign_process' | 'finish_indesign_error';
}

export interface InDesignJsonldCardExportRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  type?:
    | 'playtest'
    | 'playtest_a4'
    | 'playtest_letter'
    | 'meridian'
    | 'cartamundi'
    | 'jpg_bleed'
    | 'png_transparent'
    | 'printing_order';
  /**
   * @default "created"
   * @example "created"
   */
  status?: 'created' | 'sent' | 'start_indesign_process' | 'finish_indesign_process' | 'finish_indesign_error';
  roundedEdge?: boolean | null;
  /**
   * @default "fr_FR"
   * @example "fr_FR"
   */
  locale?: string;
  exportPath?: string | null;
}

export interface InDesignJsonldCardExportWrite {
  /**
   * @default "created"
   * @example "created"
   */
  status?: 'created' | 'sent' | 'start_indesign_process' | 'finish_indesign_process' | 'finish_indesign_error';
}

export interface Invoice {
  /** @format date-time */
  invoiceDate?: string;
  /**
   * When the seller is null, it means that it is Equinox
   * @format iri-reference
   */
  seller?: string | null;
  /** This is the invoice sequence number for that customer */
  number?: number;
  /** @format iri-reference */
  customer?: string;
  customerAddress?: EmbeddableAddress;
  sellerAddress?: EmbeddableAddress;
  lines?: InvoiceLine[];
  avalaraIdentifier?: string | null;
  avalaraEnv?: string | null;
  fileUri?: string | null;
  /** @format iri-reference */
  printingOrder?: string | null;
  marketplaceOrder?: MarketplaceOrder | null;
  mgpType?: string | null;
  currency?: string;
  marketplaceInitialAmount?: number | null;
  walletTransactions?: string[];
  /** @format date-time */
  dispatchedAt?: string | null;
  /**
   * @default true
   * @example true
   */
  draft?: boolean;
  /** List of all refunds linked to that Invoice. */
  refunds?: Refund[];
  /** Refund this invoice is for, if relevant */
  refund?: Refund | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  priceBeforeTax?: number;
  priceTaxIncluded?: number;
  discountBeforeTax?: number | null;
  discountTaxIncluded?: number | null;
  printingOrderType?: boolean;
  podOrderType?: boolean;
  feeAmount?: number;
  feeArray?: Record<string, InvoiceLine>;
  type?: string | null;
  sealed?: boolean;
}

export interface InvoiceJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  invoiceDate?: string;
  /**
   * When the seller is null, it means that it is Equinox
   * @format iri-reference
   */
  seller?: string | null;
  /** This is the invoice sequence number for that customer */
  number?: number;
  /** @format iri-reference */
  customer?: string;
  customerAddress?: EmbeddableAddressJsonld;
  sellerAddress?: EmbeddableAddressJsonld;
  lines?: InvoiceLineJsonld[];
  avalaraIdentifier?: string | null;
  avalaraEnv?: string | null;
  fileUri?: string | null;
  /** @format iri-reference */
  printingOrder?: string | null;
  marketplaceOrder?: MarketplaceOrderJsonld | null;
  mgpType?: string | null;
  currency?: string;
  marketplaceInitialAmount?: number | null;
  walletTransactions?: string[];
  /** @format date-time */
  dispatchedAt?: string | null;
  /**
   * @default true
   * @example true
   */
  draft?: boolean;
  /** List of all refunds linked to that Invoice. */
  refunds?: RefundJsonld[];
  /** Refund this invoice is for, if relevant */
  refund?: RefundJsonld | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  priceBeforeTax?: number;
  priceTaxIncluded?: number;
  discountBeforeTax?: number | null;
  discountTaxIncluded?: number | null;
  printingOrderType?: boolean;
  podOrderType?: boolean;
  feeAmount?: number;
  feeArray?: Record<string, InvoiceLineJsonld>;
  type?: string | null;
  sealed?: boolean;
}

export interface InvoiceLine {
  /** This is the human-readable product name */
  name?: string;
  /** This is the product reference */
  reference?: string;
  /**
   * @default 1
   * @example 1
   */
  quantity?: number;
  priceUnitBeforeTax?: number | null;
  priceUnitTaxIncluded?: number | null;
  /** @format iri-reference */
  invoice?: string;
  isDiscount?: boolean | null;
  negative?: boolean | null;
  tax?: number | null;
  taxRate?: number | null;
  taxLineNumber?: number | null;
  /** @format ulid */
  id?: string | null;
  avalaraCode?: string;
  discount?: boolean;
}

export interface InvoiceLineJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** This is the human-readable product name */
  name?: string;
  /** This is the product reference */
  reference?: string;
  /**
   * @default 1
   * @example 1
   */
  quantity?: number;
  priceUnitBeforeTax?: number | null;
  priceUnitTaxIncluded?: number | null;
  /** @format iri-reference */
  invoice?: string;
  isDiscount?: boolean | null;
  negative?: boolean | null;
  tax?: number | null;
  taxRate?: number | null;
  taxLineNumber?: number | null;
  /** @format ulid */
  id?: string | null;
  avalaraCode?: string;
  discount?: boolean;
}

export interface LanguageLanguageRead {
  locale?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguagePrintingOrderRead {
  locale?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguagePrintingOrderPartnerRead {
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface LanguagePrintingPageReadPrintingOrderPartnerRead {
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface LanguagePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  locale?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguageUserPrivateRead {
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageUserPrivateReadUserTokenRead {
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageUserReadUserPrivateRead {
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageJsonldLanguageRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  locale?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguageJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguageJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface LanguageJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface LanguageJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  codeLocale?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string | null;
}

export interface LanguageJsonldUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageJsonldUserReadUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LanguageJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  locale?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LeagueLeagueRead {
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
  sequence?: number;
  minPoint?: number;
  maxPoint?: number;
  badgeAX?: BadgeLeagueRead | null;
  badgeBR?: BadgeLeagueRead | null;
  badgeLY?: BadgeLeagueRead | null;
  badgeMU?: BadgeLeagueRead | null;
  badgeOR?: BadgeLeagueRead | null;
  badgeYZ?: BadgeLeagueRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface LeagueSeasonPassRead {
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
  sequence?: number;
  minPoint?: number;
  maxPoint?: number;
  badgeAX?: BadgeSeasonPassRead | null;
  badgeBR?: BadgeSeasonPassRead | null;
  badgeLY?: BadgeSeasonPassRead | null;
  badgeMU?: BadgeSeasonPassRead | null;
  badgeOR?: BadgeSeasonPassRead | null;
  badgeYZ?: BadgeSeasonPassRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface LeagueSeasonPassUserRead {
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
}

export interface LeagueJsonldLeagueRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
  sequence?: number;
  minPoint?: number;
  maxPoint?: number;
  badgeAX?: BadgeJsonldLeagueRead | null;
  badgeBR?: BadgeJsonldLeagueRead | null;
  badgeLY?: BadgeJsonldLeagueRead | null;
  badgeMU?: BadgeJsonldLeagueRead | null;
  badgeOR?: BadgeJsonldLeagueRead | null;
  badgeYZ?: BadgeJsonldLeagueRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface LeagueJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
  sequence?: number;
  minPoint?: number;
  maxPoint?: number;
  badgeAX?: BadgeJsonldSeasonPassRead | null;
  badgeBR?: BadgeJsonldSeasonPassRead | null;
  badgeLY?: BadgeJsonldSeasonPassRead | null;
  badgeMU?: BadgeJsonldSeasonPassRead | null;
  badgeOR?: BadgeJsonldSeasonPassRead | null;
  badgeYZ?: BadgeJsonldSeasonPassRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface LeagueJsonldSeasonPassUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$ */
  reference: string;
}

export type LogQrAccessLogQrRead = object;

export type LogQrAccessLogQrWrite = object;

export interface LogQrAccessJsonldLogQrRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export type LogQrAccessJsonldLogQrWrite = object;

export interface LoreEntryCardDetailRead {
  loreEntryElements?: LoreEntryElementCardDetailRead[];
  loreEntryType: LoreEntryTypeCardDetailRead | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LoreEntryLoreEntryRead {
  loreEntryElements?: string[];
  /** @format iri-reference */
  loreEntryType: string | null;
  /** @format iri-reference */
  loreEntryStatus: string | null;
  factions?: string[];
  tags?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  elements?: string[];
  name?: string;
}

export interface LoreEntryJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  loreEntryElements?: LoreEntryElementJsonldCardDetailRead[];
  loreEntryType: LoreEntryTypeJsonldCardDetailRead | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface LoreEntryJsonldLoreEntryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  loreEntryElements?: string[];
  /** @format iri-reference */
  loreEntryType: string | null;
  /** @format iri-reference */
  loreEntryStatus: string | null;
  factions?: string[];
  tags?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  elements?: string[];
  name?: string;
}

export interface LoreEntryElementCardDetailRead {
  loreEntryElementType: LoreEntryElementTypeCardDetailRead | null;
  /** @format ulid */
  id?: string | null;
  text?: string;
}

export interface LoreEntryElementLoreEntryElementRead {
  /** @format iri-reference */
  loreEntryElementType: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  text?: string;
}

export interface LoreEntryElementJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  loreEntryElementType: LoreEntryElementTypeJsonldCardDetailRead | null;
  /** @format ulid */
  id?: string | null;
  text?: string;
}

export interface LoreEntryElementJsonldLoreEntryElementRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  loreEntryElementType: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  text?: string;
}

export interface LoreEntryElementTypeCardDetailRead {
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  subject?: string | null;
}

export interface LoreEntryElementTypeLoreEntryElementTypeRead {
  sequence: number;
  isPublic: boolean;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  subject?: string | null;
  description?: string | null;
}

export interface LoreEntryElementTypeJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  subject?: string | null;
}

export interface LoreEntryElementTypeJsonldLoreEntryElementTypeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  sequence: number;
  isPublic: boolean;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  subject?: string | null;
  description?: string | null;
}

export interface LoreEntryStatusLoreEntryStatusRead {
  color?: string;
  sequence: number;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface LoreEntryStatusJsonldLoreEntryStatusRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  color?: string;
  sequence: number;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface LoreEntryTypeCardDetailRead {
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface LoreEntryTypeLoreEntryTypeRead {
  parent?: LoreEntryTypeLoreEntryTypeRead | null;
  children?: LoreEntryTypeLoreEntryTypeRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  tags?: string[];
  name?: string;
  description?: string | null;
}

export interface LoreEntryTypeJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface LoreEntryTypeJsonldLoreEntryTypeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  parent?: LoreEntryTypeJsonldLoreEntryTypeRead | null;
  children?: LoreEntryTypeJsonldLoreEntryTypeRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  tags?: string[];
  name?: string;
  description?: string | null;
}

export interface MarketplaceCart {
  orderItems?: MarketplaceCartItem[];
  missingAmount?: number;
  totalPrice?: number;
  totalQuantity?: number;
  totalPriceCents?: number;
}

export interface MarketplaceCartJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  orderItems?: MarketplaceCartItemJsonld[];
  missingAmount?: number;
  totalPrice?: number;
  totalQuantity?: number;
  totalPriceCents?: number;
}

export interface MarketplaceCartItem {
  convertedPrice?: number;
  convertedCurrency?: string;
  /** @format iri-reference */
  card?: string;
}

export interface MarketplaceCartItemJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  convertedPrice?: number;
  convertedCurrency?: string;
  /** @format iri-reference */
  card?: string;
}

export interface MarketplaceOfferMarketplaceOfferRead {
  /** @format iri-reference */
  card?: string;
  price?: number;
  currency?: string;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  quantity?: number;
  convertedPrice?: number | null;
  convertedCurrency?: string | null;
  offerId?: string | null;
}

export interface MarketplaceOfferJsonldMarketplaceOfferRead {
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  card?: string;
  price?: number;
  currency?: string;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  quantity?: number;
  convertedPrice?: number | null;
  convertedCurrency?: string | null;
  offerId?: string | null;
}

export interface MarketplaceOfferItem {
  /** @format iri-reference */
  user?: string;
  /** @format iri-reference */
  card?: string;
  price?: number;
  /** @example "EUR" */
  currency?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  /** @format iri-reference */
  ownership?: string;
  /** @format iri-reference */
  marketplaceOrderItem?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MarketplaceOfferItemJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string;
  /** @format iri-reference */
  card?: string;
  price?: number;
  /** @example "EUR" */
  currency?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  /** @format iri-reference */
  ownership?: string;
  /** @format iri-reference */
  marketplaceOrderItem?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MarketplaceOrder {
  /** @format iri-reference */
  user?: string;
  /**
   * @default "cart"
   * @example "cart"
   */
  status?: string;
  marketplaceOrderItems?: MarketplaceOrderItem[];
  walletTransactions?: WalletTransaction[];
  billingAddress?: EmbeddableAddress;
  shippingAddress?: EmbeddableAddress;
  mgpId?: string | null;
  invoices?: Invoice[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  quantity?: number;
  owner?: Owner[];
  totalConvertedPrice?: number;
}

export interface MarketplaceOrderJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string;
  /**
   * @default "cart"
   * @example "cart"
   */
  status?: string;
  marketplaceOrderItems?: MarketplaceOrderItemJsonld[];
  walletTransactions?: WalletTransactionJsonld[];
  billingAddress?: EmbeddableAddressJsonld;
  shippingAddress?: EmbeddableAddressJsonld;
  mgpId?: string | null;
  invoices?: InvoiceJsonld[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  quantity?: number;
  owner?: OwnerJsonld[];
  totalConvertedPrice?: number;
}

export interface MarketplaceOrderItem {
  /** @format iri-reference */
  marketplaceOfferItem?: string;
  marketplaceOrder?: MarketplaceOrder;
  convertedPrice?: number;
  convertedCurrency?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MarketplaceOrderItemJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  marketplaceOfferItem?: string;
  marketplaceOrder?: MarketplaceOrderJsonld;
  convertedPrice?: number;
  convertedCurrency?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MediaEventLocatorReadShopLocatorRead {
  contentUrl?: string | null;
}

export interface MediaMediaRead {
  contentUrl?: string | null;
  type?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MediaShopRead {
  contentUrl?: string | null;
}

export interface MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  contentUrl?: string | null;
  type?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MediaUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  contentUrl?: string | null;
}

export interface MediaJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  contentUrl?: string | null;
}

export interface MediaJsonldMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  contentUrl?: string | null;
  type?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MediaJsonldShopRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  contentUrl?: string | null;
}

export interface MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  contentUrl?: string | null;
  type?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface MediaJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  contentUrl?: string | null;
}

export interface ModalsModalsGetList {
  id?: number;
  date?: string | null;
  date_gmt?: string | null;
  modified?: string | null;
  modified_gmt?: string | null;
  slug?: string | null;
  status?: string | null;
  type?: string | null;
  title?: string[];
  author?: number;
  parent?: string[];
  menu_order?: number;
  template?: string | null;
  acf?: string[];
  yoast_head_json?: string[];
  childrens?: string[];
  children_previous?: string | null;
  children_next?: string | null;
  url?: string | null;
}

export interface ModalsJsonldModalsGetList {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: number;
  date?: string | null;
  date_gmt?: string | null;
  modified?: string | null;
  modified_gmt?: string | null;
  slug?: string | null;
  status?: string | null;
  type?: string | null;
  title?: string[];
  author?: number;
  parent?: string[];
  menu_order?: number;
  template?: string | null;
  acf?: string[];
  yoast_head_json?: string[];
  childrens?: string[];
  children_previous?: string | null;
  children_next?: string | null;
  url?: string | null;
}

export interface NotificationNotificationRead {
  triggerUser?: UserNotificationRead | null;
  read?: boolean;
  category?: string;
  cms?: {
    /** @example "Echange" */
    category?: string;
    /** @example "fa-solid fa-fan" */
    icon?: string;
    /** @example "**lane65** vous a donné 1 exemplaire(s) de la carte **Eidolon Yzmir 1**" */
    content?: string;
    buttons?: {
      link?: {
        /** @example "Voir la carte" */
        title?: string;
        /** @example "/fr-fr/cards/YZ_1" */
        url?: string;
        /** @example "" */
        target?: string;
      } | null;
      /** @example "coucou" */
      link_class?: string;
    }[];
    image_url?: string;
    image_position?: 'top' | 'bottom' | 'left' | 'right';
  };
  /** @format date-time */
  date?: string;
  /** @format ulid */
  id?: string | null;
}

export interface NotificationJsonldNotificationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  triggerUser?: UserJsonldNotificationRead | null;
  read?: boolean;
  category?: string;
  cms?: {
    /** @example "Echange" */
    category?: string;
    /** @example "fa-solid fa-fan" */
    icon?: string;
    /** @example "**lane65** vous a donné 1 exemplaire(s) de la carte **Eidolon Yzmir 1**" */
    content?: string;
    buttons?: {
      link?: {
        /** @example "Voir la carte" */
        title?: string;
        /** @example "/fr-fr/cards/YZ_1" */
        url?: string;
        /** @example "" */
        target?: string;
      } | null;
      /** @example "coucou" */
      link_class?: string;
    }[];
    image_url?: string;
    image_position?: 'top' | 'bottom' | 'left' | 'right';
  };
  /** @format date-time */
  date?: string;
  /** @format ulid */
  id?: string | null;
}

export interface NotificationParameterNotificationParameterRead {
  channel?: string;
  locked?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface NotificationParameterJsonldNotificationParameterRead {
  '@id'?: string;
  '@type'?: string;
  channel?: string;
  locked?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface NotificationParameterUser {
  system?: string[];
  marketplace?: string[];
  printOnDemand?: string[];
  collection?: string[];
  marketing?: string[];
  event?: string[];
  tradingAndDonation?: string[];
  social?: string[];
  wallet?: string[];
}

export interface NotificationParameterUserNotificationParameterUserRead {
  system?: string[];
  marketplace?: string[];
  printOnDemand?: string[];
  collection?: string[];
  marketing?: string[];
  event?: string[];
  tradingAndDonation?: string[];
  social?: string[];
  wallet?: string[];
}

export interface NotificationParameterUserJsonld {
  system?: string[];
  marketplace?: string[];
  printOnDemand?: string[];
  collection?: string[];
  marketing?: string[];
  event?: string[];
  tradingAndDonation?: string[];
  social?: string[];
  wallet?: string[];
}

export interface NotificationParameterUserJsonldNotificationParameterUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  system?: string[];
  marketplace?: string[];
  printOnDemand?: string[];
  collection?: string[];
  marketing?: string[];
  event?: string[];
  tradingAndDonation?: string[];
  social?: string[];
  wallet?: string[];
}

export interface OptinOptinRead {
  mandatory?: boolean;
  userProfiles: UserProfileOptinRead[];
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  name?: string | null;
}

export interface OptinJsonldOptinRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  mandatory?: boolean;
  userProfiles: UserProfileJsonldOptinRead[];
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  comment?: string | null;
  name?: string | null;
}

export interface Owner {
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  card?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  context?: string | null;
  printingHistories?: PrintingHistory[];
  /** @format date-time */
  lastPrinted?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  printingPossibleDate?: string | null;
}

export interface OwnerOwnerRead {
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerOwnerWrite {
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
}

export interface OwnerOwnerClaimMultiOwnerClaimMultiRead {
  id?: string | null;
  successes?: CardOwnerClaimMultiRead[] | null;
  fails?: CardOwnerClaimMultiRead[] | null;
}

export interface OwnerOwnerClaimMultiJsonldOwnerClaimMultiRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string | null;
  successes?: CardJsonldOwnerClaimMultiRead[] | null;
  fails?: CardJsonldOwnerClaimMultiRead[] | null;
}

export interface OwnerJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  card?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  context?: string | null;
  printingHistories?: PrintingHistoryJsonld[];
  /** @format date-time */
  lastPrinted?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  printingPossibleDate?: string | null;
}

export interface OwnerJsonldOwnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerJsonldOwnerWrite {
  /** @format iri-reference */
  ownership: string | null;
  /** @format iri-reference */
  user?: string | null;
  /**
   * @default "available"
   * @example "available"
   */
  status?: string;
}

export interface OwnerExchangeCardOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  card?: CardOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  quantity?: number;
}

export interface OwnerExchangeCardOwnerExchangeRequestWrite {
  /** @format iri-reference */
  card?: string | null;
  quantity?: number;
}

export interface OwnerExchangeCardJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  card?: CardJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  quantity?: number;
}

export interface OwnerExchangeCardJsonldOwnerExchangeRequestWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  card?: string | null;
  quantity?: number;
}

export interface OwnerExchangeRequestOwnerExchangeRequestRead {
  userLastUpdate?: UserOwnerExchangeRequestRead | null;
  status?: string | null;
  friend?: UserOwnerExchangeRequestRead;
  myTurn?: boolean;
  enableCardChoice?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerExchangeRequestOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  sender?: UserOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  userLastUpdate?: UserOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  ownerExchangeCardsSender?: OwnerExchangeCardOwnerExchangeRequestReadOwnerExchangeRequestDetailRead[];
  ownerExchangeCardsReceiver?: OwnerExchangeCardOwnerExchangeRequestReadOwnerExchangeRequestDetailRead[];
  status?: string | null;
  friend?: UserOwnerExchangeRequestReadOwnerExchangeRequestDetailRead;
  myTurn?: boolean;
  enableCardChoice?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerExchangeRequestOwnerExchangeRequestWrite {
  ownerExchangeCards?: OwnerExchangeCardOwnerExchangeRequestWrite[];
  /** @format iri-reference */
  friend?: string;
}

export interface OwnerExchangeRequestJsonldOwnerExchangeRequestRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  userLastUpdate?: UserJsonldOwnerExchangeRequestRead | null;
  status?: string | null;
  friend?: UserJsonldOwnerExchangeRequestRead;
  myTurn?: boolean;
  enableCardChoice?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  sender?: UserJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  userLastUpdate?: UserJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead | null;
  ownerExchangeCardsSender?: OwnerExchangeCardJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead[];
  ownerExchangeCardsReceiver?: OwnerExchangeCardJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead[];
  status?: string | null;
  friend?: UserJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead;
  myTurn?: boolean;
  enableCardChoice?: boolean;
  /** @format ulid */
  id?: string | null;
}

export interface OwnerExchangeRequestJsonldOwnerExchangeRequestWrite {
  ownerExchangeCards?: OwnerExchangeCardJsonldOwnerExchangeRequestWrite[];
  /** @format iri-reference */
  friend?: string;
}

export interface OwnerHistoryGroupOwnerHistoryGroupRead {
  id?: string | null;
  card?: CardOwnerHistoryGroupRead | null;
  owner?: UserOwnerHistoryGroupRead | null;
  previousOwner?: UserOwnerHistoryGroupRead | null;
  quantity?: number | null;
}

export interface OwnerHistoryGroupJsonldOwnerHistoryGroupRead {
  '@id'?: string;
  '@type'?: string;
  id?: string | null;
  card?: CardJsonldOwnerHistoryGroupRead | null;
  owner?: UserJsonldOwnerHistoryGroupRead | null;
  previousOwner?: UserJsonldOwnerHistoryGroupRead | null;
  quantity?: number | null;
}

export interface OwnershipOwnershipRead {
  /** @format ulid */
  id?: string | null;
  card: CardOwnershipRead | null;
  /**
   * @default true
   * @example true
   */
  available?: boolean;
  mine?: boolean;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  code?: string;
}

export interface OwnershipQrCodeRead {
  code?: string;
}

export interface OwnershipJsonldOwnershipRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
  card: CardJsonldOwnershipRead | null;
  /**
   * @default true
   * @example true
   */
  available?: boolean;
  mine?: boolean;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  code?: string;
}

export interface OwnershipJsonldQrCodeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  code?: string;
}

export interface OwnershipListDataOwnershipListRead {
  cards?: DeckUserListCardOwnershipListRead[];
}

export interface OwnershipListDataOwnershipListWrite {
  cards?: DeckUserListCardOwnershipListWrite[];
  putOption?: string | null;
}

export interface OwnershipListDataJsonldOwnershipListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  cards?: DeckUserListCardJsonldOwnershipListRead[];
}

export interface OwnershipListDataJsonldOwnershipListWrite {
  cards?: DeckUserListCardJsonldOwnershipListWrite[];
  putOption?: string | null;
}

export interface PagesPagesGetList {
  id?: number;
  date?: string | null;
  date_gmt?: string | null;
  modified?: string | null;
  modified_gmt?: string | null;
  slug?: string | null;
  status?: string | null;
  type?: string | null;
  title?: string[];
  author?: number;
  parent?: string[];
  menu_order?: number;
  template?: string | null;
  acf?: string[];
  yoast_head_json?: string[];
  childrens?: string[];
  children_previous?: string | null;
  children_next?: string | null;
  url?: string | null;
}

export interface PagesJsonldPagesGetList {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: number;
  date?: string | null;
  date_gmt?: string | null;
  modified?: string | null;
  modified_gmt?: string | null;
  slug?: string | null;
  status?: string | null;
  type?: string | null;
  title?: string[];
  author?: number;
  parent?: string[];
  menu_order?: number;
  template?: string | null;
  acf?: string[];
  yoast_head_json?: string[];
  childrens?: string[];
  children_previous?: string | null;
  children_next?: string | null;
  url?: string | null;
}

export type PaginatorCardSetCollectionRead = object;

export interface PaginatorJsonldCardSetCollectionRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface PayinBrowserInfoPaymentPaymentCardPayinWrite {
  javaEnabled?: boolean;
  language?: string;
  colorDepth?: number;
  screenHeight?: number;
  screenWidth?: number;
  timeZoneOffset?: number;
  userAgent?: string;
  javascriptEnabled?: boolean;
}

export interface PayinBrowserInfoJsonldPaymentPaymentCardPayinWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  javaEnabled?: boolean;
  language?: string;
  colorDepth?: number;
  screenHeight?: number;
  screenWidth?: number;
  timeZoneOffset?: number;
  userAgent?: string;
  javascriptEnabled?: boolean;
}

export interface PaymentCardPaymentDetailPayinRead {
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  number?: string;
}

export interface PaymentCardPaymentPaymentCardPayinWrite {
  browserInfo?: PayinBrowserInfoPaymentPaymentCardPayinWrite | null;
  /**
   * @min 1
   * @max 250
   */
  amount: number;
  redirectURL?: string;
}

export interface PaymentCardPaymentPaymentCardRead {
  externalId?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  active?: boolean;
  validity?: string | null;
  cardProvider?: string | null;
  number?: string;
  /** @format iri-reference */
  user?: string | null;
}

export interface PaymentCardCardPayinPaymentPaymentCardPayinRead {
  id?: string;
  secureModeRedirectURL?: string | null;
}

export interface PaymentCardCardPayinJsonldPaymentPaymentCardPayinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string;
  secureModeRedirectURL?: string | null;
}

export interface PaymentCardJsonldPaymentDetailPayinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  number?: string;
}

export interface PaymentCardJsonldPaymentPaymentCardPayinWrite {
  browserInfo?: PayinBrowserInfoJsonldPaymentPaymentCardPayinWrite | null;
  /**
   * @min 1
   * @max 250
   */
  amount: number;
  redirectURL?: string;
}

export interface PaymentCardJsonldPaymentPaymentCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  externalId?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationMonth?: string;
  /**
   * @minLength 0
   * @maxLength 2
   */
  expirationYear?: string;
  type?: string;
  active?: boolean;
  validity?: string | null;
  cardProvider?: string | null;
  number?: string;
  /** @format iri-reference */
  user?: string | null;
}

export interface PaymentPricingGridPaymentPricingGridRead {
  fee?: number;
  amount?: number;
  currency?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PaymentPricingGridJsonldPaymentPricingGridRead {
  '@id'?: string;
  '@type'?: string;
  fee?: number;
  amount?: number;
  currency?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PayoutPayoutRead {
  fees?: number;
  total?: number;
}

export type PayoutPayoutWrite = object;

export interface PayoutJsonldPayoutRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  fees?: number;
  total?: number;
}

export type PayoutJsonldPayoutWrite = object;

export interface PrintOnDemandProductPrintOnDemandProductRead {
  name?: string;
  prices?: ProductPricePrintOnDemandProductRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export type PrintOnDemandProductPrintingAuthorizationRead = object;

export interface PrintOnDemandProductPrintingOrderRead {
  name?: string;
  prices?: ProductPricePrintingOrderRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductPrintingOrderPartnerRead {
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductPrintingPageReadPrintingOrderPartnerRead {
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  name?: string;
  prices?: ProductPricePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductJsonldPrintOnDemandProductRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  prices?: ProductPriceJsonldPrintOnDemandProductRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductJsonldPrintingAuthorizationRead {
  '@id'?: string;
  '@type'?: string;
}

export interface PrintOnDemandProductJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  prices?: ProductPriceJsonldPrintingOrderRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintOnDemandProductJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  prices?: ProductPriceJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  /**
   * @default "NORMAL"
   * @example "NORMAL"
   */
  type?: string;
}

export interface PrintingHistory {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  owner?: string | null;
  /** @format date-time */
  lastPrinted?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingHistoryJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  owner?: string | null;
  /** @format date-time */
  lastPrinted?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderPrintingOrderRead {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserPrintingOrderRead | null;
  printingPages?: PrintingPagePrintingOrderRead[];
  language: LanguagePrintingOrderRead | null;
  shippingValidatedAddress?: AddressPrintingOrderRead | null;
  billingValidatedAddress?: AddressPrintingOrderRead | null;
  shippingTrackingId?: string | null;
  shippingTrackingUrl?: string;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  full?: boolean;
  currency?: string;
  prices?: ProductPriceERPPrintingOrderRead;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  /** Prices from ProductPrice are in money unit (not in cents). */
  productPrice?: ProductPricePrintingOrderRead;
  orderTTC?: number;
  discountPOD?: number;
  shippingCostTTC?: number;
  discountShipping?: number;
  totalOrderTTC?: number;
  includingTaxes?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderPrintingOrderWrite {
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  /** @format iri-reference */
  language: string | null;
  /** @format iri-reference */
  shippingValidatedAddress?: string | null;
  /** @format iri-reference */
  billingValidatedAddress?: string | null;
}

export interface PrintingOrderPrintingOrderPartnerRead {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserPrintingOrderPartnerRead | null;
  printingPages?: PrintingPagePrintingOrderPartnerRead[];
  language: LanguagePrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressPrintingOrderPartnerRead;
  billingAddress?: EmbeddableAddressPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  currency?: string;
  prices?: ProductPriceERPPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderPrintingOrderPartnerWrite {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  shippingTrackingId?: string | null;
  errorText?: string | null;
}

export interface PrintingOrderPrintingPageReadPrintingOrderPartnerRead {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserPrintingPageReadPrintingOrderPartnerRead | null;
  printingPages?: PrintingPagePrintingPageReadPrintingOrderPartnerRead[];
  language: LanguagePrintingPageReadPrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressPrintingPageReadPrintingOrderPartnerRead;
  billingAddress?: EmbeddableAddressPrintingPageReadPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  currency?: string;
  prices?: ProductPriceERPPrintingPageReadPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPages?: PrintingPagePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  language: LanguagePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  shippingValidatedAddress?: AddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  billingValidatedAddress?: AddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  billingAddress?: EmbeddableAddressPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  shippingTrackingUrl?: string;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  full?: boolean;
  currency?: string;
  prices?: ProductPriceERPPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  /** Prices from ProductPrice are in money unit (not in cents). */
  productPrice?: ProductPricePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  orderTTC?: number;
  discountPOD?: number;
  shippingCostTTC?: number;
  discountShipping?: number;
  totalOrderTTC?: number;
  includingTaxes?: number;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserJsonldPrintingOrderRead | null;
  printingPages?: PrintingPageJsonldPrintingOrderRead[];
  language: LanguageJsonldPrintingOrderRead | null;
  shippingValidatedAddress?: AddressJsonldPrintingOrderRead | null;
  billingValidatedAddress?: AddressJsonldPrintingOrderRead | null;
  shippingTrackingId?: string | null;
  shippingTrackingUrl?: string;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  full?: boolean;
  currency?: string;
  prices?: ProductPriceERPJsonldPrintingOrderRead;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  /** Prices from ProductPrice are in money unit (not in cents). */
  productPrice?: ProductPriceJsonldPrintingOrderRead;
  orderTTC?: number;
  discountPOD?: number;
  shippingCostTTC?: number;
  discountShipping?: number;
  totalOrderTTC?: number;
  includingTaxes?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderJsonldPrintingOrderWrite {
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  /** @format iri-reference */
  language: string | null;
  /** @format iri-reference */
  shippingValidatedAddress?: string | null;
  /** @format iri-reference */
  billingValidatedAddress?: string | null;
}

export interface PrintingOrderJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserJsonldPrintingOrderPartnerRead | null;
  printingPages?: PrintingPageJsonldPrintingOrderPartnerRead[];
  language: LanguageJsonldPrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressJsonldPrintingOrderPartnerRead;
  billingAddress?: EmbeddableAddressJsonldPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  currency?: string;
  prices?: ProductPriceERPJsonldPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderJsonldPrintingOrderPartnerWrite {
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  shippingTrackingId?: string | null;
  errorText?: string | null;
}

export interface PrintingOrderJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  printingPages?: PrintingPageJsonldPrintingPageReadPrintingOrderPartnerRead[];
  language: LanguageJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressJsonldPrintingPageReadPrintingOrderPartnerRead;
  billingAddress?: EmbeddableAddressJsonldPrintingPageReadPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  currency?: string;
  prices?: ProductPriceERPJsonldPrintingPageReadPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default "DRAFT"
   * @example "DRAFT"
   */
  status:
    | 'DRAFT'
    | 'CONFIRMED'
    | 'INTEGRATED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'INTEGRATION_ERROR'
    | 'PENDING_CARD_REGENERATION';
  /**
   * @minLength 0
   * @maxLength 150
   * @default true
   * @example true
   */
  name: string;
  creator: UserJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPages?: PrintingPageJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  language: LanguageJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  shippingValidatedAddress?: AddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  shippingAddress?: EmbeddableAddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  billingValidatedAddress?: AddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  billingAddress?: EmbeddableAddressJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  shippingTrackingId?: string | null;
  shippingTrackingUrl?: string;
  errorText?: string | null;
  /** @format iri-reference */
  printingOrderSlot?: string | null;
  nbNormalCards?: number;
  nbTotalNormalCards?: number;
  nbFoilCards?: number;
  nbTotalFoilCards?: number;
  full?: boolean;
  currency?: string;
  prices?: ProductPriceERPJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  printingOrderUrl?: string;
  missingAmount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  /** Prices from ProductPrice are in money unit (not in cents). */
  productPrice?: ProductPriceJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead;
  orderTTC?: number;
  discountPOD?: number;
  shippingCostTTC?: number;
  discountShipping?: number;
  totalOrderTTC?: number;
  includingTaxes?: number;
  deliveryType?: string;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingOrderSlotPrintingOrderSlotRead {
  /** @format date-time */
  printedAt?: string;
  deliveryDaysMinAfterPrinting?: number | null;
  deliveryDaysMaxAfterPrinting?: number | null;
}

export interface PrintingOrderSlotJsonldPrintingOrderSlotRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  printedAt?: string;
  deliveryDaysMinAfterPrinting?: number | null;
  deliveryDaysMaxAfterPrinting?: number | null;
}

export interface PrintingPagePrintingOrderRead {
  printOnDemandProduct: PrintOnDemandProductPrintingOrderRead | null;
  printingOrder?: PrintingOrderPrintingOrderRead | null;
  printingPageCards?: PrintingPageCardPrintingOrderRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPagePrintingOrderPartnerRead {
  printOnDemandProduct: PrintOnDemandProductPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPagePrintingPageReadPrintingOrderPartnerRead {
  printOnDemandProduct: PrintOnDemandProductPrintingPageReadPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderPrintingPageReadPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardPrintingPageReadPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPagePrintingPageWrite {
  /** @format iri-reference */
  printOnDemandProduct: string | null;
  /** @format iri-reference */
  printingOrder?: string | null;
}

export interface PrintingPagePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  printOnDemandProduct: PrintOnDemandProductPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  printOnDemandProduct: PrintOnDemandProductJsonldPrintingOrderRead | null;
  printingOrder?: PrintingOrderJsonldPrintingOrderRead | null;
  printingPageCards?: PrintingPageCardJsonldPrintingOrderRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  printOnDemandProduct: PrintOnDemandProductJsonldPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderJsonldPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardJsonldPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  printOnDemandProduct: PrintOnDemandProductJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardJsonldPrintingPageReadPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageJsonldPrintingPageWrite {
  /** @format iri-reference */
  printOnDemandProduct: string | null;
  /** @format iri-reference */
  printingOrder?: string | null;
}

export interface PrintingPageJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  printOnDemandProduct: PrintOnDemandProductJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingOrder?: PrintingOrderJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPageCards?: PrintingPageCardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead[];
  nbPageCards?: number;
  nbAvailablePlaces?: number;
  printingPageOrderUrl?: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardPrintingOrderRead {
  card?: CardPrintingOrderRead | null;
  printingPage: PrintingPagePrintingOrderRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardPrintingOrderPartnerRead {
  qrCodeUrl?: string;
  card?: CardPrintingOrderPartnerRead | null;
  printingPage: PrintingPagePrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardPrintingPageReadPrintingOrderPartnerRead {
  qrCodeUrl?: string;
  card?: CardPrintingPageReadPrintingOrderPartnerRead | null;
  printingPage: PrintingPagePrintingPageReadPrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  qrCodeUrl?: string;
  card?: CardPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPage: PrintingPagePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardPrintingPageCardWrite {
  /** @format iri-reference */
  card?: string | null;
  /** @format iri-reference */
  printingPage: string | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
}

export interface PrintingPageCardJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  card?: CardJsonldPrintingOrderRead | null;
  printingPage: PrintingPageJsonldPrintingOrderRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  qrCodeUrl?: string;
  card?: CardJsonldPrintingOrderPartnerRead | null;
  printingPage: PrintingPageJsonldPrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  qrCodeUrl?: string;
  card?: CardJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  printingPage: PrintingPageJsonldPrintingPageReadPrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  qrCodeUrl?: string;
  card?: CardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  printingPage: PrintingPageJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
  /** @format ulid */
  id?: string | null;
}

export interface PrintingPageCardJsonldPrintingPageCardWrite {
  /** @format iri-reference */
  card?: string | null;
  /** @format iri-reference */
  printingPage: string | null;
  /**
   * @min 1
   * @max 20
   * @default 1
   * @example 1
   */
  quantity?: number;
}

export interface ProductPricePrintOnDemandProductRead {
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPricePrintingOrderRead {
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPricePrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPriceJsonldPrintOnDemandProductRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPriceJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPriceJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  quantity?: number;
  price?: number;
  currency?: string;
  totalPrice?: number;
}

export interface ProductPriceERPPrintingOrderRead {
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPPrintingOrderPartnerRead {
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPPrintingPageReadPrintingOrderPartnerRead {
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface ProductPriceERPJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  productTotalPrice?: number;
  deliveryPrice?: number;
  taxesPrice?: number;
  totalPriceWithTaxes?: number;
}

export interface QrCodeQrCodeRead {
  ownership?: OwnershipQrCodeRead | null;
  url?: string | null;
  hash?: string;
  qrCodeUrl?: string | null;
}

export interface QrCodeCardQrCodeRead {
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  collectorNumberFormatted?: string | null;
}

export interface QrCodeCardJsonldQrCodeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  imagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  collectorNumberFormatted?: string | null;
}

export interface QrCodeJsonldQrCodeRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  ownership?: OwnershipJsonldQrCodeRead | null;
  url?: string | null;
  hash?: string;
  qrCodeUrl?: string | null;
}

export interface RarityCardDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
}

export interface RarityCardRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
}

export interface RarityCardVariant {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityDeckUserListRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityDeckUserListReadDeckUserListDetailRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityManufactureRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityOwnerClaimMultiRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityOwnerHistoryGroupRead {
  name?: string | null;
}

export interface RarityPrintingOrderRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityRarityRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface RaritySeasonPassRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityJsonldCardDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
}

export interface RarityJsonldCardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
}

export interface RarityJsonldCardVariant {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityJsonldManufactureRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityJsonldOwnerClaimMultiRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface RarityJsonldOwnerHistoryGroupRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string | null;
}

export interface RarityJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  name?: string | null;
}

export interface RarityJsonldRarityRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
  /** @format ulid */
  id?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface RarityJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([A-Z0-9]+(?:-[A-Z0-9]+)*(?:_[A-Z0-9]+)*)$
   */
  reference: 'COMMON' | 'RARE' | 'UNIQUE';
}

export interface Refund {
  mgpId?: string;
  /** This is in cents */
  amount?: number;
  motive?: string;
  /** @format iri-reference */
  user?: string | null;
  /**
   * This is the parent Invoice
   * @format iri-reference
   */
  invoice?: string | null;
  /**
   * This is the Invoice for this Refund
   * @format iri-reference
   */
  refundInvoice?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface RefundJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  mgpId?: string;
  /** This is in cents */
  amount?: number;
  motive?: string;
  /** @format iri-reference */
  user?: string | null;
  /**
   * This is the parent Invoice
   * @format iri-reference
   */
  invoice?: string | null;
  /**
   * This is the Invoice for this Refund
   * @format iri-reference
   */
  refundInvoice?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface RewardSeasonPassRead {
  card?: CardSeasonPassRead | null;
  /** @format iri-reference */
  faction?: string | null;
}

export interface RewardUserRewardRead {
  /** @format iri-reference */
  card?: string | null;
  /** @format iri-reference */
  faction?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface RewardJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  card?: CardJsonldSeasonPassRead | null;
  /** @format iri-reference */
  faction?: string | null;
}

export interface RewardJsonldUserRewardRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  card?: string | null;
  /** @format iri-reference */
  faction?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface RuleRuleRead {
  name: string;
  type: string;
  event?: string[] | null;
  entity?: string | null;
  groupConditions?: RuleGroupConditionRuleRead[];
  ruleActions?: RuleActionRuleRead[];
  /** todo: choice OR, AND. */
  groupRelationalOp?: string | null;
  category?: string | null;
  enabled?: boolean;
  locked?: boolean;
  ttl?: number;
  entityName?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface RuleRuleWrite {
  name: string;
  type: string;
  event?: string[] | null;
  entity?: string | null;
  groupConditions?: RuleGroupConditionRuleWrite[];
  ruleActions?: RuleActionRuleWrite[];
  /** todo: choice OR, AND. */
  groupRelationalOp?: string | null;
  category?: string | null;
  enabled?: boolean;
  locked?: boolean;
  ttl?: number;
  entityName?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface RuleJsonldRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name: string;
  type: string;
  event?: string[] | null;
  entity?: string | null;
  groupConditions?: RuleGroupConditionJsonldRuleRead[];
  ruleActions?: RuleActionJsonldRuleRead[];
  /** todo: choice OR, AND. */
  groupRelationalOp?: string | null;
  category?: string | null;
  enabled?: boolean;
  locked?: boolean;
  ttl?: number;
  entityName?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface RuleJsonldRuleWrite {
  name: string;
  type: string;
  event?: string[] | null;
  entity?: string | null;
  groupConditions?: RuleGroupConditionJsonldRuleWrite[];
  ruleActions?: RuleActionJsonldRuleWrite[];
  /** todo: choice OR, AND. */
  groupRelationalOp?: string | null;
  category?: string | null;
  enabled?: boolean;
  locked?: boolean;
  ttl?: number;
  entityName?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface RuleActionRuleRead {
  action?: string | null;
  parameters: string[] | null;
  sequence?: number | null;
  actionName?: string;
  requestedArguments?: string[];
}

export interface RuleActionRuleWrite {
  action?: string | null;
  parameters: string[] | null;
  sequence?: number | null;
}

export interface RuleActionJsonldRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  action?: string | null;
  parameters: string[] | null;
  sequence?: number | null;
  actionName?: string;
  requestedArguments?: string[];
}

export interface RuleActionJsonldRuleWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  action?: string | null;
  parameters: string[] | null;
  sequence?: number | null;
}

export interface RuleConditionRuleRead {
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
  callbackName?: string;
  entityName?: string | null;
}

export interface RuleConditionRuleWrite {
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
}

export interface RuleConditionRuleRuleRead {
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
  callbackName?: string;
  entityName?: string | null;
}

export interface RuleConditionRuleRuleWrite {
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
}

export interface RuleConditionJsonldRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
  callbackName?: string;
  entityName?: string | null;
}

export interface RuleConditionJsonldRuleWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
}

export interface RuleConditionJsonldRuleRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
  callbackName?: string;
  entityName?: string | null;
}

export interface RuleConditionJsonldRuleRuleWrite {
  name: string;
  entity?: string | null;
  property?: string | null;
  /** todo: choice [==, >, >=, <, <=, IN, NOT IN, LIKE]. */
  logicOp?: string | null;
  value?: string | null;
  past?: boolean;
  sequence?: number | null;
  callback?: string | null;
}

export interface RuleGroupConditionRuleRead {
  conditions?: RuleConditionRuleRead[];
  name: string;
  /** todo: choice OR, AND. */
  conditionRelationalOp?: string | null;
  /** todo: choice [FILTER, TEST]. */
  type?: string;
  sequence?: number | null;
}

export interface RuleGroupConditionRuleWrite {
  conditions?: RuleConditionRuleWrite[];
  name: string;
  /** todo: choice OR, AND. */
  conditionRelationalOp?: string | null;
  /** todo: choice [FILTER, TEST]. */
  type?: string;
  sequence?: number | null;
}

export interface RuleGroupConditionJsonldRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  conditions?: RuleConditionJsonldRuleRead[];
  name: string;
  /** todo: choice OR, AND. */
  conditionRelationalOp?: string | null;
  /** todo: choice [FILTER, TEST]. */
  type?: string;
  sequence?: number | null;
}

export interface RuleGroupConditionJsonldRuleWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  conditions?: RuleConditionJsonldRuleWrite[];
  name: string;
  /** todo: choice OR, AND. */
  conditionRelationalOp?: string | null;
  /** todo: choice [FILTER, TEST]. */
  type?: string;
  sequence?: number | null;
}

export type RuleProcessRuleRead = object;

export type RuleProcessRuleWrite = object;

export interface RuleProcessJsonldRuleRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export type RuleProcessJsonldRuleWrite = object;

export interface SaleSummaryMarketplaceSalesRead {
  totalSalesCount?: number;
  totalSalesAmount?: number;
  currency?: string;
}

export interface SaleSummaryJsonldMarketplaceSalesRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  totalSalesCount?: number;
  totalSalesAmount?: number;
  currency?: string;
}

export interface SeasonPassSeasonPassRead {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  leagues?: LeagueSeasonPassRead[];
  userRewards?: UserRewardSeasonPassRead[];
  userBadge?: BadgeSeasonPassRead;
  userSeasonPass?: SeasonPassUserSeasonPassRead;
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface SeasonPassSeasonPassUserRead {
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface SeasonPassJsonldSeasonPassRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  leagues?: LeagueJsonldSeasonPassRead[];
  userRewards?: UserRewardJsonldSeasonPassRead[];
  userBadge?: BadgeJsonldSeasonPassRead;
  userSeasonPass?: SeasonPassUserJsonldSeasonPassRead;
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface SeasonPassJsonldSeasonPassUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface SeasonPassUserSeasonPassRead {
  /** @format iri-reference */
  faction: string | null;
  counter?: number;
}

export interface SeasonPassUserSeasonPassUserRead {
  /** @format iri-reference */
  user?: string | null;
  seasonPass?: SeasonPassSeasonPassUserRead | null;
  faction: FactionSeasonPassUserRead | null;
  counter?: number;
  currentLeague?: LeagueSeasonPassUserRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface SeasonPassUserSeasonPassUserWrite {
  /** @format iri-reference */
  faction: string | null;
}

export interface SeasonPassUserJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  faction: string | null;
  counter?: number;
}

export interface SeasonPassUserJsonldSeasonPassUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string | null;
  seasonPass?: SeasonPassJsonldSeasonPassUserRead | null;
  faction: FactionJsonldSeasonPassUserRead | null;
  counter?: number;
  currentLeague?: LeagueJsonldSeasonPassUserRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface SeasonPassUserJsonldSeasonPassUserWrite {
  /** @format iri-reference */
  faction: string | null;
}

export interface ShopEventLocatorReadShopLocatorRead {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  user?: UserEventLocatorReadShopLocatorRead | null;
  shopSocialNetworks?: ShopSocialNetworkEventLocatorReadShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
  distance?: number;
}

export interface ShopShopLocatorRead {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  user?: UserShopLocatorRead | null;
  shopSocialNetworks?: ShopSocialNetworkShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
  distance?: number;
}

export interface ShopShopRead {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserShopRead | null;
  logo?: MediaShopRead | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  identificationNumber?: string;
  taxNumber?: string;
  incorporationCertificate?: MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  logo?: MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  background?: MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  photos?: MediaShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  members?: ShopMemberShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  shopSocialNetworks?: ShopSocialNetworkShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  owner?: UserShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
}

export interface ShopShopStatRead {
  stats?: {
    sales?: number;
    events?: number;
    affiliates?: number;
  } | null;
}

export interface ShopShopWrite {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  identificationNumber?: string;
  taxNumber?: string;
  /** @format iri-reference */
  incorporationCertificate?: string | null;
  /** @format iri-reference */
  logo?: string | null;
  /** @format iri-reference */
  background?: string | null;
  photos?: string[];
  shopSocialNetworks?: ShopSocialNetworkShopWrite[];
}

export interface ShopUserPrivateReadUserTokenRead {
  name?: string;
}

export interface ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  name?: string;
}

export interface ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  logo?: MediaUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopUserWriteShopWrite {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  identificationNumber?: string;
  taxNumber?: string;
  /** @format iri-reference */
  incorporationCertificate?: string | null;
  /** @format iri-reference */
  logo?: string | null;
  /** @format iri-reference */
  background?: string | null;
  photos?: string[];
  shopSocialNetworks?: ShopSocialNetworkUserWriteShopWrite[];
}

export interface ShopUserTokenRead {
  name?: string;
}

export interface ShopJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  user?: UserJsonldEventLocatorReadShopLocatorRead | null;
  shopSocialNetworks?: ShopSocialNetworkJsonldEventLocatorReadShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
  distance?: number;
}

export interface ShopJsonldShopLocatorRead {
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  user?: UserJsonldShopLocatorRead | null;
  shopSocialNetworks?: ShopSocialNetworkJsonldShopLocatorRead[];
  /** @format ulid */
  id?: string | null;
  distance?: number;
}

export interface ShopJsonldShopRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserJsonldShopRead | null;
  logo?: MediaJsonldShopRead | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  identificationNumber?: string;
  taxNumber?: string;
  incorporationCertificate?: MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  logo?: MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  background?: MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  photos?: MediaJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  members?: ShopMemberJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  shopSocialNetworks?: ShopSocialNetworkJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  owner?: UserJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
}

export interface ShopJsonldShopStatRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  stats?: {
    sales?: number;
    events?: number;
    affiliates?: number;
  } | null;
}

export interface ShopJsonldShopWrite {
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  identificationNumber?: string;
  taxNumber?: string;
  /** @format iri-reference */
  incorporationCertificate?: string | null;
  /** @format iri-reference */
  logo?: string | null;
  /** @format iri-reference */
  background?: string | null;
  photos?: string[];
  shopSocialNetworks?: ShopSocialNetworkJsonldShopWrite[];
}

export interface ShopJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
}

export interface ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
}

export interface ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  user?: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  logo?: MediaJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopJsonldUserWriteShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  biography?: string | null;
  mobilityReducedAccessibility?: boolean;
  eatingSpace?: boolean;
  sanitary?: boolean | null;
  printOnDemand?: boolean | null;
  identificationNumber?: string;
  taxNumber?: string;
  /** @format iri-reference */
  incorporationCertificate?: string | null;
  /** @format iri-reference */
  logo?: string | null;
  /** @format iri-reference */
  background?: string | null;
  photos?: string[];
  shopSocialNetworks?: ShopSocialNetworkJsonldUserWriteShopWrite[];
}

export interface ShopJsonldUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
}

export interface ShopDeletionStatusShopDeletionStatusRead {
  sequence?: number | null;
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface ShopDeletionStatusJsonldShopDeletionStatusRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  sequence?: number | null;
  /** @format ulid */
  id?: string | null;
  label?: string;
}

export interface ShopDistributorShopDistributorRead {
  name?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopDistributorJsonldShopDistributorRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  name?: string;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopMemberShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  user: UserShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopMemberShopMemberRead {
  /** @format iri-reference */
  user: string | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopMemberShopMemberWrite {
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  shop: string | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
}

export interface ShopMemberJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user: UserJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopMemberJsonldShopMemberRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user: string | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
  /** @format ulid */
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ShopMemberJsonldShopMemberWrite {
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  shop: string | null;
  /**
   * @default "member"
   * @example "member"
   */
  status?: string;
}

export interface ShopSocialNetworkEventLocatorReadShopLocatorRead {
  socialNetwork?: SocialNetworkEventLocatorReadShopLocatorRead | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkShopLocatorRead {
  socialNetwork?: SocialNetworkShopLocatorRead | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  socialNetwork?: SocialNetworkShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  socialUrl?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ShopSocialNetworkShopWrite {
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkShopSocialNetworkRead {
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ShopSocialNetworkShopSocialNetworkWrite {
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkUserWriteShopWrite {
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  socialNetwork?: SocialNetworkJsonldEventLocatorReadShopLocatorRead | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkJsonldShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  socialNetwork?: SocialNetworkJsonldShopLocatorRead | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  socialNetwork?: SocialNetworkJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  socialUrl?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ShopSocialNetworkJsonldShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkJsonldShopSocialNetworkRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface ShopSocialNetworkJsonldShopSocialNetworkWrite {
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface ShopSocialNetworkJsonldUserWriteShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  socialNetwork?: string | null;
  socialUrl?: string | null;
}

export interface SocialNetworkEventLocatorReadShopLocatorRead {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkShopLocatorRead {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  isConnect?: boolean | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkSocialNetworkRead {
  isConnect?: boolean | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkJsonldShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  isConnect?: boolean | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export interface SocialNetworkJsonldSocialNetworkRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  isConnect?: boolean | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
}

export type Survey = object;

export interface SurveySurveyRead {
  name?: string;
  users?: string[];
  /** @format iri-reference */
  surveyType?: string | null;
  isPublic: boolean | null;
  isActive: boolean | null;
  hasReplied?: boolean | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  google_form_id?: any;
}

export interface SurveySurveyWrite {
  name?: string;
  users?: string[];
  /** @format iri-reference */
  surveyType?: string | null;
  isPublic: boolean | null;
  isActive: boolean | null;
  translations?: Record<string, SurveyTranslationSurveyWrite>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  google_form_id?: any;
}

export interface SurveyJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface SurveyJsonldSurveyRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  name?: string;
  users?: string[];
  /** @format iri-reference */
  surveyType?: string | null;
  isPublic: boolean | null;
  isActive: boolean | null;
  hasReplied?: boolean | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  google_form_id?: any;
}

export interface SurveyJsonldSurveyWrite {
  name?: string;
  users?: string[];
  /** @format iri-reference */
  surveyType?: string | null;
  isPublic: boolean | null;
  isActive: boolean | null;
  translations?: Record<string, SurveyTranslationJsonldSurveyWrite>;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  google_form_id?: any;
}

export interface SurveyTranslationSurveyWrite {
  googleFormId?: string;
  locale?: string;
}

export interface SurveyTranslationJsonldSurveyWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  googleFormId?: string;
  locale?: string;
}

export interface SurveyTypeSurveyTypeRead {
  name?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface SurveyTypeJsonldSurveyTypeRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  name?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface TagTagRead {
  parent?: TagTagRead | null;
  children?: TagTagRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface TagJsonldTagRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  parent?: TagJsonldTagRead | null;
  children?: TagJsonldTagRead[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  name?: string;
  description?: string | null;
}

export interface TokenDeviceTokenDeviceRead {
  device: string;
  token: string;
  /** @format iri-reference */
  user: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface TokenDeviceTokenDeviceWrite {
  device: string;
  token: string;
  /** @format iri-reference */
  user: string | null;
}

export interface TokenDeviceJsonldTokenDeviceRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  device: string;
  token: string;
  /** @format iri-reference */
  user: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface TokenDeviceJsonldTokenDeviceWrite {
  device: string;
  token: string;
  /** @format iri-reference */
  user: string | null;
}

export interface UserDeckUserListRead {
  /** @format ulid */
  id?: string;
}

export interface UserDeckUserListReadDeckUserListDetailRead {
  /** @format ulid */
  id?: string;
}

export interface UserEventLocatorReadShopLocatorRead {
  avatarPath?: string;
  addresses?: AddressEventLocatorReadShopLocatorRead[];
  shop?: ShopEventLocatorReadShopLocatorRead | null;
  uniqueId?: string | null;
}

export interface UserEventRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressEventRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserEventReadAddressReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserEventReadEventFormatReadIllustrationRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressEventReadEventFormatReadIllustrationRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserEventUserRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserGameRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserNotificationRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserOwnerExchangeRequestRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserOwnerHistoryGroupRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserPrintingOrderRead {
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserPrintingOrderPartnerRead {
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserPrintingPageReadPrintingOrderPartnerRead {
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserShopLocatorRead {
  avatarPath?: string;
  addresses?: AddressShopLocatorRead[];
  uniqueId?: string | null;
}

export interface UserShopRead {
  avatarPath?: string;
  addresses?: AddressShopRead[];
  organizedEvents?: EventShopRead[];
}

export interface UserShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  /** @format ulid */
  id?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /** @format date-time */
  lastConnection?: string | null;
  addresses?: AddressShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  organizedEvents?: EventShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  shop?: ShopShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  fullName?: string | null;
}

export interface UserUserPrivateRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile: UserProfileUserPrivateRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageUserPrivateRead | null;
  userGroups?: string[];
  userOptins?: string[];
  addresses?: AddressUserPrivateRead[];
  userSocialNetworks?: string[];
  userTokens?: string[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressUserPrivateRead;
  billingAddress?: AddressUserPrivateRead;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @example "EUR" */
  currency?: 'EUR' | 'USD' | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserUserPrivateReadUserTokenRead {
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileUserPrivateReadUserTokenRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageUserPrivateReadUserTokenRead | null;
  userGroups?: string[];
  userOptins?: UserOptinUserPrivateReadUserTokenRead[];
  addresses?: AddressUserPrivateReadUserTokenRead[];
  userSocialNetworks?: string[];
  userTokens?: UserTokenUserPrivateReadUserTokenRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressUserPrivateReadUserTokenRead;
  billingAddress?: AddressUserPrivateReadUserTokenRead;
  affiliateShop?: ShopUserPrivateReadUserTokenRead | null;
  shop?: ShopUserPrivateReadUserTokenRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserUserRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
}

export interface UserUserReadUserPrivateRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile: UserProfileUserReadUserPrivateRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageUserReadUserPrivateRead | null;
  userGroups?: string[];
  userOptins?: string[];
  addresses?: AddressUserReadUserPrivateRead[];
  userSocialNetworks?: string[];
  userTokens?: string[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressUserReadUserPrivateRead;
  billingAddress?: AddressUserReadUserPrivateRead;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  /** @example "EUR" */
  currency?: 'EUR' | 'USD' | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  userGroups?: string[];
  userOptins?: UserOptinUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  addresses?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  userSocialNetworks?: UserSocialNetworkUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  userTokens?: UserTokenUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead;
  billingAddress?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead;
  affiliateShop?: ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  shop?: ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  country?: CountryUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  nationalityCountry?: CountryUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  language?: LanguageUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  userGroups?: string[];
  userOptins?: UserOptinUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  addresses?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  userSocialNetworks?: UserSocialNetworkUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  userTokens?: UserTokenUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  organizedEvents?: EventUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead;
  billingAddress?: AddressUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead;
  affiliateShop?: ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  shop?: ShopUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserUserReadUserFriendshipRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  totalFriends?: number;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  userFriendship?: UserUserReadUserFriendshipRead;
}

export interface UserUserStatRead {
  inMyTradelist?: number | null;
  events?: number | null;
}

export interface UserUserWrite {
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  password?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  /** @format date-time */
  birthDate?: string;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  /** @format iri-reference */
  language?: string | null;
  userGroups?: string[];
  userOptins?: UserOptinUserWrite[];
  optins?: string[];
  addresses?: string[];
  userSocialNetworks?: UserSocialNetworkUserWrite[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  faction?: string[];
}

export interface UserUserWriteShopWrite {
  description?: string | null;
  email?: string;
  password?: string | null;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  /** @format date-time */
  birthDate?: string;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  /** @format iri-reference */
  language?: string | null;
  userGroups?: string[];
  userOptins?: UserOptinUserWriteShopWrite[];
  optins?: string[];
  addresses?: string[];
  userSocialNetworks?: UserSocialNetworkUserWriteShopWrite[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  affiliateShop?: ShopUserWriteShopWrite | null;
  shop?: ShopUserWriteShopWrite | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  faction?: string[];
}

export interface UserUserBlockedRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserUserFriendRequestRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserUserFriendshipReadUserRead {
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  totalFriends?: number;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  userFriendship?: UserUserFriendshipReadUserRead;
}

export interface UserUserTokenRead {
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  userOptins?: UserOptinUserTokenRead[];
  shop?: ShopUserTokenRead | null;
  provenance?: string | null;
}

export interface UserUserTokenWrite {
  optins?: string[];
}

export interface UserSumsubTokenUserRead {
  token?: string;
  userId?: string;
}

export interface UserSumsubTokenJsonldUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token?: string;
  userId?: string;
}

export interface UserUserGameStatsUserGameStatsRead {
  factionPlayed?: FactionPlayedUserGameStatsRead[];
  gamesWin?: number;
  gamesLost?: number;
  totalGame?: number;
}

export interface UserUserGameStatsJsonldUserGameStatsRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  factionPlayed?: FactionPlayedJsonldUserGameStatsRead[];
  gamesWin?: number;
  gamesLost?: number;
  totalGame?: number;
}

export interface UserUserUniqueEmailUserUniqueEmailRead {
  /**
   * @default true
   * @example true
   */
  isUnique?: boolean;
  hasGoogleAccount?: boolean;
}

export interface UserUserUniqueEmailJsonldUserUniqueEmailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default true
   * @example true
   */
  isUnique?: boolean;
  hasGoogleAccount?: boolean;
}

export interface UserUserUniqueNicknameUserUniqueNicknameRead {
  /**
   * @default true
   * @example true
   */
  isUnique?: boolean;
}

export interface UserUserUniqueNicknameJsonldUserUniqueNicknameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @default true
   * @example true
   */
  isUnique?: boolean;
}

export interface UserZendeskJwtUserRead {
  jwt?: string;
}

export interface UserZendeskJwtJsonldUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  jwt?: string;
}

export interface UserJsonldDeckUserListRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
}

export interface UserJsonldDeckUserListReadDeckUserListDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
}

export interface UserJsonldEventLocatorReadShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  avatarPath?: string;
  addresses?: AddressJsonldEventLocatorReadShopLocatorRead[];
  shop?: ShopJsonldEventLocatorReadShopLocatorRead | null;
  uniqueId?: string | null;
}

export interface UserJsonldEventRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressJsonldEventRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserJsonldEventReadAddressReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressJsonldEventReadAddressReadEventFormatReadIllustrationRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserJsonldEventReadEventFormatReadIllustrationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  addresses?: AddressJsonldEventReadEventFormatReadIllustrationRead[];
  /** @format iri-reference */
  shop?: string | null;
  uniqueId?: string | null;
}

export interface UserJsonldEventUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserJsonldGameRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserJsonldNotificationRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserJsonldOwnerExchangeRequestRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  avatarPath?: string;
  uniqueId?: string | null;
}

export interface UserJsonldOwnerHistoryGroupRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserJsonldPrintingOrderRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserJsonldPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserJsonldPrintingPageReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
}

export interface UserJsonldShopLocatorRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  avatarPath?: string;
  addresses?: AddressJsonldShopLocatorRead[];
  uniqueId?: string | null;
}

export interface UserJsonldShopRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  avatarPath?: string;
  addresses?: AddressJsonldShopRead[];
  organizedEvents?: EventJsonldShopRead[];
}

export interface UserJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /** @format date-time */
  lastConnection?: string | null;
  addresses?: AddressJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  organizedEvents?: EventJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  shop?: ShopJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  fullName?: string | null;
}

export interface UserJsonldUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile: UserProfileJsonldUserPrivateRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageJsonldUserPrivateRead | null;
  userGroups?: string[];
  userOptins?: string[];
  addresses?: AddressJsonldUserPrivateRead[];
  userSocialNetworks?: string[];
  userTokens?: string[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressJsonldUserPrivateRead;
  billingAddress?: AddressJsonldUserPrivateRead;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @example "EUR" */
  currency?: 'EUR' | 'USD' | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileJsonldUserPrivateReadUserTokenRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageJsonldUserPrivateReadUserTokenRead | null;
  userGroups?: string[];
  userOptins?: UserOptinJsonldUserPrivateReadUserTokenRead[];
  addresses?: AddressJsonldUserPrivateReadUserTokenRead[];
  userSocialNetworks?: string[];
  userTokens?: UserTokenJsonldUserPrivateReadUserTokenRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressJsonldUserPrivateReadUserTokenRead;
  billingAddress?: AddressJsonldUserPrivateReadUserTokenRead;
  affiliateShop?: ShopJsonldUserPrivateReadUserTokenRead | null;
  shop?: ShopJsonldUserPrivateReadUserTokenRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserJsonldUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
}

export interface UserJsonldUserReadUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile: UserProfileJsonldUserReadUserPrivateRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageJsonldUserReadUserPrivateRead | null;
  userGroups?: string[];
  userOptins?: string[];
  addresses?: AddressJsonldUserReadUserPrivateRead[];
  userSocialNetworks?: string[];
  userTokens?: string[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressJsonldUserReadUserPrivateRead;
  billingAddress?: AddressJsonldUserReadUserPrivateRead;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  /** @example "EUR" */
  currency?: 'EUR' | 'USD' | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  language?: LanguageJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  userGroups?: string[];
  userOptins?: UserOptinJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  addresses?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  userSocialNetworks?: UserSocialNetworkJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  userTokens?: UserTokenJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead;
  billingAddress?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead;
  affiliateShop?: ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  shop?: ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  description?: string | null;
  email?: string;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  avatarPath?: string;
  /** @format date-time */
  birthDate?: string;
  isActive?: boolean | null;
  /** @format date-time */
  activation?: string | null;
  userProfile?: UserProfileJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  roles?: string[];
  /** @format date-time */
  emailUpdatedAt?: string | null;
  country?: CountryJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  nationalityCountry?: CountryJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  language?: LanguageJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  userGroups?: string[];
  userOptins?: UserOptinJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  addresses?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  userSocialNetworks?: UserSocialNetworkJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  userTokens?: UserTokenJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  organizedEvents?: EventJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  isProfessional?: boolean | null;
  shippingAddress?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead;
  billingAddress?: AddressJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead;
  affiliateShop?: ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  shop?: ShopJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  provenance?: string | null;
  /** @example "EUR" */
  currency?: string | null;
  userFriendRequestsSend?: string[];
  userFriendRequestsReceive?: string[];
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  walletEligible?: boolean;
  walletActivated?: boolean;
  betaTester?: boolean | null;
  verified?: boolean | null;
  faction?: string[];
}

export interface UserJsonldUserReadUserFriendshipRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  totalFriends?: number;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  userFriendship?: UserJsonldUserReadUserFriendshipRead;
}

export interface UserJsonldUserStatRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  inMyTradelist?: number | null;
  events?: number | null;
}

export interface UserJsonldUserWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 300
   */
  description?: string | null;
  /** @format email */
  email?: string;
  password?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  /**
   * @minLength 0
   * @maxLength 10
   */
  civility?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 20
   */
  cellPhone?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  /** @format date-time */
  birthDate?: string;
  /** @format iri-reference */
  country: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  /** @format iri-reference */
  language?: string | null;
  userGroups?: string[];
  userOptins?: UserOptinJsonldUserWrite[];
  optins?: string[];
  addresses?: string[];
  userSocialNetworks?: UserSocialNetworkJsonldUserWrite[];
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  /** @format iri-reference */
  affiliateShop?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  faction?: string[];
}

export interface UserJsonldUserWriteShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  description?: string | null;
  email?: string;
  password?: string | null;
  nickName?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  civility?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  /** @format iri-reference */
  avatar?: string | null;
  /** @format date-time */
  birthDate?: string;
  /** @format iri-reference */
  country?: string | null;
  /** @format iri-reference */
  nationalityCountry?: string | null;
  /** @format iri-reference */
  language?: string | null;
  userGroups?: string[];
  userOptins?: UserOptinJsonldUserWriteShopWrite[];
  optins?: string[];
  addresses?: string[];
  userSocialNetworks?: UserSocialNetworkJsonldUserWriteShopWrite[];
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  affiliateShop?: ShopJsonldUserWriteShopWrite | null;
  shop?: ShopJsonldUserWriteShopWrite | null;
  twoFactorMethod?: 'EMAIL' | 'AUTHENTICATOR' | null;
  fullName?: string | null;
  faction?: string[];
}

export interface UserJsonldUserBlockedRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserJsonldUserFriendRequestRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
}

export interface UserJsonldUserFriendshipReadUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format ulid */
  id?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  nickName?: string | null;
  avatarPath?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  biography?: string | null;
  /** @format iri-reference */
  background?: string | null;
  backgroundPath?: string | null;
  /** @format iri-reference */
  shop?: string | null;
  totalFriends?: number;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  friendStatus?: 'PENDING' | 'SENDING' | 'ACCEPTED' | 'NONE' | 'BLOCKED' | 'REFUSED';
  uniqueId?: string | null;
  userFriendship?: UserJsonldUserFriendshipReadUserRead;
}

export interface UserJsonldUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string | null;
  userOptins?: UserOptinJsonldUserTokenRead[];
  shop?: ShopJsonldUserTokenRead | null;
  provenance?: string | null;
}

export interface UserJsonldUserTokenWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  optins?: string[];
}

export interface UserAccessUserAccessRead {
  name: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface UserAccessJsonldUserAccessRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  name: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
}

export interface UserBlocked {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  blockedUser?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserBlockedUserBlockedRead {
  blockedUser?: UserUserBlockedRead | null;
}

export interface UserBlockedJsonld {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  blockedUser?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserBlockedJsonldUserBlockedRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  blockedUser?: UserJsonldUserBlockedRead | null;
}

export interface UserFriendRequestUserFriendRequestRead {
  sender?: UserUserFriendRequestRead | null;
  receiver?: UserUserFriendRequestRead | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  status?: 'PENDING' | 'ACCEPTED' | 'NONE' | 'REFUSED';
  /**
   * @default true
   * @example true
   */
  accept?: boolean;
}

export interface UserFriendRequestUserFriendRequestWrite {
  /** @format iri-reference */
  receiver?: string | null;
  /**
   * @default true
   * @example true
   */
  accept?: boolean;
}

export interface UserFriendRequestJsonldUserFriendRequestRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  sender?: UserJsonldUserFriendRequestRead | null;
  receiver?: UserJsonldUserFriendRequestRead | null;
  /**
   * @default "NONE"
   * @example "NONE"
   */
  status?: 'PENDING' | 'ACCEPTED' | 'NONE' | 'REFUSED';
  /**
   * @default true
   * @example true
   */
  accept?: boolean;
}

export interface UserFriendRequestJsonldUserFriendRequestWrite {
  /** @format iri-reference */
  receiver?: string | null;
  /**
   * @default true
   * @example true
   */
  accept?: boolean;
}

export interface UserFriendshipUserFriendshipReadUserRead {
  userFriend?: UserUserFriendshipReadUserRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserFriendshipJsonldUserFriendshipReadUserRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  userFriend?: UserJsonldUserFriendshipReadUserRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserGroupUserGroupRead {
  users?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface UserGroupJsonldUserGroupRead {
  '@id'?: string;
  '@type'?: string;
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  users?: string[];
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
}

export interface UserOptinUserPrivateReadUserTokenRead {
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserOptinUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  user: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  user: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinUserWrite {
  user: UserUserWrite | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinUserWriteShopWrite {
  user: UserUserWriteShopWrite | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinUserOptinRead {
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinUserOptinWrite {
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserOptinUserTokenRead {
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserOptinJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserOptinJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinJsonldUserWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user: UserJsonldUserWrite | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinJsonldUserWriteShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user: UserJsonldUserWriteShopWrite | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinJsonldUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserOptinJsonldUserOptinWrite {
  /** @format iri-reference */
  user: string | null;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserOptinJsonldUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  optin: string | null;
  value: boolean | null;
}

export interface UserProfileOptinRead {
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference:
    | 'ROLE_CUSTOMER'
    | 'ROLE_SHOP'
    | 'ROLE_SHOP_OWNER'
    | 'ROLE_SHOP_MEMBER'
    | 'ROLE_BGA'
    | 'ROLE_SHOP_ARTIST'
    | 'ROLE_PROD_PARTNER';
}

export type UserProfileUserPrivateRead = object;

export type UserProfileUserPrivateReadUserTokenRead = object;

export type UserProfileUserReadUserPrivateRead = object;

export type UserProfileUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead = object;

export type UserProfileUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead =
  object;

export interface UserProfileJsonldOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /**
   * @minLength 0
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:_[a-zA-Z0-9]+)*)$
   */
  reference:
    | 'ROLE_CUSTOMER'
    | 'ROLE_SHOP'
    | 'ROLE_SHOP_OWNER'
    | 'ROLE_SHOP_MEMBER'
    | 'ROLE_BGA'
    | 'ROLE_SHOP_ARTIST'
    | 'ROLE_PROD_PARTNER';
}

export interface UserProfileJsonldUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface UserProfileJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface UserProfileJsonldUserReadUserPrivateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface UserProfileJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface UserProfileJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
}

export interface UserRewardSeasonPassRead {
  reward?: RewardSeasonPassRead | null;
}

export interface UserRewardUserRewardRead {
  /** @format iri-reference */
  user?: string | null;
  reward?: RewardUserRewardRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserRewardJsonldSeasonPassRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  reward?: RewardJsonldSeasonPassRead | null;
}

export interface UserRewardJsonldUserRewardRead {
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string | null;
  reward?: RewardJsonldUserRewardRead | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserSocialNetworkUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  user?: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  user?: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkUserWrite {
  user?: UserUserWrite | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkUserWriteShopWrite {
  user?: UserUserWriteShopWrite | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkUserSocialNetworkRead {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkUserSocialNetworkWrite {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user?: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user?: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user?: UserJsonldUserWrite | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserWriteShopWrite {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  user?: UserJsonldUserWriteShopWrite | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserSocialNetworkRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserSocialNetworkJsonldUserSocialNetworkWrite {
  /** @format iri-reference */
  user?: string | null;
  /** @format iri-reference */
  socialNetwork?: string | null;
  connectId?: string | null;
  socialUrl?: string | null;
}

export interface UserTokenUserPrivateReadUserTokenRead {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserUserPrivateReadUserTokenRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenUserTokenCreateRead {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
}

export interface UserTokenUserTokenRead {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserUserTokenRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenUserTokenWrite {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  code?: string | null;
  /** @format date-time */
  ttl: string;
  user?: UserUserTokenWrite | null;
}

export interface UserTokenJsonldUserPrivateReadUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserJsonldUserPrivateReadUserTokenRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenJsonldUserTokenCreateRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
}

export interface UserTokenJsonldUserTokenRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  /** @format date-time */
  ttl: string;
  user?: UserJsonldUserTokenRead | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format ulid */
  id?: string | null;
}

export interface UserTokenJsonldUserTokenWrite {
  token: string;
  type:
    | 'activation-code'
    | 'activation-link'
    | 'newsletter'
    | 'kickstarter'
    | 'activation-shop-member'
    | 'authorization-iban';
  code?: string | null;
  /** @format date-time */
  ttl: string;
  user?: UserJsonldUserTokenWrite | null;
}

export interface Wallet {
  id?: string | null;
  balance?: number;
  marketplaceBalance?: number;
  rechargeBalance?: number;
  podBalance?: number;
  currency?: string | null;
  twoFactorEnabled?: boolean;
  billingAddress?: boolean;
  shippingAddress?: boolean;
  walletCreated?: boolean;
  optin?: boolean;
}

export interface WalletPaymentWalletRead {
  id?: string | null;
  balance?: number;
  marketplaceBalance?: number;
  rechargeBalance?: number;
  podBalance?: number;
  currency?: string | null;
  twoFactorEnabled?: boolean;
  billingAddress?: boolean;
  shippingAddress?: boolean;
  walletCreated?: boolean;
}

export interface WalletPaymentWalletWrite {
  optin?: boolean;
}

export interface WalletJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string | null;
  balance?: number;
  marketplaceBalance?: number;
  rechargeBalance?: number;
  podBalance?: number;
  currency?: string | null;
  twoFactorEnabled?: boolean;
  billingAddress?: boolean;
  shippingAddress?: boolean;
  walletCreated?: boolean;
  optin?: boolean;
}

export interface WalletJsonldPaymentWalletRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  id?: string | null;
  balance?: number;
  marketplaceBalance?: number;
  rechargeBalance?: number;
  podBalance?: number;
  currency?: string | null;
  twoFactorEnabled?: boolean;
  billingAddress?: boolean;
  shippingAddress?: boolean;
  walletCreated?: boolean;
}

export interface WalletJsonldPaymentWalletWrite {
  optin?: boolean;
}

export interface WalletTransaction {
  mgpId?: string | null;
  marketplaceOrder?: MarketplaceOrder | null;
  /** @format iri-reference */
  printingOrder?: string | null;
  /** @format iri-reference */
  invoice?: string | null;
  currency?: string;
  /** @format iri-reference */
  user?: string | null;
  amount?: number;
  type?: string;
  status?: string;
  tag?: string | null;
  /** @format date-time */
  date?: string;
  mangopayUrl?: string | null;
  /** @format ulid */
  id?: string | null;
  mangoType?: string | null;
  printingOrderId?: string | null;
}

export interface WalletTransactionPaymentWalletTransactionRead {
  currency?: string;
  amount?: number;
  type?: string;
  status?: string;
  /** @format date-time */
  date?: string;
  /** @format ulid */
  id?: string | null;
  printingOrderId?: string | null;
}

export interface WalletTransactionWalletDetailPaymentDetailPayinRead {
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  amountTTC?: number;
  amountHT?: number;
  methodPayment?: PaymentCardPaymentDetailPayinRead;
  mangopayFee?: number;
  alteredFee?: number;
}

export interface WalletTransactionWalletDetailPaymentDetailPayoutRead {
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  amountTTC?: number;
  amountHT?: number;
  bankAccount?: BankAccountPaymentDetailPayoutRead | null;
  payoutFee?: number;
}

export interface WalletTransactionWalletDetailPaymentDetailRead {
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  alteredFee?: number;
  type?: string;
  unitPrice?: number;
  totalPrice?: number;
  quantity?: number;
  card?: CardPaymentDetailRead | null;
}

export interface WalletTransactionWalletDetailJsonldPaymentDetailPayinRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  amountTTC?: number;
  amountHT?: number;
  methodPayment?: PaymentCardJsonldPaymentDetailPayinRead;
  mangopayFee?: number;
  alteredFee?: number;
}

export interface WalletTransactionWalletDetailJsonldPaymentDetailPayoutRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  amountTTC?: number;
  amountHT?: number;
  bankAccount?: BankAccountJsonldPaymentDetailPayoutRead | null;
  payoutFee?: number;
}

export interface WalletTransactionWalletDetailJsonldPaymentDetailRead {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  /** @format date-time */
  date?: string;
  reference?: string;
  /** @format ulid */
  invoiceId?: string | null;
  alteredFee?: number;
  type?: string;
  unitPrice?: number;
  totalPrice?: number;
  quantity?: number;
  card?: CardJsonldPaymentDetailRead | null;
}

export interface WalletTransactionJsonld {
  '@context'?:
    | string
    | {
        '@vocab': string;
        hydra: 'http://www.w3.org/ns/hydra/core#';
        [key: string]: any;
      };
  '@id'?: string;
  '@type'?: string;
  mgpId?: string | null;
  marketplaceOrder?: MarketplaceOrderJsonld | null;
  /** @format iri-reference */
  printingOrder?: string | null;
  /** @format iri-reference */
  invoice?: string | null;
  currency?: string;
  /** @format iri-reference */
  user?: string | null;
  amount?: number;
  type?: string;
  status?: string;
  tag?: string | null;
  /** @format date-time */
  date?: string;
  mangopayUrl?: string | null;
  /** @format ulid */
  id?: string | null;
  mangoType?: string | null;
  printingOrderId?: string | null;
}

export interface WalletTransactionJsonldPaymentWalletTransactionRead {
  '@id'?: string;
  '@type'?: string;
  currency?: string;
  amount?: number;
  type?: string;
  status?: string;
  /** @format date-time */
  date?: string;
  /** @format ulid */
  id?: string | null;
  printingOrderId?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '/';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Altered
 * @version 0.0.3
 * @baseUrl /
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  addresses = {
    /**
     * @description Retrieves the collection of Address resources.
     *
     * @tags Address
     * @name ApiAddressesGetCollection
     * @summary Retrieves the collection of Address resources.
     * @request GET:/addresses
     * @secure
     */
    apiAddressesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        zipCode?: string;
        city?: string;
        'country.reference'?: string;
        'country.reference[]'?: string[];
        isDefaultBilling?: boolean;
        'isDefaultBilling[]'?: boolean[];
        isDefaultShipping?: boolean;
        'isDefaultShipping[]'?: boolean[];
        'order[zipCode]'?: 'asc' | 'desc';
        'order[city]'?: 'asc' | 'desc';
        'order[country.reference]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        /** This filter search all the eligible address for the current user. */
        isEligible?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': AddressJsonldAddressReadAddressWrite[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/addresses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Address resource.
     *
     * @tags Address
     * @name ApiAddressesIdGet
     * @summary Retrieves a Address resource.
     * @request GET:/addresses/{id}
     * @secure
     */
    apiAddressesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<AddressJsonldAddressReadAddressWrite, void>({
        path: `/addresses/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Address resource.
     *
     * @tags Address
     * @name ApiAddressesIdPut
     * @summary Replaces the Address resource.
     * @request PUT:/addresses/{id}
     * @secure
     */
    apiAddressesIdPut: (id: string, data: AddressJsonldAddressWrite, params: RequestParams = {}) =>
      this.request<AddressJsonldAddressReadAddressWrite, void>({
        path: `/addresses/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the Address resource.
     *
     * @tags Address
     * @name ApiAddressesIdDelete
     * @summary Removes the Address resource.
     * @request DELETE:/addresses/{id}
     * @secure
     */
    apiAddressesIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/addresses/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  badges = {
    /**
     * @description Retrieves a Badge resource.
     *
     * @tags Badge
     * @name ApiBadgesIdGet
     * @summary Retrieves a Badge resource.
     * @request GET:/badges/{id}
     * @secure
     */
    apiBadgesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<BadgeJsonldBadgeRead, void>({
        path: `/badges/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardElementTypes = {
    /**
     * @description Retrieves the collection of CardElementType resources.
     *
     * @tags CardElementType
     * @name ApiCardElementTypesGetCollection
     * @summary Retrieves the collection of CardElementType resources.
     * @request GET:/card_element_types
     * @secure
     */
    apiCardElementTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardElementTypeJsonldCardElementTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_element_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardElements = {
    /**
     * @description Retrieves a CardElement resource.
     *
     * @tags CardElement
     * @name ApiCardElementsIdGet
     * @summary Retrieves a CardElement resource.
     * @request GET:/card_elements/{id}
     * @secure
     */
    apiCardElementsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<CardElementJsonldCardElementRead, void>({
        path: `/card_elements/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardExports = {
    /**
     * @description Retrieves a InDesign resource.
     *
     * @tags InDesign
     * @name ApiCardExportsIdGet
     * @summary Retrieves a InDesign resource.
     * @request GET:/card_exports/{id}
     * @secure
     */
    apiCardExportsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<InDesignJsonldCardExportRead, void>({
        path: `/card_exports/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the InDesign resource.
     *
     * @tags InDesign
     * @name ApiCardExportsIdPut
     * @summary Replaces the InDesign resource.
     * @request PUT:/card_exports/{id}
     * @secure
     */
    apiCardExportsIdPut: (id: string, data: InDesignJsonldCardExportWrite, params: RequestParams = {}) =>
      this.request<InDesignJsonldCardExportRead, void>({
        path: `/card_exports/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Informations from Card Set.
     *
     * @tags InDesign
     * @name ApiCardExportsIddataGet
     * @summary Get informations of Card Set for collection
     * @request GET:/card_exports/{id}/data
     * @secure
     */
    apiCardExportsIddataGet: (id: string, params: RequestParams = {}) =>
      this.request<InDesignJsonldCardExportRead, void>({
        path: `/card_exports/${id}/data`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardProducts = {
    /**
     * @description Retrieves the collection of CardProduct resources.
     *
     * @tags CardProduct
     * @name ApiCardProductsGetCollection
     * @summary Retrieves the collection of CardProduct resources.
     * @request GET:/card_products
     * @secure
     */
    apiCardProductsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'order[reference]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardProductJsonldCardProductRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a CardProduct resource.
     *
     * @tags CardProduct
     * @name ApiCardProductsIdGet
     * @summary Retrieves a CardProduct resource.
     * @request GET:/card_products/{id}
     * @secure
     */
    apiCardProductsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<CardProductJsonldCardProductRead, void>({
        path: `/card_products/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardSets = {
    /**
     * @description Retrieves the collection of CardSet resources.
     *
     * @tags CardSet
     * @name ApiCardSetsGetCollection
     * @summary Retrieves the collection of CardSet resources.
     * @request GET:/card_sets
     * @secure
     */
    apiCardSetsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'translations.name'?: string;
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        isActive?: boolean;
        'isActive[]'?: boolean[];
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[date]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'date[before]'?: string;
        'date[strictly_before]'?: string;
        'date[after]'?: string;
        'date[strictly_after]'?: string;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'groups[]'?: (
          | 'lore_entry:read'
          | 'lore_entry_lore_entry_element:read'
          | 'lore_entry_type:read'
          | 'lore_entry_status:read'
          | 'illustration_lore_entry:read'
          | 'faction:read'
          | 'tag:read'
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardSetJsonldCardSetRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_sets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Informations from Card Set.
     *
     * @tags CardSet
     * @name ApiCardSetscollectionsGetCollection
     * @summary Get informations of Card Set for collection
     * @request GET:/card_sets/collections
     * @secure
     */
    apiCardSetscollectionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'translations.name'?: string;
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        isActive?: boolean;
        'isActive[]'?: boolean[];
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[date]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'date[before]'?: string;
        'date[strictly_before]'?: string;
        'date[after]'?: string;
        'date[strictly_after]'?: string;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'groups[]'?: (
          | 'lore_entry:read'
          | 'lore_entry_lore_entry_element:read'
          | 'lore_entry_type:read'
          | 'lore_entry_status:read'
          | 'illustration_lore_entry:read'
          | 'faction:read'
          | 'tag:read'
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardSetCardSetDataJsonldCardSetCollectionRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_sets/collections`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardTypes = {
    /**
     * @description Retrieves the collection of CardType resources.
     *
     * @tags CardType
     * @name ApiCardTypesGetCollection
     * @summary Retrieves the collection of CardType resources.
     * @request GET:/card_types
     * @secure
     */
    apiCardTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardTypeJsonldCardTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardUserListCards = {
    /**
     * @description Retrieves the collection of CardUserListCard resources.
     *
     * @tags CardUserListCard
     * @name ApiCardUserListCardsGetCollection
     * @summary Retrieves the collection of CardUserListCard resources.
     * @request GET:/card_user_list_cards
     * @secure
     */
    apiCardUserListCardsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardUserListCardJsonldCardUserListCardRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_user_list_cards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add multiple Cards in a specific list for the current user.
     *
     * @tags CardUserListCard
     * @name ApiCardUserListCardsPost
     * @summary Add multiple Cards to a list
     * @request POST:/card_user_list_cards
     * @secure
     */
    apiCardUserListCardsPost: (
      data: CardUserListCardPostCardsUserListCardDataJsonldPostCardsUserListCardDataWrite,
      params: RequestParams = {},
    ) =>
      this.request<CardUserListCardJsonldCardUserListRead, void>({
        path: `/card_user_list_cards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a CardUserListCard resource.
     *
     * @tags CardUserListCard
     * @name ApiCardUserListCardsIdGet
     * @summary Retrieves a CardUserListCard resource.
     * @request GET:/card_user_list_cards/{id}
     * @secure
     */
    apiCardUserListCardsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<CardUserListCardJsonldCardUserListCardRead, void>({
        path: `/card_user_list_cards/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cardUserLists = {
    /**
     * @description Retrieves the collection of CardUserList resources.
     *
     * @tags CardUserList
     * @name ApiCardUserListsGetCollection
     * @summary Retrieves the collection of CardUserList resources.
     * @request GET:/card_user_lists
     * @secure
     */
    apiCardUserListsGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          'hydra:member': CardUserListJsonldCardUserListRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/card_user_lists`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the CardUserList resource.
     *
     * @tags CardUserList
     * @name ApiCardUserListsIdDelete
     * @summary Removes the CardUserList resource.
     * @request DELETE:/card_user_lists/{id}
     * @secure
     */
    apiCardUserListsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/card_user_lists/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Delete a specific card in a specific list for the current user.
     *
     * @tags CardUserList
     * @name ApiCardUserListsListNamecardsReferenceDelete
     * @summary Delete a Card in a List
     * @request DELETE:/card_user_lists/{listName}/cards/{reference}
     * @secure
     */
    apiCardUserListsListNamecardsReferenceDelete: (listName: string, reference: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/card_user_lists/${listName}/cards/${reference}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  cards = {
    /**
     * @description Retrieves the collection of Card resources.
     *
     * @tags Card
     * @name ApiCardsGetCollection
     * @summary Retrieves the collection of Card resources.
     * @request GET:/cards
     * @secure
     */
    apiCardsGetCollection: (
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @max 36
         * @default 30
         */
        itemsPerPage?: number;
        /** Filter Offer with missing card on deck */
        deckUserList?: string;
        /** Filter by MaxPrice */
        priceMax?: number;
        /** Filter by Card having Offers */
        inSale?: boolean;
        /** Filter by current user Offers */
        myOffer?: boolean;
        /** Filter by available in collection */
        collection?: boolean;
        /** Order by price */
        'order[price]'?: 'asc' | 'desc';
        /** Filter Offer with seller id */
        seller?: string;
        /** Filter foiled cards */
        foiled?: boolean;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        factions?: string;
        'factions[]'?: string[];
        'factions.reference'?: string;
        'factions.reference[]'?: string[];
        cardType?: string;
        'cardType[]'?: string[];
        'cardType.reference'?: string;
        'cardType.reference[]'?: string[];
        cardSubTypes?: string;
        'cardSubTypes[]'?: string[];
        cardSet?: string;
        'cardSet[]'?: string[];
        'cardSet.reference'?: string;
        'cardSet.reference[]'?: string[];
        rarity?: string;
        'rarity[]'?: string[];
        'rarity.reference'?: string;
        'rarity.reference[]'?: string[];
        'translations.name'?: string;
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[cardType.reference]'?: 'asc' | 'desc';
        'order[cardSubType.reference]'?: 'asc' | 'desc';
        'order[parent.reference]'?: 'asc' | 'desc';
        'order[cardSet.reference]'?: 'asc' | 'desc';
        'order[factions.reference]'?: 'asc' | 'desc';
        'order[cardUserListCards.createdAt]'?: 'asc' | 'desc';
        /**
         * This filter search a CardElement of type mainCost with value in the array
         * @example "['1', '3']"
         */
        mainCost?: string;
        /**
         * This filter search a CardElement of type recallCost with value in the array
         * @example "['1', '3']"
         */
        recallCost?: string;
        /**
         * This filter search a CardElement of type mountainPower with value in the array
         * @example "['1', '3']"
         */
        mountainPower?: string;
        /**
         * This filter search a CardElement of type oceanPower with value in the array
         * @example "['1', '3']"
         */
        oceanPower?: string;
        /**
         * This filter search a CardElement of type forestPower with value in the array
         * @example "['1', '3']"
         */
        forestPower?: string;
        /**
         * This filter search a CardKeyword of type mainEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        mainEffect?: string;
        /**
         * This filter search a CardKeyword of type echoEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        echoEffect?: string;
        /** Order cards by MAIN COST. */
        'order[mainCost]'?: 'asc' | 'desc';
        /** Order cards by RECALL COST. */
        'order[recallCost]'?: 'asc' | 'desc';
        /** Order cards by Last Added in Collection. */
        'order[collectionLatestAdded]'?: 'asc' | 'desc';
        /**
         * This filter search all the card in the given list name of the current user.
         * @example "wantlist"
         */
        'cardList.name'?: string;
        /**
         * This filter order the card list by sequence
         * @example "ASC | DESC"
         */
        'cardList.order'?: string;
        /** Get Exclusive Cards. */
        isExclusive?: boolean;
        /** Order by collectionNumber */
        'order[collectionNumber]'?: 'asc' | 'desc';
        /** Order by raritySequence */
        'order[raritySequence]'?: 'asc' | 'desc';
        /** Get Suspended Cards. */
        isSuspended?: boolean;
        /** Get cards by Card Product Reference. */
        cardProductReference?: string;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardJsonldCardRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List of all values needed to initiate card filters.
     *
     * @tags CardFilterData
     * @name ApiCardsfilterDataGetCollection
     * @summary Get the filter's data for Cards list
     * @request GET:/cards/filter-data
     * @secure
     */
    apiCardsfilterDataGetCollection: (
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardFilterDataJsonldCardFilterData[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards/filter-data`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Card resources.
     *
     * @tags Card
     * @name ApiCardsstatsGetCollection
     * @summary Get All Stats from the cards
     * @request GET:/cards/stats
     * @secure
     */
    apiCardsstatsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @max 36
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        factions?: string;
        'factions[]'?: string[];
        'factions.reference'?: string;
        'factions.reference[]'?: string[];
        cardType?: string;
        'cardType[]'?: string[];
        'cardType.reference'?: string;
        'cardType.reference[]'?: string[];
        cardSubTypes?: string;
        'cardSubTypes[]'?: string[];
        cardSet?: string;
        'cardSet[]'?: string[];
        'cardSet.reference'?: string;
        'cardSet.reference[]'?: string[];
        rarity?: string;
        'rarity[]'?: string[];
        'rarity.reference'?: string;
        'rarity.reference[]'?: string[];
        'translations.name'?: string;
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[cardType.reference]'?: 'asc' | 'desc';
        'order[cardSubType.reference]'?: 'asc' | 'desc';
        'order[parent.reference]'?: 'asc' | 'desc';
        'order[cardSet.reference]'?: 'asc' | 'desc';
        'order[factions.reference]'?: 'asc' | 'desc';
        'order[cardUserListCards.createdAt]'?: 'asc' | 'desc';
        /**
         * This filter search a CardElement of type mainCost with value in the array
         * @example "['1', '3']"
         */
        mainCost?: string;
        /**
         * This filter search a CardElement of type recallCost with value in the array
         * @example "['1', '3']"
         */
        recallCost?: string;
        /**
         * This filter search a CardElement of type mountainPower with value in the array
         * @example "['1', '3']"
         */
        mountainPower?: string;
        /**
         * This filter search a CardElement of type oceanPower with value in the array
         * @example "['1', '3']"
         */
        oceanPower?: string;
        /**
         * This filter search a CardElement of type forestPower with value in the array
         * @example "['1', '3']"
         */
        forestPower?: string;
        /**
         * This filter search a CardKeyword of type mainEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        mainEffect?: string;
        /**
         * This filter search a CardKeyword of type echoEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        echoEffect?: string;
        /** Order cards by MAIN COST. */
        'order[mainCost]'?: 'asc' | 'desc';
        /** Order cards by RECALL COST. */
        'order[recallCost]'?: 'asc' | 'desc';
        /** Order cards by Last Added in Collection. */
        'order[collectionLatestAdded]'?: 'asc' | 'desc';
        /**
         * This filter search all the card in the given list name of the current user.
         * @example "wantlist"
         */
        'cardList.name'?: string;
        /**
         * This filter order the card list by sequence
         * @example "ASC | DESC"
         */
        'cardList.order'?: string;
        /** Get Exclusive Cards. */
        isExclusive?: boolean;
        /** Order by collectionNumber */
        'order[collectionNumber]'?: 'asc' | 'desc';
        /** Order by raritySequence */
        'order[raritySequence]'?: 'asc' | 'desc';
        /** Get Suspended Cards. */
        isSuspended?: boolean;
        /** Get cards by Card Product Reference. */
        cardProductReference?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardJsonldCardStatRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards/stats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Card resource.
     *
     * @tags Card
     * @name ApiCardsReferenceGet
     * @summary Retrieves a Card resource.
     * @request GET:/cards/{reference}
     * @secure
     */
    apiCardsReferenceGet: (
      reference: string,
      query: {
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CardJsonldCardDetailRead, void>({
        path: `/cards/${reference}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Card resource.
     *
     * @tags Card
     * @name ApiCardsReferencecardHistoriesGet
     * @summary Retrieves a Card resource.
     * @request GET:/cards/{reference}/card_histories
     * @secure
     */
    apiCardsReferencecardHistoriesGet: (reference: string, params: RequestParams = {}) =>
      this.request<CardCardHistoryDataJsonldCardHistoryRead, void>({
        path: `/cards/${reference}/card_histories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Card resource.
     *
     * @tags Card
     * @name ApiCardsReferencefoilPost
     * @summary Creates a Card resource.
     * @request POST:/cards/{reference}/foil
     * @secure
     */
    apiCardsReferencefoilPost: (reference: string, data?: any, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/cards/${reference}/foil`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description List of all Offers for a Card.
     *
     * @tags MarketplaceOffer
     * @name ApiCardsReferenceoffersGetCollection
     * @summary Get Card Offers
     * @request GET:/cards/{reference}/offers
     * @secure
     */
    apiCardsReferenceoffersGetCollection: (
      reference: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        /** Filter Offer with missing card on deck */
        deckUserList?: string;
        /** Filter by MaxPrice */
        priceMax?: number;
        /** Filter by Card having Offers */
        inSale?: boolean;
        /** Filter by current user Offers */
        myOffer?: boolean;
        /** Filter by available in collection */
        collection?: boolean;
        /** Order by price */
        'order[price]'?: 'asc' | 'desc';
        /** Filter Offer with seller id */
        seller?: string;
        /** Filter foiled cards */
        foiled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': MarketplaceOfferJsonldMarketplaceOfferRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards/${reference}/offers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List of Offer for a Card.
     *
     * @tags MarketplaceOffer
     * @name ApiCardsReferenceoffersOfferIdGetCollection
     * @summary Get Card Offer Item
     * @request GET:/cards/{reference}/offers/{offerId}
     * @secure
     */
    apiCardsReferenceoffersOfferIdGetCollection: (
      reference: string,
      offerId: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': MarketplaceOfferJsonldMarketplaceOfferRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards/${reference}/offers/${offerId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Card resource.
     *
     * @tags Card
     * @name ApiCardsReferencestatsGet
     * @summary Retrieves a Card resource.
     * @request GET:/cards/{reference}/stats
     * @secure
     */
    apiCardsReferencestatsGet: (
      reference: string,
      query: {
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CardJsonldCardStatRead, void>({
        path: `/cards/${reference}/stats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Card resources.
     *
     * @tags Card
     * @name CardsReferenceVariants
     * @summary Get All Variants for one card
     * @request GET:/cards/{reference}/variants
     * @secure
     */
    cardsReferenceVariants: (
      reference: string,
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        factions?: string;
        'factions[]'?: string[];
        'factions.reference'?: string;
        'factions.reference[]'?: string[];
        cardType?: string;
        'cardType[]'?: string[];
        'cardType.reference'?: string;
        'cardType.reference[]'?: string[];
        cardSubTypes?: string;
        'cardSubTypes[]'?: string[];
        cardSet?: string;
        'cardSet[]'?: string[];
        'cardSet.reference'?: string;
        'cardSet.reference[]'?: string[];
        rarity?: string;
        'rarity[]'?: string[];
        'rarity.reference'?: string;
        'rarity.reference[]'?: string[];
        'translations.name'?: string;
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[cardType.reference]'?: 'asc' | 'desc';
        'order[cardSubType.reference]'?: 'asc' | 'desc';
        'order[parent.reference]'?: 'asc' | 'desc';
        'order[cardSet.reference]'?: 'asc' | 'desc';
        'order[factions.reference]'?: 'asc' | 'desc';
        'order[cardUserListCards.createdAt]'?: 'asc' | 'desc';
        /**
         * This filter search a CardElement of type mainCost with value in the array
         * @example "['1', '3']"
         */
        mainCost?: string;
        /**
         * This filter search a CardElement of type recallCost with value in the array
         * @example "['1', '3']"
         */
        recallCost?: string;
        /**
         * This filter search a CardElement of type mountainPower with value in the array
         * @example "['1', '3']"
         */
        mountainPower?: string;
        /**
         * This filter search a CardElement of type oceanPower with value in the array
         * @example "['1', '3']"
         */
        oceanPower?: string;
        /**
         * This filter search a CardElement of type forestPower with value in the array
         * @example "['1', '3']"
         */
        forestPower?: string;
        /**
         * This filter search a CardKeyword of type mainEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        mainEffect?: string;
        /**
         * This filter search a CardKeyword of type echoEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        echoEffect?: string;
        /** Order cards by MAIN COST. */
        'order[mainCost]'?: 'asc' | 'desc';
        /** Order cards by RECALL COST. */
        'order[recallCost]'?: 'asc' | 'desc';
        /** Order cards by Last Added in Collection. */
        'order[collectionLatestAdded]'?: 'asc' | 'desc';
        /**
         * This filter search all the card in the given list name of the current user.
         * @example "wantlist"
         */
        'cardList.name'?: string;
        /**
         * This filter order the card list by sequence
         * @example "ASC | DESC"
         */
        'cardList.order'?: string;
        /** Get Exclusive Cards. */
        isExclusive?: boolean;
        /** Order by collectionNumber */
        'order[collectionNumber]'?: 'asc' | 'desc';
        /** Order by raritySequence */
        'order[raritySequence]'?: 'asc' | 'desc';
        /** Get Suspended Cards. */
        isSuspended?: boolean;
        /** Get cards by Card Product Reference. */
        cardProductReference?: string;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardJsonldCardVariant[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/cards/${reference}/variants`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  cms = {
    /**
     * @description Retrieves a Modals resource.
     *
     * @tags CMS
     * @name ApiCmsmodalsGet
     * @summary Get a modal from the CMS
     * @request GET:/cms/modals
     * @secure
     */
    apiCmsmodalsGet: (
      query?: {
        url?: string;
        locale?: string;
        userContextHash?: string;
        page?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ModalsJsonldModalsGetList, void>({
        path: `/cms/modals`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Pages resource.
     *
     * @tags CMS
     * @name ApiCmspagesGet
     * @summary Get a page from the CMS
     * @request GET:/cms/pages
     * @secure
     */
    apiCmspagesGet: (
      query: {
        url: string;
        isMobileApp: boolean;
        locale?: string;
        userContextHash?: string;
        page?: string;
        inSale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagesJsonldPagesGetList, void>({
        path: `/cms/pages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  contacts = {
    /**
     * @description Creates a Contact resource.
     *
     * @tags Contact
     * @name ApiContactsPost
     * @summary Creates a Contact resource.
     * @request POST:/contacts
     * @secure
     */
    apiContactsPost: (data: ContactJsonldContactWrite, params: RequestParams = {}) =>
      this.request<ContactJsonldContactRead, void>({
        path: `/contacts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  countries = {
    /**
     * @description Retrieves the collection of Country resources.
     *
     * @tags Country
     * @name ApiCountriesGetCollection
     * @summary Retrieves the collection of Country resources.
     * @request GET:/countries
     * @secure
     */
    apiCountriesGetCollection: (
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        /** Enable or disable pagination */
        pagination?: boolean;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CountryJsonldCountryRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/countries`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Country resources.
     *
     * @tags Country
     * @name ApiCountrieslocatorGetCollection
     * @summary Retrieves the collection of Country resources.
     * @request GET:/countries/locator
     * @secure
     */
    apiCountrieslocatorGetCollection: (
      query: {
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CountryJsonldCountryRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/countries/locator`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Country resource.
     *
     * @tags Country
     * @name ApiCountriesReferenceGet
     * @summary Retrieves a Country resource.
     * @request GET:/countries/{reference}
     * @secure
     */
    apiCountriesReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<CountryJsonldCountryRead, void>({
        path: `/countries/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  deckUserLists = {
    /**
     * @description Retrieves the collection of DeckUserList resources.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsGetCollection
     * @summary Collection of Decks
     * @request GET:/deck_user_lists
     * @secure
     */
    apiDeckUserListsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'faction.reference'?: string;
        'faction.reference[]'?: string[];
        'alterator.reference'?: string;
        'alterator.reference[]'?: string[];
        name?: string;
        isLegal?: boolean;
        'isLegal[]'?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': DeckUserListJsonldDeckUserListRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/deck_user_lists`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsPost
     * @summary Create a Deck
     * @request POST:/deck_user_lists
     * @secure
     */
    apiDeckUserListsPost: (data: DeckUserListJsonldDeckUserListWrite, params: RequestParams = {}) =>
      this.request<DeckUserListJsonldDeckUserListRead, void>({
        path: `/deck_user_lists`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of DeckUserList resources.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsuserUserGetCollection
     * @summary Collection of public deck from one user
     * @request GET:/deck_user_lists/user/{user}
     * @secure
     */
    apiDeckUserListsuserUserGetCollection: (
      user: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'faction.reference'?: string;
        'faction.reference[]'?: string[];
        'alterator.reference'?: string;
        'alterator.reference[]'?: string[];
        name?: string;
        isLegal?: boolean;
        'isLegal[]'?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': DeckUserListJsonldDeckUserListRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/deck_user_lists/user/${user}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdGet
     * @summary Get a Deck
     * @request GET:/deck_user_lists/{id}
     * @secure
     */
    apiDeckUserListsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<DeckUserListJsonldDeckUserListReadDeckUserListDetailRead, void>({
        path: `/deck_user_lists/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdPut
     * @summary Update a Deck
     * @request PUT:/deck_user_lists/{id}
     * @secure
     */
    apiDeckUserListsIdPut: (id: string, data: DeckUserListJsonldDeckUserListPut, params: RequestParams = {}) =>
      this.request<DeckUserListJsonldDeckUserListRead, void>({
        path: `/deck_user_lists/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdDelete
     * @summary Delete a Deck
     * @request DELETE:/deck_user_lists/{id}
     * @secure
     */
    apiDeckUserListsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/deck_user_lists/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Replaces the DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdaddCardsPut
     * @summary Add Cards to a Deck
     * @request PUT:/deck_user_lists/{id}/add_cards
     * @secure
     */
    apiDeckUserListsIdaddCardsPut: (
      id: string,
      data: DeckUserListDeckAddCardDataJsonldDeckAddCardDataWrite,
      params: RequestParams = {},
    ) =>
      this.request<DeckUserListJsonldDeckUserListReadDeckUserListDetailRead, void>({
        path: `/deck_user_lists/${id}/add_cards`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdduplicatePut
     * @summary Duplicate a Deck
     * @request PUT:/deck_user_lists/{id}/duplicate
     * @secure
     */
    apiDeckUserListsIdduplicatePut: (
      id: string,
      data: DeckUserListJsonldDeckUserListWrite,
      params: RequestParams = {},
    ) =>
      this.request<DeckUserListJsonldDeckUserListRead, void>({
        path: `/deck_user_lists/${id}/duplicate`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdmultiAddCardsPut
     * @summary Multi Scan to add Cards to a Deck
     * @request PUT:/deck_user_lists/{id}/multi_add_cards
     * @secure
     */
    apiDeckUserListsIdmultiAddCardsPut: (id: string, data?: string[], params: RequestParams = {}) =>
      this.request<DeckUserListDeckMultiScanJsonldDeckUserListRead, void>({
        path: `/deck_user_lists/${id}/multi_add_cards`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a DeckUserList resource.
     *
     * @tags Deckbuilder
     * @name ApiDeckUserListsIdstatsGet
     * @summary Get Statistics for a Deck
     * @request GET:/deck_user_lists/{id}/stats
     * @secure
     */
    apiDeckUserListsIdstatsGet: (id: string, params: RequestParams = {}) =>
      this.request<DeckUserListDeckStatisticsDataJsonldDeckUserListReadDeckUserListData, void>({
        path: `/deck_user_lists/${id}/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  eventTypes = {
    /**
     * @description Retrieves the collection of EventType resources.
     *
     * @tags EventType
     * @name ApiEventTypesGetCollection
     * @summary Retrieves the collection of EventType resources.
     * @request GET:/event_types
     * @secure
     */
    apiEventTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventTypeJsonldEventTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/event_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a EventType resource.
     *
     * @tags EventType
     * @name ApiEventTypesReferenceGet
     * @summary Retrieves a EventType resource.
     * @request GET:/event_types/{reference}
     * @secure
     */
    apiEventTypesReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<EventTypeJsonldEventTypeRead, void>({
        path: `/event_types/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  eventUsers = {
    /**
     * @description Retrieves the collection of EventUser resources.
     *
     * @tags EventUser
     * @name ApiEventUsersGetCollection
     * @summary Retrieves the collection of EventUser resources.
     * @request GET:/event_users
     * @secure
     */
    apiEventUsersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        event?: string;
        'event[]'?: string[];
        'user.id'?: string;
        'user.id[]'?: string[];
        'user.email'?: string;
        'user.email[]'?: string[];
        'user.uniqueId'?: string;
        'user.uniqueId[]'?: string[];
        'event.id'?: string;
        'event.id[]'?: string[];
        status?: string;
        'order[user.nickName]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventUserJsonldEventUserRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/event_users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a EventUser resource.
     *
     * @tags EventUser
     * @name ApiEventUsersPost
     * @summary Creates a EventUser resource.
     * @request POST:/event_users
     * @secure
     */
    apiEventUsersPost: (data: EventUserJsonldEventUserWrite, params: RequestParams = {}) =>
      this.request<EventUserJsonldEventUserRead, void>({
        path: `/event_users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a EventUser resource.
     *
     * @tags EventUser
     * @name ApiEventUsersIdGet
     * @summary Retrieves a EventUser resource.
     * @request GET:/event_users/{id}
     * @secure
     */
    apiEventUsersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<EventUserJsonldEventUserRead, void>({
        path: `/event_users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the EventUser resource.
     *
     * @tags EventUser
     * @name ApiEventUsersIdPut
     * @summary Replaces the EventUser resource.
     * @request PUT:/event_users/{id}
     * @secure
     */
    apiEventUsersIdPut: (id: string, data: EventUserJsonldEventUserUpdate, params: RequestParams = {}) =>
      this.request<EventUserJsonldEventUserRead, void>({
        path: `/event_users/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the EventUser resource.
     *
     * @tags EventUser
     * @name ApiEventUsersIdDelete
     * @summary Removes the EventUser resource.
     * @request DELETE:/event_users/{id}
     * @secure
     */
    apiEventUsersIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/event_users/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  events = {
    /**
     * @description Get the event list.
     *
     * @tags Event
     * @name ApiEventsGetCollection
     * @summary Event Users List
     * @request GET:/events
     * @secure
     */
    apiEventsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'address.id'?: string;
        'address.id[]'?: string[];
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'translations.name'?: string;
        organizer?: string;
        'organizer[]'?: string[];
        status?: string;
        'status[]'?: string[];
        isFree?: boolean;
        'isFree[]'?: boolean[];
        'eventType.reference'?: string;
        'eventType.reference[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        gameFormat?: string;
        'gameFormat[]'?: string[];
        'order[eventFormat]'?: 'asc' | 'desc';
        'order[address.street]'?: 'asc' | 'desc';
        'order[startDateTime]'?: 'asc' | 'desc';
        'order[endDateTime]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'startDateTime[before]'?: string;
        'startDateTime[strictly_before]'?: string;
        'startDateTime[after]'?: string;
        'startDateTime[strictly_after]'?: string;
        'endDateTime[before]'?: string;
        'endDateTime[strictly_before]'?: string;
        'endDateTime[after]'?: string;
        'endDateTime[strictly_after]'?: string;
        /** Filter where the field not_status is not equal to a given value */
        not_status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventJsonldEventReadEventFormatReadIllustrationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/events`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Event resource.
     *
     * @tags Event
     * @name ApiEventsPost
     * @summary Creates a Event resource.
     * @request POST:/events
     * @secure
     */
    apiEventsPost: (data: EventJsonldEventWrite, params: RequestParams = {}) =>
      this.request<EventJsonldEventRead, void>({
        path: `/events`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Event resource.
     *
     * @tags Event
     * @name ApiEventscreatePost
     * @summary Creates a Event resource.
     * @request POST:/events/create
     * @secure
     */
    apiEventscreatePost: (data: EventJsonldEventWrite, params: RequestParams = {}) =>
      this.request<EventJsonldEventRead, void>({
        path: `/events/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Event near the location.
     *
     * @tags Event
     * @name ApiEventslocatorGetCollection
     * @summary Event Locator
     * @request GET:/events/locator
     * @secure
     */
    apiEventslocatorGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @max 50
         * @default 30
         */
        itemsPerPage?: number;
        /** Filter by coordinate */
        latitude?: number;
        /** Filter by coordinate */
        longitude?: number;
        /** Max distance with latitude and longitude */
        maxDistance?: 10 | 20 | 50 | 100;
        /** Unit system used for calculation */
        unit?: 'meters' | 'miles';
        /** Date from which shops have an event planned */
        from?: number;
        /** Date until which shops have an event planned */
        to?: number;
        /**
         * Country
         * @example ["FR","US"]
         */
        country?: string;
        id?: string;
        'id[]'?: string[];
        'address.id'?: string;
        'address.id[]'?: string[];
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'translations.name'?: string;
        organizer?: string;
        'organizer[]'?: string[];
        status?: string;
        'status[]'?: string[];
        isFree?: boolean;
        'isFree[]'?: boolean[];
        'eventType.reference'?: string;
        'eventType.reference[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        gameFormat?: string;
        'gameFormat[]'?: string[];
        'order[eventFormat]'?: 'asc' | 'desc';
        'order[address.street]'?: 'asc' | 'desc';
        'order[startDateTime]'?: 'asc' | 'desc';
        'order[endDateTime]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'startDateTime[before]'?: string;
        'startDateTime[strictly_before]'?: string;
        'startDateTime[after]'?: string;
        'startDateTime[strictly_after]'?: string;
        'endDateTime[before]'?: string;
        'endDateTime[strictly_before]'?: string;
        'endDateTime[after]'?: string;
        'endDateTime[strictly_after]'?: string;
        /** Filter where the field not_status is not equal to a given value */
        not_status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventEventLocatorJsonldEventLocatorReadShopLocatorRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/events/locator`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the detail information of an Event with the connected user.
     *
     * @tags Event
     * @name ApiEventsIdGet
     * @summary Event Users
     * @request GET:/events/{id}
     * @secure
     */
    apiEventsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<EventJsonldEventRead, void>({
        path: `/events/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Event resource.
     *
     * @tags Event
     * @name ApiEventsIdPut
     * @summary Replaces the Event resource.
     * @request PUT:/events/{id}
     * @secure
     */
    apiEventsIdPut: (id: string, data: EventJsonldEventWrite, params: RequestParams = {}) =>
      this.request<EventJsonldEventRead, void>({
        path: `/events/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the Event resource.
     *
     * @tags Event
     * @name ApiEventsIdDelete
     * @summary Removes the Event resource.
     * @request DELETE:/events/{id}
     * @secure
     */
    apiEventsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/events/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get the event that the user shop created.
     *
     * @tags Event
     * @name ApiEventsIdorganizerGetCollection
     * @summary Event the user shop created
     * @request GET:/events/{id}/organizer
     * @secure
     */
    apiEventsIdorganizerGetCollection: (
      id: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'address.id'?: string;
        'address.id[]'?: string[];
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'translations.name'?: string;
        organizer?: string;
        'organizer[]'?: string[];
        status?: string;
        'status[]'?: string[];
        isFree?: boolean;
        'isFree[]'?: boolean[];
        'eventType.reference'?: string;
        'eventType.reference[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        gameFormat?: string;
        'gameFormat[]'?: string[];
        'order[eventFormat]'?: 'asc' | 'desc';
        'order[address.street]'?: 'asc' | 'desc';
        'order[startDateTime]'?: 'asc' | 'desc';
        'order[endDateTime]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'startDateTime[before]'?: string;
        'startDateTime[strictly_before]'?: string;
        'startDateTime[after]'?: string;
        'startDateTime[strictly_after]'?: string;
        'endDateTime[before]'?: string;
        'endDateTime[strictly_before]'?: string;
        'endDateTime[after]'?: string;
        'endDateTime[strictly_after]'?: string;
        /** Filter where the field not_status is not equal to a given value */
        not_status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventJsonldEventReadAddressReadEventFormatReadIllustrationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/events/${id}/organizer`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the ranking of users.
     *
     * @tags Event
     * @name ApiEventsIdrankingGetCollection
     * @summary Event ranking
     * @request GET:/events/{id}/ranking
     * @secure
     */
    apiEventsIdrankingGetCollection: (
      id: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'address.id'?: string;
        'address.id[]'?: string[];
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'translations.name'?: string;
        organizer?: string;
        'organizer[]'?: string[];
        status?: string;
        'status[]'?: string[];
        isFree?: boolean;
        'isFree[]'?: boolean[];
        'eventType.reference'?: string;
        'eventType.reference[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        gameFormat?: string;
        'gameFormat[]'?: string[];
        'order[eventFormat]'?: 'asc' | 'desc';
        'order[address.street]'?: 'asc' | 'desc';
        'order[startDateTime]'?: 'asc' | 'desc';
        'order[endDateTime]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'startDateTime[before]'?: string;
        'startDateTime[strictly_before]'?: string;
        'startDateTime[after]'?: string;
        'startDateTime[strictly_after]'?: string;
        'endDateTime[before]'?: string;
        'endDateTime[strictly_before]'?: string;
        'endDateTime[after]'?: string;
        'endDateTime[strictly_after]'?: string;
        /** Filter where the field not_status is not equal to a given value */
        not_status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventEventRankingJsonldEventRankingRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/events/${id}/ranking`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  factions = {
    /**
     * @description Retrieves the collection of Faction resources.
     *
     * @tags Faction
     * @name ApiFactionsGetCollection
     * @summary Retrieves the collection of Faction resources.
     * @request GET:/factions
     * @secure
     */
    apiFactionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'translations.name'?: string;
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'order[id]'?: 'asc' | 'desc';
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': FactionJsonldFactionRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/factions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Faction resource.
     *
     * @tags Faction
     * @name ApiFactionsReferenceGet
     * @summary Retrieves a Faction resource.
     * @request GET:/factions/{reference}
     * @secure
     */
    apiFactionsReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<FactionJsonldFactionRead, void>({
        path: `/factions/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  gameUsers = {
    /**
     * @description Retrieves the collection of GameUser resources.
     *
     * @tags GameUser
     * @name ApiGameUsersGetCollection
     * @summary Retrieves the collection of GameUser resources.
     * @request GET:/game_users
     * @secure
     */
    apiGameUsersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        id?: string;
        'id[]'?: string[];
        game?: string;
        'game[]'?: string[];
        'user.id'?: string;
        'user.id[]'?: string[];
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'groups[]'?: ('game:read' | 'user:read' | 'faction:read')[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': GameUserJsonldGameUserRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/game_users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a GameUser resource.
     *
     * @tags GameUser
     * @name ApiGameUsersPost
     * @summary Creates a GameUser resource.
     * @request POST:/game_users
     * @secure
     */
    apiGameUsersPost: (data: GameUserJsonldGameWriteGameUserWrite, params: RequestParams = {}) =>
      this.request<GameUserJsonldGameUserRead, void>({
        path: `/game_users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a GameUser resource.
     *
     * @tags GameUser
     * @name ApiGameUsersIdGet
     * @summary Retrieves a GameUser resource.
     * @request GET:/game_users/{id}
     * @secure
     */
    apiGameUsersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<GameUserJsonldGameUserRead, void>({
        path: `/game_users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the GameUser resource.
     *
     * @tags GameUser
     * @name ApiGameUsersIdPut
     * @summary Replaces the GameUser resource.
     * @request PUT:/game_users/{id}
     * @secure
     */
    apiGameUsersIdPut: (id: string, data: GameUserJsonldGameUserWrite, params: RequestParams = {}) =>
      this.request<GameUserJsonldGameUserRead, void>({
        path: `/game_users/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  games = {
    /**
     * @description Retrieves the collection of Game resources.
     *
     * @tags Game
     * @name ApiGamesGetCollection
     * @summary Retrieves the collection of Game resources.
     * @request GET:/games
     * @secure
     */
    apiGamesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        'event.id'?: string;
        'event.id[]'?: string[];
        'cardSet.id'?: string;
        'cardSet.id[]'?: string[];
        'gameUsers.user.id'?: string;
        'gameUsers.user.id[]'?: string[];
        'order[dateTime]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'dateTime[before]'?: string;
        'dateTime[strictly_before]'?: string;
        'dateTime[after]'?: string;
        'dateTime[strictly_after]'?: string;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'groups[]'?: (
          | 'user:read'
          | 'event:read'
          | 'game_type:read'
          | 'game_user:read'
          | 'card_set:read'
          | 'faction:read'
          | 'event_format:read'
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': GameJsonldGameRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/games`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Game resource.
     *
     * @tags Game
     * @name ApiGamesPost
     * @summary Creates a Game resource.
     * @request POST:/games
     * @secure
     */
    apiGamesPost: (data: GameJsonldGameWriteGameUserWrite, params: RequestParams = {}) =>
      this.request<GameJsonldGameRead, void>({
        path: `/games`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Game resources.
     *
     * @tags Game
     * @name ApiGamesexportGetCollection
     * @summary Get a CSV file of Games data.
     * @request GET:/games/export
     * @secure
     */
    apiGamesexportGetCollection: (
      query?: {
        id?: string;
        'id[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        'event.id'?: string;
        'event.id[]'?: string[];
        'cardSet.id'?: string;
        'cardSet.id[]'?: string[];
        'gameUsers.user.id'?: string;
        'gameUsers.user.id[]'?: string[];
        'order[dateTime]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'dateTime[before]'?: string;
        'dateTime[strictly_before]'?: string;
        'dateTime[after]'?: string;
        'dateTime[strictly_after]'?: string;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'groups[]'?: (
          | 'user:read'
          | 'event:read'
          | 'game_type:read'
          | 'game_user:read'
          | 'card_set:read'
          | 'faction:read'
          | 'event_format:read'
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': GameJsonldGameRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/games/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Game resource.
     *
     * @tags Game
     * @name ApiGamesIdGet
     * @summary Retrieves a Game resource.
     * @request GET:/games/{id}
     * @secure
     */
    apiGamesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<GameJsonldGameRead, void>({
        path: `/games/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Game resource.
     *
     * @tags Game
     * @name ApiGamesIdPut
     * @summary Replaces the Game resource.
     * @request PUT:/games/{id}
     * @secure
     */
    apiGamesIdPut: (id: string, data: GameJsonldGameWrite, params: RequestParams = {}) =>
      this.request<GameJsonldGameRead, void>({
        path: `/games/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  illustrationStatuses = {
    /**
     * @description Retrieves the collection of IllustrationStatus resources.
     *
     * @tags IllustrationStatus
     * @name ApiIllustrationStatusesGetCollection
     * @summary Retrieves the collection of IllustrationStatus resources.
     * @request GET:/illustration_statuses
     * @secure
     */
    apiIllustrationStatusesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': IllustrationStatusJsonldIllustrationStatusRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/illustration_statuses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a IllustrationStatus resource.
     *
     * @tags IllustrationStatus
     * @name ApiIllustrationStatusesIdGet
     * @summary Retrieves a IllustrationStatus resource.
     * @request GET:/illustration_statuses/{id}
     * @secure
     */
    apiIllustrationStatusesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<IllustrationStatusJsonldIllustrationStatusRead, void>({
        path: `/illustration_statuses/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  illustrationTypes = {
    /**
     * @description Retrieves the collection of IllustrationType resources.
     *
     * @tags IllustrationType
     * @name ApiIllustrationTypesGetCollection
     * @summary Retrieves the collection of IllustrationType resources.
     * @request GET:/illustration_types
     * @secure
     */
    apiIllustrationTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': IllustrationTypeJsonldIllustrationTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/illustration_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a IllustrationType resource.
     *
     * @tags IllustrationType
     * @name ApiIllustrationTypesIdGet
     * @summary Retrieves a IllustrationType resource.
     * @request GET:/illustration_types/{id}
     * @secure
     */
    apiIllustrationTypesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<IllustrationTypeJsonldIllustrationTypeRead, void>({
        path: `/illustration_types/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  illustrations = {
    /**
     * @description Retrieves the collection of Illustration resources.
     *
     * @tags Illustration
     * @name ApiIllustrationsGetCollection
     * @summary Retrieves the collection of Illustration resources.
     * @request GET:/illustrations
     * @secure
     */
    apiIllustrationsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'illustrationType.reference'?: string;
        'illustrationType.reference[]'?: string[];
        'illustrationStatus.reference'?: string;
        'illustrationStatus.reference[]'?: string[];
        'order[reference]'?: 'asc' | 'desc';
        'groups[]'?: (
          | 'faction:read'
          | 'illustration_lore_entry:read'
          | 'lore_entry:read'
          | 'lore_entry_lore_entry_element:read'
          | 'rarity:read'
          | 'user:read'
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': IllustrationJsonldIllustrationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/illustrations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Illustration resource.
     *
     * @tags Illustration
     * @name ApiIllustrationsIdGet
     * @summary Retrieves a Illustration resource.
     * @request GET:/illustrations/{id}
     * @secure
     */
    apiIllustrationsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<IllustrationJsonldIllustrationRead, void>({
        path: `/illustrations/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  invoices = {
    /**
     * @description Retrieves the collection of Invoice resources.
     *
     * @tags Invoice
     * @name ApiInvoicesGetCollection
     * @summary Retrieves the collection of Invoice resources.
     * @request GET:/invoices
     * @secure
     */
    apiInvoicesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': InvoiceJsonld[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Invoice resource.
     *
     * @tags Invoice
     * @name ApiInvoicesIdGet
     * @summary Retrieves a Invoice resource.
     * @request GET:/invoices/{id}
     * @secure
     */
    apiInvoicesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<InvoiceJsonld, void>({
        path: `/invoices/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Invoice resource.
     *
     * @tags Invoice
     * @name ApiInvoicesIdpdfGet
     * @summary Retrieves a Invoice resource.
     * @request GET:/invoices/{id}/pdf
     * @secure
     */
    apiInvoicesIdpdfGet: (id: string, params: RequestParams = {}) =>
      this.request<Invoice, void>({
        path: `/invoices/${id}/pdf`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a Invoice resource.
     *
     * @tags Invoice
     * @name ApiInvoicesIdpdfPost
     * @summary Creates a Invoice resource.
     * @request POST:/invoices/{id}/pdf
     * @secure
     */
    apiInvoicesIdpdfPost: (
      id: string,
      data?: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<InvoiceJsonld, void>({
        path: `/invoices/${id}/pdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  languages = {
    /**
     * @description Retrieves the collection of Language resources.
     *
     * @tags Language
     * @name ApiLanguagesGetCollection
     * @summary Retrieves the collection of Language resources.
     * @request GET:/languages
     * @secure
     */
    apiLanguagesGetCollection: (
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': LanguageJsonldLanguageRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/languages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Language resources.
     *
     * @tags Language
     * @name ApiLanguagesallGetCollection
     * @summary Retrieves the collection of Language resources.
     * @request GET:/languages/all
     * @secure
     */
    apiLanguagesallGetCollection: (
      query: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        /** Override locale */
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': LanguageJsonldLanguageRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/languages/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Language resource.
     *
     * @tags Language
     * @name ApiLanguagesIdGet
     * @summary Retrieves a Language resource.
     * @request GET:/languages/{id}
     * @secure
     */
    apiLanguagesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LanguageJsonldLanguageRead, void>({
        path: `/languages/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  leagues = {
    /**
     * @description Retrieves the collection of League resources.
     *
     * @tags League
     * @name ApiLeaguesGetCollection
     * @summary Retrieves the collection of League resources.
     * @request GET:/leagues
     * @secure
     */
    apiLeaguesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': LeagueJsonldLeagueRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/leagues`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a League resource.
     *
     * @tags League
     * @name ApiLeaguesReferenceGet
     * @summary Retrieves a League resource.
     * @request GET:/leagues/{reference}
     * @secure
     */
    apiLeaguesReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<LeagueJsonldLeagueRead, void>({
        path: `/leagues/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  logQrAccess = {
    /**
     * @description Creates a LogQrAccess resource.
     *
     * @tags LogQrAccess
     * @name ApiLogQrAccessPost
     * @summary Creates a LogQrAccess resource.
     * @request POST:/log_qr_access
     * @secure
     */
    apiLogQrAccessPost: (data: LogQrAccessJsonldLogQrWrite, params: RequestParams = {}) =>
      this.request<LogQrAccessJsonldLogQrRead, void>({
        path: `/log_qr_access`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  login = {
    /**
     * No description
     *
     * @tags Login Check
     * @name LoginCheckPost
     * @summary Creates a user token.
     * @request POST:/login
     * @secure
     */
    loginCheckPost: (
      data: {
        email: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          token: string;
          refresh_token?: string;
        },
        any
      >({
        path: `/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  loreEntries = {
    /**
     * @description Retrieves a LoreEntry resource.
     *
     * @tags LoreEntry
     * @name ApiLoreEntriesIdGet
     * @summary Retrieves a LoreEntry resource.
     * @request GET:/lore_entries/{id}
     * @secure
     */
    apiLoreEntriesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LoreEntryJsonldLoreEntryRead, void>({
        path: `/lore_entries/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  loreEntryElementTypes = {
    /**
     * @description Retrieves a LoreEntryElementType resource.
     *
     * @tags LoreEntryElementType
     * @name ApiLoreEntryElementTypesIdGet
     * @summary Retrieves a LoreEntryElementType resource.
     * @request GET:/lore_entry_element_types/{id}
     * @secure
     */
    apiLoreEntryElementTypesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LoreEntryElementTypeJsonldLoreEntryElementTypeRead, void>({
        path: `/lore_entry_element_types/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  loreEntryElements = {
    /**
     * @description Retrieves a LoreEntryElement resource.
     *
     * @tags LoreEntryElement
     * @name ApiLoreEntryElementsIdGet
     * @summary Retrieves a LoreEntryElement resource.
     * @request GET:/lore_entry_elements/{id}
     * @secure
     */
    apiLoreEntryElementsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LoreEntryElementJsonldLoreEntryElementRead, void>({
        path: `/lore_entry_elements/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  loreEntryStatuses = {
    /**
     * @description Retrieves a LoreEntryStatus resource.
     *
     * @tags LoreEntryStatus
     * @name ApiLoreEntryStatusesIdGet
     * @summary Retrieves a LoreEntryStatus resource.
     * @request GET:/lore_entry_statuses/{id}
     * @secure
     */
    apiLoreEntryStatusesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LoreEntryStatusJsonldLoreEntryStatusRead, void>({
        path: `/lore_entry_statuses/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  loreEntryTypes = {
    /**
     * @description Retrieves a LoreEntryType resource.
     *
     * @tags LoreEntryType
     * @name ApiLoreEntryTypesIdGet
     * @summary Retrieves a LoreEntryType resource.
     * @request GET:/lore_entry_types/{id}
     * @secure
     */
    apiLoreEntryTypesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<LoreEntryTypeJsonldLoreEntryTypeRead, void>({
        path: `/lore_entry_types/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  manufactures = {
    /**
     * @description Retrieves the collection of CardManufacture resources.
     *
     * @tags CardManufacture
     * @name ApiManufacturesReferencecardsGetCollection
     * @summary Get Cards by manufacture
     * @request GET:/manufactures/{reference}/cards
     * @secure
     */
    apiManufacturesReferencecardsGetCollection: (
      reference: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardManufactureCardJsonldManufactureRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/manufactures/${reference}/cards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  marketplace = {
    /**
     * @description Creates a MarketplaceOfferItem resource.
     *
     * @tags Marketplace Offer
     * @name ApiMarketplaceaddPost
     * @summary Publish a new Marketplace Offer with these Cards
     * @request POST:/marketplace/add
     * @secure
     */
    apiMarketplaceaddPost: (
      data?: {
        cards?: {
          /** @example "YZ_1" */
          reference?: string;
          /** @example "3" */
          quantity?: number;
          /** @example "3.5" */
          price?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketplaceOfferItemJsonld, void>({
        path: `/marketplace/add`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create an Order.
     *
     * @tags Marketplace Order
     * @name ApiMarketplaceordercreatePost
     * @summary Create an Order
     * @request POST:/marketplace/order/create
     * @secure
     */
    apiMarketplaceordercreatePost: (
      data?: {
        quantity?: number;
        cardRef?: string;
        offerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/marketplace/order/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the MarketplaceCart resource.
     *
     * @tags Marketplace Order
     * @name ApiMarketplaceordermyCartDelete
     * @summary Delete the current Cart
     * @request DELETE:/marketplace/order/my-cart
     * @secure
     */
    apiMarketplaceordermyCartDelete: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/marketplace/order/my-cart`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves a SaleSummary resource.
     *
     * @tags SaleSummary
     * @name ApiMarketplacesalesSummaryGet
     * @summary Retrieves a SaleSummary resource.
     * @request GET:/marketplace/sales-summary
     * @secure
     */
    apiMarketplacesalesSummaryGet: (params: RequestParams = {}) =>
      this.request<SaleSummaryJsonldMarketplaceSalesRead, void>({
        path: `/marketplace/sales-summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the MarketplaceOfferItem resource.
     *
     * @tags Marketplace Offer
     * @name ApiMarketplaceReferencePut
     * @summary Update price of a Marketplace Offer
     * @request PUT:/marketplace/{reference}
     * @secure
     */
    apiMarketplaceReferencePut: (
      reference: string,
      data?: {
        /**
         * @format float
         * @example 3.1
         */
        newPrice?: number;
        /**
         * @format integer
         * @example 3
         */
        quantity?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/marketplace/${reference}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes the MarketplaceOfferItem resource.
     *
     * @tags Marketplace Offer
     * @name ApiMarketplaceReferenceDelete
     * @summary Delete a Marketplace Offer
     * @request DELETE:/marketplace/{reference}
     * @secure
     */
    apiMarketplaceReferenceDelete: (reference: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/marketplace/${reference}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  marketplaceOrderItems = {
    /**
     * @description Retrieves the collection of MarketplaceOrderItem resources.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsGetCollection
     * @summary Retrieves the collection of MarketplaceOrderItem resources.
     * @request GET:/marketplace_order_items
     * @secure
     */
    apiMarketplaceOrderItemsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': MarketplaceOrderItemJsonld[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/marketplace_order_items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a MarketplaceOrderItem resource.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsPost
     * @summary Creates a MarketplaceOrderItem resource.
     * @request POST:/marketplace_order_items
     * @secure
     */
    apiMarketplaceOrderItemsPost: (data: MarketplaceOrderItemJsonld, params: RequestParams = {}) =>
      this.request<MarketplaceOrderItemJsonld, void>({
        path: `/marketplace_order_items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a MarketplaceOrderItem resource.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsIdGet
     * @summary Retrieves a MarketplaceOrderItem resource.
     * @request GET:/marketplace_order_items/{id}
     * @secure
     */
    apiMarketplaceOrderItemsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<MarketplaceOrderItemJsonld, void>({
        path: `/marketplace_order_items/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the MarketplaceOrderItem resource.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsIdPut
     * @summary Replaces the MarketplaceOrderItem resource.
     * @request PUT:/marketplace_order_items/{id}
     * @secure
     */
    apiMarketplaceOrderItemsIdPut: (id: string, data: MarketplaceOrderItemJsonld, params: RequestParams = {}) =>
      this.request<MarketplaceOrderItemJsonld, void>({
        path: `/marketplace_order_items/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the MarketplaceOrderItem resource.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsIdDelete
     * @summary Removes the MarketplaceOrderItem resource.
     * @request DELETE:/marketplace_order_items/{id}
     * @secure
     */
    apiMarketplaceOrderItemsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/marketplace_order_items/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Updates the MarketplaceOrderItem resource.
     *
     * @tags MarketplaceOrderItem
     * @name ApiMarketplaceOrderItemsIdPatch
     * @summary Updates the MarketplaceOrderItem resource.
     * @request PATCH:/marketplace_order_items/{id}
     * @secure
     */
    apiMarketplaceOrderItemsIdPatch: (id: string, data: MarketplaceOrderItem, params: RequestParams = {}) =>
      this.request<MarketplaceOrderItemJsonld, void>({
        path: `/marketplace_order_items/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  me = {
    /**
     * @description Return the connected user.
     *
     * @tags User
     * @name ApiMeGet
     * @summary Get the connected User
     * @request GET:/me
     * @secure
     */
    apiMeGet: (params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserPrivateRead, void>({
        path: `/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  media = {
    /**
     * @description Creates a Media resource.
     *
     * @tags Media
     * @name ApiMediaPost
     * @summary Creates a Media resource.
     * @request POST:/media
     * @secure
     */
    apiMediaPost: (
      data?: {
        /** @format binary */
        file?: File;
        type?: 'shop_logo' | 'shop_background' | 'shop_photo' | 'shop_inc_certificate';
      },
      params: RequestParams = {},
    ) =>
      this.request<MediaJsonldMediaRead, void>({
        path: `/media`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Media resource.
     *
     * @tags Media
     * @name ApiMediaIdGet
     * @summary Retrieves a Media resource.
     * @request GET:/media/{id}
     * @secure
     */
    apiMediaIdGet: (id: string, params: RequestParams = {}) =>
      this.request<MediaJsonldMediaRead, void>({
        path: `/media/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the Media resource.
     *
     * @tags Media
     * @name ApiMediaIdDelete
     * @summary Removes the Media resource.
     * @request DELETE:/media/{id}
     * @secure
     */
    apiMediaIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/media/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  memberLogged = {
    /**
     * @description Return the user connected from Shop.
     *
     * @tags User
     * @name ApiMemberLoggedGet
     * @summary Get the user connected from Shop
     * @request GET:/member_logged
     * @secure
     */
    apiMemberLoggedGet: (params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserPrivateRead, void>({
        path: `/member_logged`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  myEvents = {
    /**
     * @description Get the event list for the connected user.
     *
     * @tags Event
     * @name ApiMyEventsGetCollection
     * @summary Event For Users List
     * @request GET:/my_events
     * @secure
     */
    apiMyEventsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        'address.id'?: string;
        'address.id[]'?: string[];
        'translations.locale'?: string;
        'translations.locale[]'?: string[];
        'translations.name'?: string;
        organizer?: string;
        'organizer[]'?: string[];
        status?: string;
        'status[]'?: string[];
        isFree?: boolean;
        'isFree[]'?: boolean[];
        'eventType.reference'?: string;
        'eventType.reference[]'?: string[];
        eventFormat?: string;
        'eventFormat[]'?: string[];
        gameFormat?: string;
        'gameFormat[]'?: string[];
        'order[eventFormat]'?: 'asc' | 'desc';
        'order[address.street]'?: 'asc' | 'desc';
        'order[startDateTime]'?: 'asc' | 'desc';
        'order[endDateTime]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'startDateTime[before]'?: string;
        'startDateTime[strictly_before]'?: string;
        'startDateTime[after]'?: string;
        'startDateTime[strictly_after]'?: string;
        'endDateTime[before]'?: string;
        'endDateTime[strictly_before]'?: string;
        'endDateTime[after]'?: string;
        'endDateTime[strictly_after]'?: string;
        /** Filter where the field not_status is not equal to a given value */
        not_status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventJsonldEventReadEventFormatReadIllustrationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/my_events`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notificationParameterUsers = {
    /**
     * @description Retrieves the collection of NotificationParameterUser resources.
     *
     * @tags NotificationParameterUser
     * @name ApiNotificationParameterUsersGetCollection
     * @summary Get all the notification parameters for the connected user
     * @request GET:/notification_parameter_users
     * @secure
     */
    apiNotificationParameterUsersGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          'hydra:member': NotificationParameterUserJsonldNotificationParameterUserRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/notification_parameter_users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a NotificationParameterUser resource.
     *
     * @tags NotificationParameterUser
     * @name ApiNotificationParameterUsersPost
     * @summary Save the notification parameters
     * @request POST:/notification_parameter_users
     * @secure
     */
    apiNotificationParameterUsersPost: (data: NotificationParameterUserJsonld, params: RequestParams = {}) =>
      this.request<NotificationParameterUserJsonldNotificationParameterUserRead, void>({
        path: `/notification_parameter_users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  notificationParameters = {
    /**
     * @description Retrieves the collection of NotificationParameter resources.
     *
     * @tags NotificationParameter
     * @name ApiNotificationParametersGetCollection
     * @summary Get all the notification parameters
     * @request GET:/notification_parameters
     * @secure
     */
    apiNotificationParametersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': NotificationParameterJsonldNotificationParameterRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/notification_parameters`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * @description Retrieves the collection of Notification resources.
     *
     * @tags Notification
     * @name ApiNotificationsGetCollection
     * @summary Get all the user notifications
     * @request GET:/notifications
     * @secure
     */
    apiNotificationsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': NotificationJsonldNotificationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Notification resource.
     *
     * @tags Notification
     * @name ApiNotificationsmarkAsReadPut
     * @summary Put all user notification on read
     * @request PUT:/notifications/mark-as-read
     * @secure
     */
    apiNotificationsmarkAsReadPut: (data?: any, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/notifications/mark-as-read`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a Notification resource.
     *
     * @tags Notification
     * @name ApiNotificationsunreadGet
     * @summary Get the count of unread notification
     * @request GET:/notifications/unread
     * @secure
     */
    apiNotificationsunreadGet: (params: RequestParams = {}) =>
      this.request<
        {
          unread?: number;
        },
        any
      >({
        path: `/notifications/unread`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  optins = {
    /**
     * @description Retrieves the collection of Optin resources.
     *
     * @tags Optin
     * @name ApiOptinsGetCollection
     * @summary Retrieves the collection of Optin resources.
     * @request GET:/optins
     * @secure
     */
    apiOptinsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        'userProfiles.reference'?: string;
        'userProfiles.reference[]'?: string[];
        'countries.reference'?: string;
        'countries.reference[]'?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': OptinJsonldOptinRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/optins`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Optin resource.
     *
     * @tags Optin
     * @name ApiOptinsReferenceGet
     * @summary Retrieves a Optin resource.
     * @request GET:/optins/{reference}
     * @secure
     */
    apiOptinsReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<OptinJsonldOptinRead, void>({
        path: `/optins/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ownerExchangeRequests = {
    /**
     * @description Retrieves the collection of OwnerExchangeRequest resources.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsGetCollection
     * @summary Retrieves the collection of OwnerExchangeRequest resources.
     * @request GET:/owner_exchange_requests
     * @secure
     */
    apiOwnerExchangeRequestsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        isActive?: boolean;
        'isActive[]'?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': OwnerExchangeRequestJsonldOwnerExchangeRequestRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/owner_exchange_requests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsPost
     * @summary Creates a OwnerExchangeRequest resource.
     * @request POST:/owner_exchange_requests
     * @secure
     */
    apiOwnerExchangeRequestsPost: (
      data: OwnerExchangeRequestJsonldOwnerExchangeRequestWrite,
      params: RequestParams = {},
    ) =>
      this.request<OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead, void>({
        path: `/owner_exchange_requests`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsIdGet
     * @summary Retrieves a OwnerExchangeRequest resource.
     * @request GET:/owner_exchange_requests/{id}
     * @secure
     */
    apiOwnerExchangeRequestsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead, void>({
        path: `/owner_exchange_requests/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsIdPut
     * @summary Replaces the OwnerExchangeRequest resource.
     * @request PUT:/owner_exchange_requests/{id}
     * @secure
     */
    apiOwnerExchangeRequestsIdPut: (
      id: string,
      data: OwnerExchangeRequestJsonldOwnerExchangeRequestWrite,
      params: RequestParams = {},
    ) =>
      this.request<OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead, void>({
        path: `/owner_exchange_requests/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsIdDelete
     * @summary Removes the OwnerExchangeRequest resource.
     * @request DELETE:/owner_exchange_requests/{id}
     * @secure
     */
    apiOwnerExchangeRequestsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/owner_exchange_requests/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Replaces the OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsIdacceptPut
     * @summary Replaces the OwnerExchangeRequest resource.
     * @request PUT:/owner_exchange_requests/{id}/accept
     * @secure
     */
    apiOwnerExchangeRequestsIdacceptPut: (
      id: string,
      data: OwnerExchangeRequestJsonldOwnerExchangeRequestWrite,
      params: RequestParams = {},
    ) =>
      this.request<OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead, void>({
        path: `/owner_exchange_requests/${id}/accept`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the OwnerExchangeRequest resource.
     *
     * @tags OwnerExchangeRequest
     * @name ApiOwnerExchangeRequestsIdcancelPut
     * @summary Replaces the OwnerExchangeRequest resource.
     * @request PUT:/owner_exchange_requests/{id}/cancel
     * @secure
     */
    apiOwnerExchangeRequestsIdcancelPut: (
      id: string,
      data: OwnerExchangeRequestJsonldOwnerExchangeRequestWrite,
      params: RequestParams = {},
    ) =>
      this.request<OwnerExchangeRequestJsonldOwnerExchangeRequestReadOwnerExchangeRequestDetailRead, void>({
        path: `/owner_exchange_requests/${id}/cancel`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ownerHistoryGroups = {
    /**
     * @description Retrieves the collection of OwnerHistoryGroup resources.
     *
     * @tags OwnerHistoryGroup
     * @name ApiOwnerHistoryGroupsIdGetCollection
     * @summary Retrieves the collection of OwnerHistoryGroup resources.
     * @request GET:/owner_history_groups/{id}
     * @secure
     */
    apiOwnerHistoryGroupsIdGetCollection: (
      id: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': OwnerHistoryGroupJsonldOwnerHistoryGroupRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/owner_history_groups/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  owners = {
    /**
     * @description Creates a Owner resource.
     *
     * @tags Owner
     * @name ApiOwnersPost
     * @summary Creates a Owner resource.
     * @request POST:/owners
     * @secure
     */
    apiOwnersPost: (data: OwnerJsonldOwnerWrite, params: RequestParams = {}) =>
      this.request<OwnerJsonldOwnerRead, void>({
        path: `/owners`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Give a quantity of ownerships of a Card to an User.
     *
     * @tags Owner
     * @name ApiOwnersgivePost
     * @summary Give ownerships of a Card
     * @request POST:/owners/give
     * @secure
     */
    apiOwnersgivePost: (
      data?: {
        /** @example "/users/01GWKQNC4M55D3EWVFGCFJ5SB7" */
        user?: string;
        cards?: {
          /** @example "YZ_1" */
          reference?: string;
          /** @example "3" */
          quantity?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example "/owner_history_groups/xxxxxxxx" */
          ownerHistoryGroup?: string;
        },
        void
      >({
        path: `/owners/give`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Claim a list of ownerships
     *
     * @tags Owner
     * @name ApiOwnersmultiClaimPost
     * @summary Claim Multiple ownerships
     * @request POST:/owners/multi-claim
     * @secure
     */
    apiOwnersmultiClaimPost: (data?: string[], params: RequestParams = {}) =>
      this.request<OwnerOwnerClaimMultiJsonldOwnerClaimMultiRead, void>({
        path: `/owners/multi-claim`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Owner resource.
     *
     * @tags Owner
     * @name ApiOwnersIdGet
     * @summary Retrieves a Owner resource.
     * @request GET:/owners/{id}
     * @secure
     */
    apiOwnersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<OwnerJsonldOwnerRead, void>({
        path: `/owners/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ownershipLists = {
    /**
     * @description Replaces the OwnershipListData resource.
     *
     * @tags Ownership List
     * @name ApiOwnershipListsListNamePut
     * @summary Add Cards to a OwnershipList
     * @request PUT:/ownership_lists/{listName}
     * @secure
     */
    apiOwnershipListsListNamePut: (
      listName: string,
      data: OwnershipListDataJsonldOwnershipListWrite,
      params: RequestParams = {},
    ) =>
      this.request<OwnershipListDataJsonldOwnershipListRead, void>({
        path: `/ownership_lists/${listName}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Card resources.
     *
     * @tags Tradelist
     * @name ApiOwnershipListsListNameusersUserGetCollection
     * @summary Add Cards to a Tradelist
     * @request GET:/ownership_lists/{listName}/users/{user}
     * @secure
     */
    apiOwnershipListsListNameusersUserGetCollection: (
      listName: string,
      user: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        factions?: string;
        'factions[]'?: string[];
        'factions.reference'?: string;
        'factions.reference[]'?: string[];
        cardType?: string;
        'cardType[]'?: string[];
        'cardType.reference'?: string;
        'cardType.reference[]'?: string[];
        cardSubTypes?: string;
        'cardSubTypes[]'?: string[];
        cardSet?: string;
        'cardSet[]'?: string[];
        'cardSet.reference'?: string;
        'cardSet.reference[]'?: string[];
        rarity?: string;
        'rarity[]'?: string[];
        'rarity.reference'?: string;
        'rarity.reference[]'?: string[];
        'translations.name'?: string;
        'order[reference]'?: 'asc' | 'desc';
        'order[translations.name]'?: 'asc' | 'desc';
        'order[cardType.reference]'?: 'asc' | 'desc';
        'order[cardSubType.reference]'?: 'asc' | 'desc';
        'order[parent.reference]'?: 'asc' | 'desc';
        'order[cardSet.reference]'?: 'asc' | 'desc';
        'order[factions.reference]'?: 'asc' | 'desc';
        'order[cardUserListCards.createdAt]'?: 'asc' | 'desc';
        /**
         * This filter search a CardElement of type mainCost with value in the array
         * @example "['1', '3']"
         */
        mainCost?: string;
        /**
         * This filter search a CardElement of type recallCost with value in the array
         * @example "['1', '3']"
         */
        recallCost?: string;
        /**
         * This filter search a CardElement of type mountainPower with value in the array
         * @example "['1', '3']"
         */
        mountainPower?: string;
        /**
         * This filter search a CardElement of type oceanPower with value in the array
         * @example "['1', '3']"
         */
        oceanPower?: string;
        /**
         * This filter search a CardElement of type forestPower with value in the array
         * @example "['1', '3']"
         */
        forestPower?: string;
        /**
         * This filter search a CardKeyword of type mainEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        mainEffect?: string;
        /**
         * This filter search a CardKeyword of type echoEffect with value in the array
         * @example "['-', 'X', '1', '3']"
         */
        echoEffect?: string;
        /** Order cards by MAIN COST. */
        'order[mainCost]'?: 'asc' | 'desc';
        /** Order cards by RECALL COST. */
        'order[recallCost]'?: 'asc' | 'desc';
        /** Order cards by Last Added in Collection. */
        'order[collectionLatestAdded]'?: 'asc' | 'desc';
        /**
         * This filter search all the card in the given list name of the current user.
         * @example "wantlist"
         */
        'cardList.name'?: string;
        /**
         * This filter order the card list by sequence
         * @example "ASC | DESC"
         */
        'cardList.order'?: string;
        /** Get Exclusive Cards. */
        isExclusive?: boolean;
        /** Order by collectionNumber */
        'order[collectionNumber]'?: 'asc' | 'desc';
        /** Order by raritySequence */
        'order[raritySequence]'?: 'asc' | 'desc';
        /** Get Suspended Cards. */
        isSuspended?: boolean;
        /** Get cards by Card Product Reference. */
        cardProductReference?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CardJsonldOwnershipListRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/ownership_lists/${listName}/users/${user}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ownerships = {
    /**
     * @description Retrieves a Ownership resource.
     *
     * @tags Ownership
     * @name ApiOwnershipsIdGet
     * @summary Retrieves a Ownership resource.
     * @request GET:/ownerships/{id}
     * @secure
     */
    apiOwnershipsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<OwnershipJsonldOwnershipRead, void>({
        path: `/ownerships/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  payment = {
    /**
     * @description Retrieves a Currency resource.
     *
     * @tags Currency
     * @name ApiPaymentcurrencyCodeGet
     * @summary Retrieves a Currency resource.
     * @request GET:/payment/currency/{code}
     * @secure
     */
    apiPaymentcurrencyCodeGet: (code: string, params: RequestParams = {}) =>
      this.request<CurrencyJsonldPaymentCurrencyRead, void>({
        path: `/payment/currency/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  payments = {
    /**
     * @description Retrieves a BankAccount resource.
     *
     * @tags Payment Payout
     * @name ApiPaymentsbankAccountGet
     * @summary Get Bank Account
     * @request GET:/payments/bank_account
     * @secure
     */
    apiPaymentsbankAccountGet: (params: RequestParams = {}) =>
      this.request<BankAccountJsonldBankAccountRead, void>({
        path: `/payments/bank_account`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a BankAccount resource.
     *
     * @tags Payment Payout
     * @name ApiPaymentsbankAccountPost
     * @summary Create Bank Account
     * @request POST:/payments/bank_account
     * @secure
     */
    apiPaymentsbankAccountPost: (data: BankAccountJsonldBankAccountWrite, params: RequestParams = {}) =>
      this.request<BankAccountJsonldBankAccountRead, void>({
        path: `/payments/bank_account`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the BankAccount resource.
     *
     * @tags Payment Payout
     * @name ApiPaymentsbankAccountDelete
     * @summary Deactivate Bank Account
     * @request DELETE:/payments/bank_account
     * @secure
     */
    apiPaymentsbankAccountDelete: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/payments/bank_account`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Creates a CardRegistration resource.
     *
     * @tags Payment Card Registration
     * @name ApiPaymentscardRegistrationPost
     * @summary Create Card Resource
     * @request POST:/payments/card-registration
     * @secure
     */
    apiPaymentscardRegistrationPost: (data: CardRegistrationJsonldPaymentCardPostWrite, params: RequestParams = {}) =>
      this.request<CardRegistrationJsonldPaymentPaymentCardRead, void>({
        path: `/payments/card-registration`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the CardRegistration resource.
     *
     * @tags Payment Card Registration
     * @name ApiPaymentscardRegistrationIdPut
     * @summary Update Card Resource
     * @request PUT:/payments/card-registration/{id}
     * @secure
     */
    apiPaymentscardRegistrationIdPut: (
      id: string,
      data: CardRegistrationJsonldPaymentCardPutWrite,
      params: RequestParams = {},
    ) =>
      this.request<CardRegistrationPaymentCardJsonldPaymentPaymentCardRead, void>({
        path: `/payments/card-registration/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of Currency resources.
     *
     * @tags Payment
     * @name ApiPaymentscurrenciesGetCollection
     * @summary Get Currency List
     * @request GET:/payments/currencies
     * @secure
     */
    apiPaymentscurrenciesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': CurrencyJsonldPaymentCurrencyRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/payments/currencies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a WalletTransaction resource.
     *
     * @tags Payment Wallet Detail
     * @name ApiPaymentsdetailpayinIdGet
     * @summary Get Payin Detail
     * @request GET:/payments/detail/payin/{id}
     * @secure
     */
    apiPaymentsdetailpayinIdGet: (id: string, params: RequestParams = {}) =>
      this.request<WalletTransactionWalletDetailJsonldPaymentDetailPayinRead, void>({
        path: `/payments/detail/payin/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a WalletTransaction resource.
     *
     * @tags Payment Wallet Detail
     * @name ApiPaymentsdetailpayoutIdGet
     * @summary Get Payout Detail
     * @request GET:/payments/detail/payout/{id}
     * @secure
     */
    apiPaymentsdetailpayoutIdGet: (id: string, params: RequestParams = {}) =>
      this.request<WalletTransactionWalletDetailJsonldPaymentDetailPayoutRead, void>({
        path: `/payments/detail/payout/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a WalletTransaction resource.
     *
     * @tags Payment Wallet Detail
     * @name ApiPaymentsdetailIdGet
     * @summary Get Marketplace Detail
     * @request GET:/payments/detail/{id}
     * @secure
     */
    apiPaymentsdetailIdGet: (id: string, params: RequestParams = {}) =>
      this.request<WalletTransactionWalletDetailJsonldPaymentDetailRead, void>({
        path: `/payments/detail/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of PaymentCard resources.
     *
     * @tags Payment Card
     * @name ApiPaymentspaymentCardsGetCollection
     * @summary Get Payment Card List
     * @request GET:/payments/payment-cards
     * @secure
     */
    apiPaymentspaymentCardsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PaymentCardJsonldPaymentPaymentCardRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/payments/payment-cards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a PaymentCard resource.
     *
     * @tags Payment Card
     * @name ApiPaymentspaymentCardsExternalIdGet
     * @summary Get Payment Card
     * @request GET:/payments/payment-cards/{externalId}
     * @secure
     */
    apiPaymentspaymentCardsExternalIdGet: (externalId: string, params: RequestParams = {}) =>
      this.request<PaymentCardJsonldPaymentPaymentCardRead, void>({
        path: `/payments/payment-cards/${externalId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the PaymentCard resource.
     *
     * @tags Payment Card
     * @name ApiPaymentspaymentCardsExternalIdDelete
     * @summary Delete Payment Card
     * @request DELETE:/payments/payment-cards/{externalId}
     * @secure
     */
    apiPaymentspaymentCardsExternalIdDelete: (externalId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/payments/payment-cards/${externalId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Replaces the PaymentCard resource.
     *
     * @tags Payment Card
     * @name ApiPaymentspaymentCardsExternalIdpayinPut
     * @summary Create Card Payin
     * @request PUT:/payments/payment-cards/{externalId}/payin
     * @secure
     */
    apiPaymentspaymentCardsExternalIdpayinPut: (
      externalId: string,
      data: PaymentCardJsonldPaymentPaymentCardPayinWrite,
      params: RequestParams = {},
    ) =>
      this.request<PaymentCardCardPayinJsonldPaymentPaymentCardPayinRead, void>({
        path: `/payments/payment-cards/${externalId}/payin`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Payout resource.
     *
     * @tags Payment Payout
     * @name ApiPaymentspayoutGet
     * @summary Webhook Payout
     * @request GET:/payments/payout
     * @secure
     */
    apiPaymentspayoutGet: (params: RequestParams = {}) =>
      this.request<PayoutJsonldPayoutRead, void>({
        path: `/payments/payout`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Payout resource.
     *
     * @tags Payment Payout
     * @name ApiPaymentspayoutPost
     * @summary Create Payout
     * @request POST:/payments/payout
     * @secure
     */
    apiPaymentspayoutPost: (data: PayoutJsonldPayoutWrite, params: RequestParams = {}) =>
      this.request<PayoutJsonldPayoutRead, void>({
        path: `/payments/payout`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of PaymentPricingGrid resources.
     *
     * @tags Payment Card
     * @name ApiPaymentspricingGridGetCollection
     * @summary Get Payment Pricing Grid
     * @request GET:/payments/pricing-grid
     * @secure
     */
    apiPaymentspricingGridGetCollection: (
      query?: {
        /** Custom Amount */
        amount?: any;
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PaymentPricingGridJsonldPaymentPricingGridRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        {
          title?: string;
          description?: string;
        }
      >({
        path: `/payments/pricing-grid`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Wallet resource.
     *
     * @tags Payment Wallet
     * @name ApiPaymentswalletsactivatePost
     * @summary Activate Wallet
     * @request POST:/payments/wallets/activate
     * @secure
     */
    apiPaymentswalletsactivatePost: (data: WalletJsonldPaymentWalletWrite, params: RequestParams = {}) =>
      this.request<WalletJsonld, void>({
        path: `/payments/wallets/activate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Wallet resource.
     *
     * @tags Payment Wallet
     * @name ApiPaymentswalletsbalanceGet
     * @summary Get Wallet Balance
     * @request GET:/payments/wallets/balance
     * @secure
     */
    apiPaymentswalletsbalanceGet: (params: RequestParams = {}) =>
      this.request<WalletJsonldPaymentWalletRead, void>({
        path: `/payments/wallets/balance`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of WalletTransaction resources.
     *
     * @tags Payment Wallet
     * @name ApiPaymentswalletstransactionsGetCollection
     * @summary List Wallet Transactions
     * @request GET:/payments/wallets/transactions
     * @secure
     */
    apiPaymentswalletstransactionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        'order[mgpId]'?: 'asc' | 'desc';
        'order[currency]'?: 'asc' | 'desc';
        'order[amount]'?: 'asc' | 'desc';
        'order[type]'?: 'asc' | 'desc';
        'order[status]'?: 'asc' | 'desc';
        'order[tag]'?: 'asc' | 'desc';
        'order[date]'?: 'asc' | 'desc';
        'order[id]'?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': WalletTransactionJsonldPaymentWalletTransactionRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/payments/wallets/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  printOnDemandProducts = {
    /**
     * @description Retrieves the collection of PrintOnDemandProduct resources.
     *
     * @tags PrintOnDemandProduct
     * @name ApiPrintOnDemandProductsGetCollection
     * @summary Retrieves the collection of PrintOnDemandProduct resources.
     * @request GET:/print_on_demand_products
     * @secure
     */
    apiPrintOnDemandProductsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PrintOnDemandProductJsonldPrintOnDemandProductRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/print_on_demand_products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a PrintOnDemandProduct resource.
     *
     * @tags PrintOnDemandProduct
     * @name ApiPrintOnDemandProductsIdGet
     * @summary Retrieves a PrintOnDemandProduct resource.
     * @request GET:/print_on_demand_products/{id}
     * @secure
     */
    apiPrintOnDemandProductsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PrintOnDemandProductJsonldPrintOnDemandProductRead, void>({
        path: `/print_on_demand_products/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of PrintOnDemandProduct resources.
     *
     * @tags PrintOnDemandProduct
     * @name ApiPrintOnDemandProductsIdcardsReferenceGetCollection
     * @summary Get the information about possibility of printing a Card in an Order
     * @request GET:/print_on_demand_products/{id}/cards/{reference}
     * @secure
     */
    apiPrintOnDemandProductsIdcardsReferenceGetCollection: (
      id: string,
      reference: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PrintOnDemandProductJsonldPrintingAuthorizationRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/print_on_demand_products/${id}/cards/${reference}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Price for a given product and Currency.
     *
     * @tags PrintOnDemandProduct
     * @name ApiPrintOnDemandProductsIdpricesCurrencyGet
     * @summary Get Price for a given product and Currency
     * @request GET:/print_on_demand_products/{id}/prices/{currency}
     * @secure
     */
    apiPrintOnDemandProductsIdpricesCurrencyGet: (
      id: string,
      currency: string,
      query?: {
        quantity?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrintOnDemandProductJsonldPrintOnDemandProductRead, void>({
        path: `/print_on_demand_products/${id}/prices/${currency}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  printingOrderSlots = {
    /**
     * @description Retrieves a PrintingOrderSlot resource.
     *
     * @tags PrintingOrderSlot
     * @name ApiPrintingOrderSlotsopenGet
     * @summary Get the next open slot for order
     * @request GET:/printing_order_slots/open
     * @secure
     */
    apiPrintingOrderSlotsopenGet: (params: RequestParams = {}) =>
      this.request<PrintingOrderSlotJsonldPrintingOrderSlotRead, void>({
        path: `/printing_order_slots/open`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  printingOrders = {
    /**
     * @description Retrieves the collection of PrintingOrder resources.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersGetCollection
     * @summary Retrieves the collection of PrintingOrder resources.
     * @request GET:/printing_orders
     * @secure
     */
    apiPrintingOrdersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        status?: string;
        'status[]'?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PrintingOrderJsonldPrintingOrderRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/printing_orders`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a PrintingOrder resource.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersPost
     * @summary Creates a PrintingOrder resource.
     * @request POST:/printing_orders
     * @secure
     */
    apiPrintingOrdersPost: (data: PrintingOrderJsonldPrintingOrderWrite, params: RequestParams = {}) =>
      this.request<PrintingOrderJsonldPrintingOrderRead, void>({
        path: `/printing_orders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the collection of PrintingOrder resources.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrderspartnersinformationsGetCollection
     * @summary Retrieves the collection of PrintingOrder resources.
     * @request GET:/printing_orders/partners/informations
     * @secure
     */
    apiPrintingOrderspartnersinformationsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        status?: string;
        'status[]'?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': PrintingOrderJsonldPrintingOrderPartnerRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/printing_orders/partners/informations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a PrintingOrder resource.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersIdGet
     * @summary Retrieves a PrintingOrder resource.
     * @request GET:/printing_orders/{id}
     * @secure
     */
    apiPrintingOrdersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PrintingOrderJsonldPrintingOrderRead, void>({
        path: `/printing_orders/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the PrintingOrder resource.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersIdPut
     * @summary Replaces the PrintingOrder resource.
     * @request PUT:/printing_orders/{id}
     * @secure
     */
    apiPrintingOrdersIdPut: (id: string, data: PrintingOrderJsonldPrintingOrderWrite, params: RequestParams = {}) =>
      this.request<PrintingOrderJsonldPrintingOrderRead, void>({
        path: `/printing_orders/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the PrintingOrder resource.
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersIdDelete
     * @summary Removes the PrintingOrder resource.
     * @request DELETE:/printing_orders/{id}
     * @secure
     */
    apiPrintingOrdersIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/printing_orders/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Finalize POD Checkout Process
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersIdcheckoutPut
     * @summary Checkout a Printing Order
     * @request PUT:/printing_orders/{id}/checkout
     * @secure
     */
    apiPrintingOrdersIdcheckoutPut: (id: string, data?: any, params: RequestParams = {}) =>
      this.request<PrintingOrderJsonldPrintingOrderRead, void>({
        path: `/printing_orders/${id}/checkout`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update status (only for partner)
     *
     * @tags PrintingOrder
     * @name ApiPrintingOrdersIdprinterPut
     * @summary Update Printing Order Status
     * @request PUT:/printing_orders/{id}/printer
     * @secure
     */
    apiPrintingOrdersIdprinterPut: (
      id: string,
      data: PrintingOrderJsonldPrintingOrderPartnerWrite,
      params: RequestParams = {},
    ) =>
      this.request<PrintingOrderJsonldPrintingOrderPartnerRead, void>({
        path: `/printing_orders/${id}/printer`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  printingPageCards = {
    /**
     * @description Creates a PrintingPageCard resource.
     *
     * @tags PrintingPageCard
     * @name ApiPrintingPageCardsPost
     * @summary Creates a PrintingPageCard resource.
     * @request POST:/printing_page_cards
     * @secure
     */
    apiPrintingPageCardsPost: (data: PrintingPageCardJsonldPrintingPageCardWrite, params: RequestParams = {}) =>
      this.request<PrintingPageCardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead, void>({
        path: `/printing_page_cards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a PrintingPageCard resource.
     *
     * @tags PrintingPageCard
     * @name ApiPrintingPageCardsIdGet
     * @summary Retrieves a PrintingPageCard resource.
     * @request GET:/printing_page_cards/{id}
     * @secure
     */
    apiPrintingPageCardsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PrintingPageCardJsonldPrintingPageCardReadPrintingOrderReadPrintingOrderPartnerRead, void>({
        path: `/printing_page_cards/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the PrintingPageCard resource.
     *
     * @tags PrintingPageCard
     * @name ApiPrintingPageCardsIdDelete
     * @summary Removes the PrintingPageCard resource.
     * @request DELETE:/printing_page_cards/{id}
     * @secure
     */
    apiPrintingPageCardsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/printing_page_cards/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  printingPages = {
    /**
     * @description Creates a PrintingPage resource.
     *
     * @tags PrintingPage
     * @name ApiPrintingPagesPost
     * @summary Creates a PrintingPage resource.
     * @request POST:/printing_pages
     * @secure
     */
    apiPrintingPagesPost: (data: PrintingPageJsonldPrintingPageWrite, params: RequestParams = {}) =>
      this.request<PrintingPageJsonldPrintingPageReadPrintingOrderPartnerRead, void>({
        path: `/printing_pages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a PrintingPage resource.
     *
     * @tags PrintingPage
     * @name ApiPrintingPagesIdGet
     * @summary Retrieves a PrintingPage resource.
     * @request GET:/printing_pages/{id}
     * @secure
     */
    apiPrintingPagesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PrintingPageJsonldPrintingPageReadPrintingOrderPartnerRead, void>({
        path: `/printing_pages/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the PrintingPage resource.
     *
     * @tags PrintingPage
     * @name ApiPrintingPagesIdDelete
     * @summary Removes the PrintingPage resource.
     * @request DELETE:/printing_pages/{id}
     * @secure
     */
    apiPrintingPagesIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/printing_pages/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  qrCodes = {
    /**
     * @description Retrieves the collection of QrCode resources.
     *
     * @tags QrCode
     * @name ApiQrCodesGetCollection
     * @summary Retrieves the collection of QrCode resources.
     * @request GET:/qr_codes
     * @secure
     */
    apiQrCodesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        hash?: string;
        'hash[]'?: string[];
        type?: string;
        'type[]'?: string[];
        'manufacture.reference'?: string;
        'manufacture.reference[]'?: string[];
        'ownership.card.reference'?: string;
        'ownership.card.reference[]'?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': QrCodeJsonldQrCodeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/qr_codes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a QrCode resource.
     *
     * @tags QrCode
     * @name ApiQrCodesIdGet
     * @summary Retrieves a QrCode resource.
     * @request GET:/qr_codes/{id}
     * @secure
     */
    apiQrCodesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<QrCodeJsonldQrCodeRead, void>({
        path: `/qr_codes/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a QrCode resource.
     *
     * @tags QrCode
     * @name ApiQrCodesIdcardGet
     * @summary Get Card from QRCode Hash
     * @request GET:/qr_codes/{id}/card
     * @secure
     */
    apiQrCodesIdcardGet: (id: string, params: RequestParams = {}) =>
      this.request<QrCodeCardJsonldQrCodeRead, void>({
        path: `/qr_codes/${id}/card`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  rarities = {
    /**
     * @description Retrieves the collection of Rarity resources.
     *
     * @tags Rarity
     * @name ApiRaritiesGetCollection
     * @summary Retrieves the collection of Rarity resources.
     * @request GET:/rarities
     * @secure
     */
    apiRaritiesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RarityJsonldRarityRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rarities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Rarity resource.
     *
     * @tags Rarity
     * @name ApiRaritiesReferenceGet
     * @summary Retrieves a Rarity resource.
     * @request GET:/rarities/{reference}
     * @secure
     */
    apiRaritiesReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<RarityJsonldRarityRead, void>({
        path: `/rarities/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ruleActions = {
    /**
     * @description Retrieves the collection of RuleAction resources.
     *
     * @tags RuleAction
     * @name ApiRuleActionsGetCollection
     * @summary Retrieves the collection of RuleAction resources.
     * @request GET:/rule_actions
     * @secure
     */
    apiRuleActionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleActionJsonldRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rule_actions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a RuleAction resource.
     *
     * @tags RuleAction
     * @name ApiRuleActionsPost
     * @summary Creates a RuleAction resource.
     * @request POST:/rule_actions
     * @secure
     */
    apiRuleActionsPost: (data: RuleActionJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleActionJsonldRuleRead, void>({
        path: `/rule_actions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a RuleAction resource.
     *
     * @tags RuleAction
     * @name ApiRuleActionsIdGet
     * @summary Retrieves a RuleAction resource.
     * @request GET:/rule_actions/{id}
     * @secure
     */
    apiRuleActionsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<RuleActionJsonldRuleRead, void>({
        path: `/rule_actions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the RuleAction resource.
     *
     * @tags RuleAction
     * @name ApiRuleActionsIdPut
     * @summary Replaces the RuleAction resource.
     * @request PUT:/rule_actions/{id}
     * @secure
     */
    apiRuleActionsIdPut: (id: string, data: RuleActionJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleActionJsonldRuleRead, void>({
        path: `/rule_actions/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ruleConditions = {
    /**
     * @description Retrieves the collection of RuleCondition resources.
     *
     * @tags RuleCondition
     * @name ApiRuleConditionsGetCollection
     * @summary Retrieves the collection of RuleCondition resources.
     * @request GET:/rule_conditions
     * @secure
     */
    apiRuleConditionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleConditionJsonldRuleRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rule_conditions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a RuleCondition resource.
     *
     * @tags RuleCondition
     * @name ApiRuleConditionsPost
     * @summary Creates a RuleCondition resource.
     * @request POST:/rule_conditions
     * @secure
     */
    apiRuleConditionsPost: (data: RuleConditionJsonldRuleRuleWrite, params: RequestParams = {}) =>
      this.request<RuleConditionJsonldRuleRuleRead, void>({
        path: `/rule_conditions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a RuleCondition resource.
     *
     * @tags RuleCondition
     * @name ApiRuleConditionsIdGet
     * @summary Retrieves a RuleCondition resource.
     * @request GET:/rule_conditions/{id}
     * @secure
     */
    apiRuleConditionsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<RuleConditionJsonldRuleRuleRead, void>({
        path: `/rule_conditions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the RuleCondition resource.
     *
     * @tags RuleCondition
     * @name ApiRuleConditionsIdPut
     * @summary Replaces the RuleCondition resource.
     * @request PUT:/rule_conditions/{id}
     * @secure
     */
    apiRuleConditionsIdPut: (id: string, data: RuleConditionJsonldRuleRuleWrite, params: RequestParams = {}) =>
      this.request<RuleConditionJsonldRuleRuleRead, void>({
        path: `/rule_conditions/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ruleGroupConditions = {
    /**
     * @description Retrieves the collection of RuleGroupCondition resources.
     *
     * @tags RuleGroupCondition
     * @name ApiRuleGroupConditionsGetCollection
     * @summary Retrieves the collection of RuleGroupCondition resources.
     * @request GET:/rule_group_conditions
     * @secure
     */
    apiRuleGroupConditionsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleGroupConditionJsonldRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rule_group_conditions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a RuleGroupCondition resource.
     *
     * @tags RuleGroupCondition
     * @name ApiRuleGroupConditionsPost
     * @summary Creates a RuleGroupCondition resource.
     * @request POST:/rule_group_conditions
     * @secure
     */
    apiRuleGroupConditionsPost: (data: RuleGroupConditionJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleGroupConditionJsonldRuleRead, void>({
        path: `/rule_group_conditions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a RuleGroupCondition resource.
     *
     * @tags RuleGroupCondition
     * @name ApiRuleGroupConditionsIdGet
     * @summary Retrieves a RuleGroupCondition resource.
     * @request GET:/rule_group_conditions/{id}
     * @secure
     */
    apiRuleGroupConditionsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<RuleGroupConditionJsonldRuleRead, void>({
        path: `/rule_group_conditions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the RuleGroupCondition resource.
     *
     * @tags RuleGroupCondition
     * @name ApiRuleGroupConditionsIdPut
     * @summary Replaces the RuleGroupCondition resource.
     * @request PUT:/rule_group_conditions/{id}
     * @secure
     */
    apiRuleGroupConditionsIdPut: (id: string, data: RuleGroupConditionJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleGroupConditionJsonldRuleRead, void>({
        path: `/rule_group_conditions/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ruleProcesses = {
    /**
     * @description Retrieves the collection of RuleProcess resources.
     *
     * @tags RuleProcess
     * @name ApiRuleProcessesGetCollection
     * @summary Retrieves the collection of RuleProcess resources.
     * @request GET:/rule_processes
     * @secure
     */
    apiRuleProcessesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleProcessJsonldRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rule_processes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a RuleProcess resource.
     *
     * @tags RuleProcess
     * @name ApiRuleProcessesPost
     * @summary Creates a RuleProcess resource.
     * @request POST:/rule_processes
     * @secure
     */
    apiRuleProcessesPost: (data: RuleProcessJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleProcessJsonldRuleRead, void>({
        path: `/rule_processes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a RuleProcess resource.
     *
     * @tags RuleProcess
     * @name ApiRuleProcessesIdGet
     * @summary Retrieves a RuleProcess resource.
     * @request GET:/rule_processes/{id}
     * @secure
     */
    apiRuleProcessesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<RuleProcessJsonldRuleRead, void>({
        path: `/rule_processes/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the RuleProcess resource.
     *
     * @tags RuleProcess
     * @name ApiRuleProcessesIdPut
     * @summary Replaces the RuleProcess resource.
     * @request PUT:/rule_processes/{id}
     * @secure
     */
    apiRuleProcessesIdPut: (id: string, data: RuleProcessJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleProcessJsonldRuleRead, void>({
        path: `/rule_processes/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  rules = {
    /**
     * @description Retrieves the collection of Rule resources.
     *
     * @tags Rule
     * @name ApiRulesGetCollection
     * @summary Retrieves the collection of Rule resources.
     * @request GET:/rules
     * @secure
     */
    apiRulesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        type?: string;
        'type[]'?: string[];
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleJsonldRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rules`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Rule resource.
     *
     * @tags Rule
     * @name ApiRulesPost
     * @summary Creates a Rule resource.
     * @request POST:/rules
     * @secure
     */
    apiRulesPost: (data: RuleJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleJsonldRuleRead, void>({
        path: `/rules`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the parameters needed to create a rule creation / edit form.
     *
     * @tags Rule
     * @name ApiRulesparametersGetCollection
     * @summary Rule Parameters
     * @request GET:/rules/parameters
     * @secure
     */
    apiRulesparametersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        type?: string;
        'type[]'?: string[];
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': RuleJsonldRuleRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/rules/parameters`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Rule resource.
     *
     * @tags Rule
     * @name ApiRulesReferenceGet
     * @summary Retrieves a Rule resource.
     * @request GET:/rules/{reference}
     * @secure
     */
    apiRulesReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<RuleJsonldRuleRead, void>({
        path: `/rules/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Rule resource.
     *
     * @tags Rule
     * @name ApiRulesReferencePut
     * @summary Replaces the Rule resource.
     * @request PUT:/rules/{reference}
     * @secure
     */
    apiRulesReferencePut: (reference: string, data: RuleJsonldRuleWrite, params: RequestParams = {}) =>
      this.request<RuleJsonldRuleRead, void>({
        path: `/rules/${reference}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Launch a specific asynchronous rule.
     *
     * @tags Rule
     * @name ApiRulesReferencelaunchGet
     * @summary Rule Launch
     * @request GET:/rules/{reference}/launch
     * @secure
     */
    apiRulesReferencelaunchGet: (reference: string, params: RequestParams = {}) =>
      this.request<RuleJsonldRuleRead, void>({
        path: `/rules/${reference}/launch`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Preview asynchronous rule.
     *
     * @tags Rule
     * @name ApiRulesReferencepreviewGet
     * @summary Rule Preview
     * @request GET:/rules/{reference}/preview
     * @secure
     */
    apiRulesReferencepreviewGet: (reference: string, params: RequestParams = {}) =>
      this.request<RuleJsonldRuleRead, void>({
        path: `/rules/${reference}/preview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  seasonPassUsers = {
    /**
     * @description Creates a SeasonPassUser resource.
     *
     * @tags SeasonPassUser
     * @name ApiSeasonPassUsersPost
     * @summary Creates a SeasonPassUser resource.
     * @request POST:/season_pass_users
     * @secure
     */
    apiSeasonPassUsersPost: (data: SeasonPassUserJsonldSeasonPassUserWrite, params: RequestParams = {}) =>
      this.request<SeasonPassUserJsonldSeasonPassUserRead, void>({
        path: `/season_pass_users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the user by unique ID.
     *
     * @tags SeasonPassUser
     * @name ApiSeasonPassUsersuserUniqueIdGet
     * @summary Get the user by unique ID
     * @request GET:/season_pass_users/user/{uniqueId}
     * @secure
     */
    apiSeasonPassUsersuserUniqueIdGet: (uniqueId: string, params: RequestParams = {}) =>
      this.request<SeasonPassUserJsonldSeasonPassUserRead, void>({
        path: `/season_pass_users/user/${uniqueId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a SeasonPassUser resource.
     *
     * @tags SeasonPassUser
     * @name ApiSeasonPassUsersIdGet
     * @summary Retrieves a SeasonPassUser resource.
     * @request GET:/season_pass_users/{id}
     * @secure
     */
    apiSeasonPassUsersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<SeasonPassUserJsonldSeasonPassUserRead, void>({
        path: `/season_pass_users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  seasonPasses = {
    /**
     * @description Retrieves the collection of SeasonPass resources.
     *
     * @tags SeasonPass
     * @name ApiSeasonPassesGetCollection
     * @summary Retrieves the collection of SeasonPass resources.
     * @request GET:/season_passes
     * @secure
     */
    apiSeasonPassesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        'startDate[before]'?: string;
        'startDate[strictly_before]'?: string;
        'startDate[after]'?: string;
        'startDate[strictly_after]'?: string;
        'endDate[before]'?: string;
        'endDate[strictly_before]'?: string;
        'endDate[after]'?: string;
        'endDate[strictly_after]'?: string;
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': SeasonPassJsonldSeasonPassRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/season_passes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a SeasonPass resource.
     *
     * @tags SeasonPass
     * @name ApiSeasonPassesIdGet
     * @summary Retrieves a SeasonPass resource.
     * @request GET:/season_passes/{id}
     * @secure
     */
    apiSeasonPassesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<SeasonPassJsonldSeasonPassRead, void>({
        path: `/season_passes/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a SeasonPass resource.
     *
     * @tags SeasonPass
     * @name ApiSeasonPassesIduserUniqueIdGet
     * @summary Retrieves a SeasonPass resource.
     * @request GET:/season_passes/{id}/user/{uniqueId}
     * @secure
     */
    apiSeasonPassesIduserUniqueIdGet: (id: string, uniqueId: string, params: RequestParams = {}) =>
      this.request<SeasonPassJsonldSeasonPassRead, void>({
        path: `/season_passes/${id}/user/${uniqueId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shopDeletionStatuses = {
    /**
     * @description Retrieves the collection of ShopDeletionStatus resources.
     *
     * @tags ShopDeletionStatus
     * @name ApiShopDeletionStatusesGetCollection
     * @summary Retrieves the collection of ShopDeletionStatus resources.
     * @request GET:/shop_deletion_statuses
     * @secure
     */
    apiShopDeletionStatusesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopDeletionStatusJsonldShopDeletionStatusRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shop_deletion_statuses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a ShopDeletionStatus resource.
     *
     * @tags ShopDeletionStatus
     * @name ApiShopDeletionStatusesIdGet
     * @summary Retrieves a ShopDeletionStatus resource.
     * @request GET:/shop_deletion_statuses/{id}
     * @secure
     */
    apiShopDeletionStatusesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<ShopDeletionStatusJsonldShopDeletionStatusRead, void>({
        path: `/shop_deletion_statuses/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shopDistributors = {
    /**
     * @description Retrieves the collection of ShopDistributor resources.
     *
     * @tags ShopDistributor
     * @name ApiShopDistributorsGetCollection
     * @summary Retrieves the collection of ShopDistributor resources.
     * @request GET:/shop_distributors
     * @secure
     */
    apiShopDistributorsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopDistributorJsonldShopDistributorRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shop_distributors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a ShopDistributor resource.
     *
     * @tags ShopDistributor
     * @name ApiShopDistributorsReferenceGet
     * @summary Retrieves a ShopDistributor resource.
     * @request GET:/shop_distributors/{reference}
     * @secure
     */
    apiShopDistributorsReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<ShopDistributorJsonldShopDistributorRead, void>({
        path: `/shop_distributors/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shopEventTypes = {
    /**
     * @description Retrieves the collection of EventType resources.
     *
     * @tags EventType
     * @name ApiShopEventTypesGetCollection
     * @summary Retrieves the collection of EventType resources.
     * @request GET:/shop_event_types
     * @secure
     */
    apiShopEventTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': EventTypeShopEventTypeJsonldEventTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shop_event_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shopMembers = {
    /**
     * @description Retrieves the collection of ShopMember resources.
     *
     * @tags ShopMember
     * @name ApiShopMembersGetCollection
     * @summary Retrieves the collection of ShopMember resources.
     * @request GET:/shop_members
     * @secure
     */
    apiShopMembersGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopMemberJsonldShopMemberRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shop_members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a ShopMember resource.
     *
     * @tags ShopMember
     * @name ApiShopMembersIdGet
     * @summary Retrieves a ShopMember resource.
     * @request GET:/shop_members/{id}
     * @secure
     */
    apiShopMembersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<ShopMemberJsonldShopMemberRead, void>({
        path: `/shop_members/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the ShopMember resource.
     *
     * @tags ShopMember
     * @name ApiShopMembersIdPut
     * @summary Replaces the ShopMember resource.
     * @request PUT:/shop_members/{id}
     * @secure
     */
    apiShopMembersIdPut: (id: string, data: ShopMemberJsonldShopMemberWrite, params: RequestParams = {}) =>
      this.request<ShopMemberJsonldShopMemberRead, void>({
        path: `/shop_members/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the ShopMember resource.
     *
     * @tags ShopMember
     * @name ApiShopMembersIdDelete
     * @summary Removes the ShopMember resource.
     * @request DELETE:/shop_members/{id}
     * @secure
     */
    apiShopMembersIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/shop_members/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  shopSocialNetworks = {
    /**
     * @description Retrieves the collection of ShopSocialNetwork resources.
     *
     * @tags ShopSocialNetwork
     * @name ApiShopSocialNetworksGetCollection
     * @summary Retrieves the collection of ShopSocialNetwork resources.
     * @request GET:/shop_social_networks
     * @secure
     */
    apiShopSocialNetworksGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopSocialNetworkJsonldShopSocialNetworkRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shop_social_networks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a ShopSocialNetwork resource.
     *
     * @tags ShopSocialNetwork
     * @name ApiShopSocialNetworksPost
     * @summary Creates a ShopSocialNetwork resource.
     * @request POST:/shop_social_networks
     * @secure
     */
    apiShopSocialNetworksPost: (data: ShopSocialNetworkJsonldShopSocialNetworkWrite, params: RequestParams = {}) =>
      this.request<ShopSocialNetworkJsonldShopSocialNetworkRead, void>({
        path: `/shop_social_networks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a ShopSocialNetwork resource.
     *
     * @tags ShopSocialNetwork
     * @name ApiShopSocialNetworksIdGet
     * @summary Retrieves a ShopSocialNetwork resource.
     * @request GET:/shop_social_networks/{id}
     * @secure
     */
    apiShopSocialNetworksIdGet: (id: string, params: RequestParams = {}) =>
      this.request<ShopSocialNetworkJsonldShopSocialNetworkRead, void>({
        path: `/shop_social_networks/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the ShopSocialNetwork resource.
     *
     * @tags ShopSocialNetwork
     * @name ApiShopSocialNetworksIdPut
     * @summary Replaces the ShopSocialNetwork resource.
     * @request PUT:/shop_social_networks/{id}
     * @secure
     */
    apiShopSocialNetworksIdPut: (
      id: string,
      data: ShopSocialNetworkJsonldShopSocialNetworkWrite,
      params: RequestParams = {},
    ) =>
      this.request<ShopSocialNetworkJsonldShopSocialNetworkRead, void>({
        path: `/shop_social_networks/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  shops = {
    /**
     * @description Retrieves the collection of Shop resources.
     *
     * @tags Shop
     * @name ApiShopsGetCollection
     * @summary Retrieves the collection of Shop resources.
     * @request GET:/shops
     * @secure
     */
    apiShopsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        mobilityReducedAccessibility?: boolean;
        'mobilityReducedAccessibility[]'?: boolean[];
        sanitary?: boolean;
        'sanitary[]'?: boolean[];
        eatingSpace?: boolean;
        'eatingSpace[]'?: boolean[];
        printOnDemand?: boolean;
        'printOnDemand[]'?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopJsonldShopRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shops`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Shop resource.
     *
     * @tags Shop
     * @name ApiShopsPost
     * @summary Creates a Shop resource.
     * @request POST:/shops
     * @secure
     */
    apiShopsPost: (data: ShopJsonldShopWrite, params: RequestParams = {}) =>
      this.request<ShopJsonldShopRead, void>({
        path: `/shops`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Shop near the location.
     *
     * @tags Shop
     * @name ApiShopslocatorGetCollection
     * @summary Shop Locator
     * @request GET:/shops/locator
     * @secure
     */
    apiShopslocatorGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @max 50
         * @default 30
         */
        itemsPerPage?: number;
        /** Filter by coordinate */
        latitude?: number;
        /** Filter by coordinate */
        longitude?: number;
        /** Max distance with latitude and longitude */
        maxDistance?: 10 | 20 | 50 | 100;
        /** Unit system used for calculation */
        unit?: 'meters' | 'miles';
        /** Date from which shops have an event planned */
        from?: number;
        /** Date until which shops have an event planned */
        to?: number;
        /**
         * Country
         * @example ["FR","US"]
         */
        country?: string;
        id?: string;
        'id[]'?: string[];
        mobilityReducedAccessibility?: boolean;
        'mobilityReducedAccessibility[]'?: boolean[];
        sanitary?: boolean;
        'sanitary[]'?: boolean[];
        eatingSpace?: boolean;
        'eatingSpace[]'?: boolean[];
        printOnDemand?: boolean;
        'printOnDemand[]'?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': ShopJsonldShopLocatorRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/shops/locator`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Shop resource.
     *
     * @tags Shop
     * @name ApiShopsIdGet
     * @summary Retrieves a Shop resource.
     * @request GET:/shops/{id}
     * @secure
     */
    apiShopsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<
        ShopJsonldShopReadShopMemberReadShopDetailReadUserReadAddressReadCountryReadShopSocialNetworkReadSocialNetworkReadMediaRead,
        void
      >({
        path: `/shops/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Shop resource.
     *
     * @tags Shop
     * @name ApiShopsIdPut
     * @summary Replaces the Shop resource.
     * @request PUT:/shops/{id}
     * @secure
     */
    apiShopsIdPut: (id: string, data: ShopJsonldShopWrite, params: RequestParams = {}) =>
      this.request<ShopJsonldShopRead, void>({
        path: `/shops/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the Shop resource.
     *
     * @tags Shop
     * @name ApiShopsIdDelete
     * @summary Delete a Shop
     * @request DELETE:/shops/{id}
     * @secure
     */
    apiShopsIdDelete: (
      id: string,
      data?: {
        onDeletionCommentary?: string;
        /** @example "/shop_deletion_statuses/XXXXXX" */
        shopDeletionStatus?: string;
        /** @example "mySuperPassword" */
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/shops/${id}`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Retrieves a Shop resource.
     *
     * @tags Shop
     * @name ApiShopsIdstatsGet
     * @summary Retrieves a Shop resource.
     * @request GET:/shops/{id}/stats
     * @secure
     */
    apiShopsIdstatsGet: (id: string, params: RequestParams = {}) =>
      this.request<ShopJsonldShopStatRead, void>({
        path: `/shops/${id}/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  socialNetworks = {
    /**
     * @description Retrieves the collection of SocialNetwork resources.
     *
     * @tags SocialNetwork
     * @name ApiSocialNetworksGetCollection
     * @summary Retrieves the collection of SocialNetwork resources.
     * @request GET:/social_networks
     * @secure
     */
    apiSocialNetworksGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        name?: string;
        isConnect?: boolean;
        'isConnect[]'?: boolean[];
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
        'order[id]'?: 'asc' | 'desc';
        'order[reference]'?: 'asc' | 'desc';
        'order[name]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': SocialNetworkJsonldSocialNetworkRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/social_networks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a SocialNetwork resource.
     *
     * @tags SocialNetwork
     * @name ApiSocialNetworksReferenceGet
     * @summary Retrieves a SocialNetwork resource.
     * @request GET:/social_networks/{reference}
     * @secure
     */
    apiSocialNetworksReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<SocialNetworkJsonldSocialNetworkRead, void>({
        path: `/social_networks/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  surveyTypes = {
    /**
     * @description Retrieves the collection of SurveyType resources.
     *
     * @tags SurveyType
     * @name ApiSurveyTypesGetCollection
     * @summary Retrieves the collection of SurveyType resources.
     * @request GET:/survey_types
     * @secure
     */
    apiSurveyTypesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': SurveyTypeJsonldSurveyTypeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/survey_types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a SurveyType resource.
     *
     * @tags SurveyType
     * @name ApiSurveyTypesIdGet
     * @summary Retrieves a SurveyType resource.
     * @request GET:/survey_types/{id}
     * @secure
     */
    apiSurveyTypesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<SurveyTypeJsonldSurveyTypeRead, void>({
        path: `/survey_types/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  surveys = {
    /**
     * @description Retrieves the collection of Survey resources.
     *
     * @tags Survey
     * @name ApiSurveysGetCollection
     * @summary Retrieves the collection of Survey resources.
     * @request GET:/surveys
     * @secure
     */
    apiSurveysGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        id?: string;
        'id[]'?: string[];
        reference?: string;
        'reference[]'?: string[];
        name?: string;
        'order[name]'?: 'asc' | 'desc';
        'order[createdAt]'?: 'asc' | 'desc';
        'order[updatedAt]'?: 'asc' | 'desc';
        'createdAt[before]'?: string;
        'createdAt[strictly_before]'?: string;
        'createdAt[after]'?: string;
        'createdAt[strictly_after]'?: string;
        'updatedAt[before]'?: string;
        'updatedAt[strictly_before]'?: string;
        'updatedAt[after]'?: string;
        'updatedAt[strictly_after]'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': SurveyJsonldSurveyRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/surveys`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Survey resource.
     *
     * @tags Survey
     * @name ApiSurveysPost
     * @summary Creates a Survey resource.
     * @request POST:/surveys
     * @secure
     */
    apiSurveysPost: (data: SurveyJsonldSurveyWrite, params: RequestParams = {}) =>
      this.request<SurveyJsonldSurveyRead, void>({
        path: `/surveys`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a form created from a Google Form.
     *
     * @tags Survey
     * @name ApiSurveysgoogleFormReferenceGet
     * @summary Get a survey from Google
     * @request GET:/surveys/google-form/{reference}
     * @secure
     */
    apiSurveysgoogleFormReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<SurveyJsonld, void>({
        path: `/surveys/google-form/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send responses to a survey to Google Form.
     *
     * @tags Survey
     * @name ApiSurveysresponsesPost
     * @summary Send responses to Google
     * @request POST:/surveys/responses
     * @secure
     */
    apiSurveysresponsesPost: (data: SurveyJsonldSurveyWrite, params: RequestParams = {}) =>
      this.request<SurveyJsonldSurveyRead, void>({
        path: `/surveys/responses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Survey resource.
     *
     * @tags Survey
     * @name ApiSurveysReferenceGet
     * @summary Retrieves a Survey resource.
     * @request GET:/surveys/{reference}
     * @secure
     */
    apiSurveysReferenceGet: (reference: string, params: RequestParams = {}) =>
      this.request<SurveyJsonldSurveyRead, void>({
        path: `/surveys/${reference}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the Survey resource.
     *
     * @tags Survey
     * @name ApiSurveysReferencePut
     * @summary Replaces the Survey resource.
     * @request PUT:/surveys/{reference}
     * @secure
     */
    apiSurveysReferencePut: (reference: string, data: SurveyJsonldSurveyWrite, params: RequestParams = {}) =>
      this.request<SurveyJsonldSurveyRead, void>({
        path: `/surveys/${reference}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tags = {
    /**
     * @description Retrieves the collection of Tag resources.
     *
     * @tags Tag
     * @name ApiTagsGetCollection
     * @summary Retrieves the collection of Tag resources.
     * @request GET:/tags
     * @secure
     */
    apiTagsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': TagJsonldTagRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a Tag resource.
     *
     * @tags Tag
     * @name ApiTagsIdGet
     * @summary Retrieves a Tag resource.
     * @request GET:/tags/{id}
     * @secure
     */
    apiTagsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<TagJsonldTagRead, void>({
        path: `/tags/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tokenDevices = {
    /**
     * @description Retrieves the collection of TokenDevice resources.
     *
     * @tags TokenDevice
     * @name ApiTokenDevicesGetCollection
     * @summary Retrieves the collection of TokenDevice resources.
     * @request GET:/token_devices
     * @secure
     */
    apiTokenDevicesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': TokenDeviceJsonldTokenDeviceRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/token_devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a TokenDevice resource.
     *
     * @tags TokenDevice
     * @name ApiTokenDevicesPost
     * @summary Creates a TokenDevice resource.
     * @request POST:/token_devices
     * @secure
     */
    apiTokenDevicesPost: (data: TokenDeviceJsonldTokenDeviceWrite, params: RequestParams = {}) =>
      this.request<TokenDeviceJsonldTokenDeviceRead, void>({
        path: `/token_devices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a TokenDevice resource.
     *
     * @tags TokenDevice
     * @name ApiTokenDevicesIdGet
     * @summary Retrieves a TokenDevice resource.
     * @request GET:/token_devices/{id}
     * @secure
     */
    apiTokenDevicesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<TokenDeviceJsonldTokenDeviceRead, void>({
        path: `/token_devices/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the TokenDevice resource.
     *
     * @tags TokenDevice
     * @name ApiTokenDevicesIdPut
     * @summary Replaces the TokenDevice resource.
     * @request PUT:/token_devices/{id}
     * @secure
     */
    apiTokenDevicesIdPut: (id: string, data: TokenDeviceJsonldTokenDeviceWrite, params: RequestParams = {}) =>
      this.request<TokenDeviceJsonldTokenDeviceRead, void>({
        path: `/token_devices/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * @description Return the stats of the game for the user.
     *
     * @tags User
     * @name ApiUsergameStatsGet
     * @summary Get the stats of the user's game
     * @request GET:/user/gameStats
     * @secure
     */
    apiUsergameStatsGet: (params: RequestParams = {}) =>
      this.request<UserUserGameStatsJsonldUserGameStatsRead, void>({
        path: `/user/gameStats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a User resource.
     *
     * @tags User
     * @name ApiUsersumsubtokenGet
     * @summary Retrieves a User resource.
     * @request GET:/user/sumsub/token
     * @secure
     */
    apiUsersumsubtokenGet: (params: RequestParams = {}) =>
      this.request<UserSumsubTokenJsonldUserRead, void>({
        path: `/user/sumsub/token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a User resource.
     *
     * @tags User
     * @name ApiUserzendeskjwtGet
     * @summary Retrieves a User resource.
     * @request GET:/user/zendesk/jwt
     * @secure
     */
    apiUserzendeskjwtGet: (params: RequestParams = {}) =>
      this.request<UserZendeskJwtJsonldUserRead, void>({
        path: `/user/zendesk/jwt`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userAccesses = {
    /**
     * @description Retrieves the collection of UserAccess resources.
     *
     * @tags UserAccess
     * @name ApiUserAccessesGetCollection
     * @summary Retrieves the collection of UserAccess resources.
     * @request GET:/user_accesses
     * @secure
     */
    apiUserAccessesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserAccessJsonldUserAccessRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_accesses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a UserAccess resource.
     *
     * @tags UserAccess
     * @name ApiUserAccessesIdGet
     * @summary Retrieves a UserAccess resource.
     * @request GET:/user_accesses/{id}
     * @secure
     */
    apiUserAccessesIdGet: (id: string, params: RequestParams = {}) =>
      this.request<UserAccessJsonldUserAccessRead, void>({
        path: `/user_accesses/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userBadges = {
    /**
     * @description Retrieves the collection of Badge resources.
     *
     * @tags Badge
     * @name ApiUserBadgesGetCollection
     * @summary Retrieves the collection of Badge resources.
     * @request GET:/user_badges
     * @secure
     */
    apiUserBadgesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': BadgeJsonldBadgeRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_badges`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userBlockeds = {
    /**
     * @description Retrieves the collection of UserBlocked resources.
     *
     * @tags UserBlocked
     * @name ApiUserBlockedsGetCollection
     * @summary Retrieves the collection of UserBlocked resources.
     * @request GET:/user_blockeds
     * @secure
     */
    apiUserBlockedsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserBlockedJsonldUserBlockedRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_blockeds`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Blocked User.
     *
     * @tags UserBlocked
     * @name ApiUserBlockedsIdPost
     * @summary Blocked User
     * @request POST:/user_blockeds/{id}
     * @secure
     */
    apiUserBlockedsIdPost: (id: string, data: UserBlockedJsonld, params: RequestParams = {}) =>
      this.request<UserBlockedJsonldUserBlockedRead, void>({
        path: `/user_blockeds/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the UserBlocked resource.
     *
     * @tags UserBlocked
     * @name ApiUserBlockedsIdDelete
     * @summary Removes the UserBlocked resource.
     * @request DELETE:/user_blockeds/{id}
     * @secure
     */
    apiUserBlockedsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/user_blockeds/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  userFriendRequests = {
    /**
     * @description Retrieves the collection of UserFriendRequest resources.
     *
     * @tags UserFriendRequest
     * @name ApiUserFriendRequestsGetCollection
     * @summary Retrieves the collection of UserFriendRequest resources.
     * @request GET:/user_friend_requests
     * @secure
     */
    apiUserFriendRequestsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        status?: string;
        'status[]'?: string[];
        'sender.nickName'?: string;
        'receiver.nickName'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserFriendRequestJsonldUserFriendRequestRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_friend_requests`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a UserFriendRequest resource.
     *
     * @tags UserFriendRequest
     * @name ApiUserFriendRequestsPost
     * @summary Creates a UserFriendRequest resource.
     * @request POST:/user_friend_requests
     * @secure
     */
    apiUserFriendRequestsPost: (data: UserFriendRequestJsonldUserFriendRequestWrite, params: RequestParams = {}) =>
      this.request<UserFriendRequestJsonldUserFriendRequestRead, void>({
        path: `/user_friend_requests`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userFriendships = {
    /**
     * @description Retrieves the collection of UserFriendship resources.
     *
     * @tags UserFriendship
     * @name ApiUserFriendshipsGetCollection
     * @summary Retrieves the collection of UserFriendship resources.
     * @request GET:/user_friendships
     * @secure
     */
    apiUserFriendshipsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        'user.nickName'?: string;
        'userFriend.nickName'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserFriendshipJsonldUserFriendshipReadUserRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_friendships`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the user's friends information's of a friend.
     *
     * @tags UserFriendship
     * @name ApiUserFriendshipsfriendsIdGetCollection
     * @summary Get the user's friends of a friend
     * @request GET:/user_friendships/friends/{id}
     * @secure
     */
    apiUserFriendshipsfriendsIdGetCollection: (
      id: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        'user.nickName'?: string;
        'userFriend.nickName'?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserFriendshipJsonldUserFriendshipReadUserRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_friendships/friends/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the UserFriendship resource.
     *
     * @tags UserFriendship
     * @name ApiUserFriendshipsIdDelete
     * @summary Removes the UserFriendship resource.
     * @request DELETE:/user_friendships/{id}
     * @secure
     */
    apiUserFriendshipsIdDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/user_friendships/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  userGroups = {
    /**
     * @description Retrieves the collection of UserGroup resources.
     *
     * @tags UserGroup
     * @name ApiUserGroupsGetCollection
     * @summary Retrieves the collection of UserGroup resources.
     * @request GET:/user_groups
     * @secure
     */
    apiUserGroupsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserGroupJsonldUserGroupRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_groups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a UserGroup resource.
     *
     * @tags UserGroup
     * @name ApiUserGroupsIdGet
     * @summary Retrieves a UserGroup resource.
     * @request GET:/user_groups/{id}
     * @secure
     */
    apiUserGroupsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<UserGroupJsonldUserGroupRead, void>({
        path: `/user_groups/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userOptins = {
    /**
     * @description Retrieves the collection of UserOptin resources.
     *
     * @tags UserOptin
     * @name ApiUserOptinsGetCollection
     * @summary Retrieves the collection of UserOptin resources.
     * @request GET:/user_optins
     * @secure
     */
    apiUserOptinsGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserOptinJsonldUserOptinRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_optins`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a UserOptin resource.
     *
     * @tags UserOptin
     * @name ApiUserOptinsPost
     * @summary Creates a UserOptin resource.
     * @request POST:/user_optins
     * @secure
     */
    apiUserOptinsPost: (data: UserOptinJsonldUserOptinWrite, params: RequestParams = {}) =>
      this.request<UserOptinJsonldUserOptinRead, void>({
        path: `/user_optins`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a UserOptin resource.
     *
     * @tags UserOptin
     * @name ApiUserOptinsIdGet
     * @summary Retrieves a UserOptin resource.
     * @request GET:/user_optins/{id}
     * @secure
     */
    apiUserOptinsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<UserOptinJsonldUserOptinRead, void>({
        path: `/user_optins/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the UserOptin resource.
     *
     * @tags UserOptin
     * @name ApiUserOptinsIdPut
     * @summary Replaces the UserOptin resource.
     * @request PUT:/user_optins/{id}
     * @secure
     */
    apiUserOptinsIdPut: (id: string, data: UserOptinJsonldUserOptinWrite, params: RequestParams = {}) =>
      this.request<UserOptinJsonldUserOptinRead, void>({
        path: `/user_optins/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userRewards = {
    /**
     * @description Retrieves the collection of UserReward resources.
     *
     * @tags UserReward
     * @name ApiUserRewardsUniqueIdseasonSeasonPassGetCollection
     * @summary Retrieves the collection of UserReward resources.
     * @request GET:/user_rewards/{uniqueId}/season/{seasonPass}
     * @secure
     */
    apiUserRewardsUniqueIdseasonSeasonPassGetCollection: (
      uniqueId: string,
      seasonPass: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        seasonPass?: string;
        'seasonPass[]'?: string[];
        'user.uniqueId'?: string;
        'user.uniqueId[]'?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserRewardJsonldUserRewardRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_rewards/${uniqueId}/season/${seasonPass}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userSocialNetworks = {
    /**
     * @description Retrieves the collection of UserSocialNetwork resources.
     *
     * @tags UserSocialNetwork
     * @name ApiUserSocialNetworksGetCollection
     * @summary Retrieves the collection of UserSocialNetwork resources.
     * @request GET:/user_social_networks
     * @secure
     */
    apiUserSocialNetworksGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          'hydra:member': UserSocialNetworkJsonldUserSocialNetworkRead[];
          /** @min 0 */
          'hydra:totalItems'?: number;
          /** @example {"@id":"string","type":"string","hydra:first":"string","hydra:last":"string","hydra:previous":"string","hydra:next":"string"} */
          'hydra:view'?: {
            /** @format iri-reference */
            '@id'?: string;
            '@type'?: string;
            /** @format iri-reference */
            'hydra:first'?: string;
            /** @format iri-reference */
            'hydra:last'?: string;
            /** @format iri-reference */
            'hydra:previous'?: string;
            /** @format iri-reference */
            'hydra:next'?: string;
          };
          'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:variableRepresentation'?: string;
            'hydra:mapping'?: {
              '@type'?: string;
              variable?: string;
              property?: string | null;
              required?: boolean;
            }[];
          };
        },
        any
      >({
        path: `/user_social_networks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a UserSocialNetwork resource.
     *
     * @tags UserSocialNetwork
     * @name ApiUserSocialNetworksPost
     * @summary Creates a UserSocialNetwork resource.
     * @request POST:/user_social_networks
     * @secure
     */
    apiUserSocialNetworksPost: (data: UserSocialNetworkJsonldUserSocialNetworkWrite, params: RequestParams = {}) =>
      this.request<UserSocialNetworkJsonldUserSocialNetworkRead, void>({
        path: `/user_social_networks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a UserSocialNetwork resource.
     *
     * @tags UserSocialNetwork
     * @name ApiUserSocialNetworksIdGet
     * @summary Retrieves a UserSocialNetwork resource.
     * @request GET:/user_social_networks/{id}
     * @secure
     */
    apiUserSocialNetworksIdGet: (id: string, params: RequestParams = {}) =>
      this.request<UserSocialNetworkJsonldUserSocialNetworkRead, void>({
        path: `/user_social_networks/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the UserSocialNetwork resource.
     *
     * @tags UserSocialNetwork
     * @name ApiUserSocialNetworksIdPut
     * @summary Replaces the UserSocialNetwork resource.
     * @request PUT:/user_social_networks/{id}
     * @secure
     */
    apiUserSocialNetworksIdPut: (
      id: string,
      data: UserSocialNetworkJsonldUserSocialNetworkWrite,
      params: RequestParams = {},
    ) =>
      this.request<UserSocialNetworkJsonldUserSocialNetworkRead, void>({
        path: `/user_social_networks/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userTokens = {
    /**
     * @description Creates a UserToken resource.
     *
     * @tags UserToken
     * @name ApiUserTokensPost
     * @summary Creates a UserToken resource.
     * @request POST:/user_tokens
     * @secure
     */
    apiUserTokensPost: (data: UserTokenJsonldUserTokenWrite, params: RequestParams = {}) =>
      this.request<UserTokenJsonldUserTokenCreateRead, void>({
        path: `/user_tokens`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a UserToken resource.
     *
     * @tags UserToken
     * @name ApiUserTokensTokenGet
     * @summary Retrieves a UserToken resource.
     * @request GET:/user_tokens/{token}
     * @secure
     */
    apiUserTokensTokenGet: (token: string, params: RequestParams = {}) =>
      this.request<UserTokenJsonldUserTokenRead, void>({
        path: `/user_tokens/${token}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  users = {
    /**
     * @description Create an User for join newsletter.
     *
     * @tags User
     * @name ApiUsersaddToNewsletterPost
     * @summary Create a Newsletter User
     * @request POST:/users/add-to-newsletter
     * @secure
     */
    apiUsersaddToNewsletterPost: (data: UserJsonldUserWrite, params: RequestParams = {}) =>
      this.request<UserJsonldUserPrivateReadUserTokenRead, void>({
        path: `/users/add-to-newsletter`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create an User with the minimum properties.
     *
     * @tags User
     * @name ApiUserscreateIdPut
     * @summary Create an User
     * @request PUT:/users/create/{id}
     * @secure
     */
    apiUserscreateIdPut: (id: string, data: UserJsonldUserWrite, params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinRead, void>({
        path: `/users/create/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Removes the User resource.
     *
     * @tags User
     * @name ApiUsersdeleteAccountDelete
     * @summary Removes the User resource.
     * @request DELETE:/users/delete-account
     * @secure
     */
    apiUsersdeleteAccountDelete: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/users/delete-account`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get the user by unique ID.
     *
     * @tags User
     * @name ApiUsersprofileUniqueIdGet
     * @summary Get the user by unique ID
     * @request GET:/users/profile/{uniqueId}
     * @secure
     */
    apiUsersprofileUniqueIdGet: (uniqueId: string, params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserFriendshipRead, void>({
        path: `/users/profile/${uniqueId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a User resource.
     *
     * @tags User
     * @name ApiUserssearchUniqueIdGet
     * @summary Search User by unique ID - Used for Friendship search
     * @request GET:/users/search/{uniqueId}
     * @secure
     */
    apiUserssearchUniqueIdGet: (uniqueId: string, params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserFriendshipRead, void>({
        path: `/users/search/${uniqueId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Shop Member
     *
     * @tags User
     * @name ApiUsersshopMemberPost
     * @summary Create a Shop Member
     * @request POST:/users/shop-member
     * @secure
     */
    apiUsersshopMemberPost: (data: UserJsonldUserWriteShopWrite, params: RequestParams = {}) =>
      this.request<
        UserJsonldUserReadUserPrivateReadUserTokenReadUserSocialNetworkReadUserOptinReadShopReadAddressReadCountryRead,
        void
      >({
        path: `/users/shop-member`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Check if the email is unique.
     *
     * @tags User
     * @name ApiUsersuniqueEmailEmailGet
     * @summary Unique Email
     * @request GET:/users/unique-email/{email}
     * @secure
     */
    apiUsersuniqueEmailEmailGet: (email: string, params: RequestParams = {}) =>
      this.request<UserUserUniqueEmailJsonldUserUniqueEmailRead, void>({
        path: `/users/unique-email/${email}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Check if the nickname is unique.
     *
     * @tags User
     * @name ApiUsersuniqueNicknameNickNameGet
     * @summary Unique Nickname
     * @request GET:/users/unique-nickname/{nickName}
     * @secure
     */
    apiUsersuniqueNicknameNickNameGet: (nickName: string, params: RequestParams = {}) =>
      this.request<UserUserUniqueNicknameJsonldUserUniqueNicknameRead, void>({
        path: `/users/unique-nickname/${nickName}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a User resource.
     *
     * @tags User
     * @name ApiUsersIdGet
     * @summary Retrieves a User resource.
     * @request GET:/users/{id}
     * @secure
     */
    apiUsersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<UserJsonldUserReadUserFriendshipRead, void>({
        path: `/users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces the User resource.
     *
     * @tags User
     * @name ApiUsersIdPut
     * @summary Replaces the User resource.
     * @request PUT:/users/{id}
     * @secure
     */
    apiUsersIdPut: (id: string, data: UserJsonldUserWrite, params: RequestParams = {}) =>
      this.request<UserJsonldUserPrivateRead, void>({
        path: `/users/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a User resource.
     *
     * @tags User
     * @name ApiUsersUniqueIdstatsGet
     * @summary Get the user stat by unique ID
     * @request GET:/users/{uniqueId}/stats
     * @secure
     */
    apiUsersUniqueIdstatsGet: (uniqueId: string, params: RequestParams = {}) =>
      this.request<UserJsonldUserStatRead, void>({
        path: `/users/${uniqueId}/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  validateAddresses = {
    /**
     * @description Creates a AddressValidated resource.
     *
     * @tags AddressValidated
     * @name ApiValidateAddressesPost
     * @summary Creates a AddressValidated resource.
     * @request POST:/validate-addresses
     * @secure
     */
    apiValidateAddressesPost: (data: AddressValidatedJsonldAddressValidatedValidateWrite, params: RequestParams = {}) =>
      this.request<AddressValidatedJsonldAddressValidatedRead, void>({
        path: `/validate-addresses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Post an Address validated by Google API.
     *
     * @tags AddressValidated
     * @name ApiValidateAddressesResponseIdPost
     * @summary Post a validated Address
     * @request POST:/validate-addresses/{responseId}
     * @secure
     */
    apiValidateAddressesResponseIdPost: (
      data: AddressValidatedJsonldAddressValidatedPostWrite,
      responseId?: string,
      params: RequestParams = {},
    ) =>
      this.request<AddressValidatedAddressJsonldAddressRead, void>({
        path: `/validate-addresses/${responseId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
